// Rollen-tabel per type (film_av + festival), gegenereerd uit:
//   seed-migraties 00012/00015/00016/00017/00019 (basis + aliases + dep)
//   00013/00018 (omschrijvingen)
//   doc 6 col D (bullets, alleen Film/AV)
// AUTO-GEGENEREERD door scripts/genereer_rollen.py. Niet handmatig wijzigen.
// Vorm: { dep, rol, niveaus, aliases, omschrijving, bullets, volgorde }.

export const rollenFilmAv = [
  {
    "dep": "Animatie",
    "rol": "Puppet maintanance (stopmotion animatie)",
    "niveaus": [
      "A",
      "B",
      "C"
    ],
    "aliases": [],
    "omschrijving": "Onderhoudt en verzorgt de poppen op verzoek van de pupppet builders of productie. Ontwikkelt eigen tools om het onderhoudsproces beter en efficiënter te maken. Ideeën worden veelal aangedragen door specialisten vanuit het eigen departement. Afbreukrisico omdat eventuele gevolgen van verkeerd handelen zijn direct zichtbaar en moeten direct opgelost worden om verlies van productietijd en geld te minimaliseren.",
    "bullets": [
      "Onderhoudt en verzorgt de poppen op verzoek van de pupppet builders of productie",
      "Ontwikkelt eigen tools om het onderhoudsproces beter en efficiënter te maken",
      "Ideeën worden veelal aangedragen door specialisten vanuit het eigen departement",
      "Eventuele gevolgen van verkeerd handelen zijn direct zichtbaar en moeten direct opgelost worden om verlies van productietijd en geld te minimaliseren"
    ],
    "volgorde": 10
  },
  {
    "dep": "Animatie",
    "rol": "Animator 2D / 3D",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Werkt aan de hand van storyboards om geanimeerde scènes te creëren. Animeert beweging en uitvoering, ontwikkelt, beweegt en verplaatst de objecten waaraan wordt gewerkt. Draagt zorg voor de best mogelijke en passende beweging binnen de scène. Voert specialistische vakinhoudelijke werkzaamheden voor het departement uit ten behoeve van het primaire werkproces, signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team.",
    "bullets": [
      "Werkt aan de hand van storyboards om geanimeerde scènes te creëren",
      "Animeert beweging en uitvoering, ontwikkelt, beweegt en verplaatst de objecten waaraan wordt gewerkt",
      "Draagt zorg voor de best mogelijke en passende beweging binnen de scène",
      "Voert specialistische vakinhoudelijke werkzaamheden voor het departement uit ten behoeve van het primaire werkproces",
      "Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team"
    ],
    "volgorde": 20
  },
  {
    "dep": "Animatie",
    "rol": "Concept Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Bedenkt en maakt visuele voorstellen, zoals (experimentele) schetsen van shots, sets en decors van belangrijke momenten in het verhaal die inzicht bieden als mogelijke eindresultaten voor regie, production design, camera en VFX/Postproductie. Werkt vanuit concrete richtlijnen gegeven door de Head of Department en vertaalt deze naar creatieve keuzes die tevens dienen als visuele gids voor de creatieve teams (Art, Kostuum, VFX en Hair & Make-up). Stuurt, indien aanwezig, assistenten aan door het werk te verdelen en inhoudelijke aanwijzingen en/of instructies te geven ten behoeve van het beoogde resultaat.",
    "bullets": [
      "Is verantwoordelijk voor de eerste studies, schetsten en ontwerpen om de beoogde sfeer, locaties, karakter en props in beeld te vangen",
      "Zet de eerste stappen in het definieren van een visuele visie van het eindproduct door creatief creërende werkzaamheden te verrichten die bepalend zijn voor het eindresultaat",
      "Voert werkzaamheden uit met ruimte voor eigen inzicht, binnen de kaders van de instructies en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen, maar ook met departementen erbuiten",
      "Werkzaamheden hebben consequenties voor alle andere departementen"
    ],
    "volgorde": 30
  },
  {
    "dep": "Animatie",
    "rol": "Lighting and Shading Artist (Rendering)",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Maakt gebruik van materialen, om belichting en schaduw op digitale beelden te creëren. Voert vakinhoudelijke uitvoerende werkzaamheden voor het departement uit ten behoeve van een ondersteunend werkproces, signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team.",
    "bullets": [
      "Maakt gebruik van materialen, om belichting en schaduw op digitale beelden te creëren",
      "Voert vakinhoudelijke uitvoerende werkzaamheden voor het departement uit ten behoeve van een ondersteunend werkproces",
      "Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team"
    ],
    "volgorde": 40
  },
  {
    "dep": "Animatie",
    "rol": "Modellers (3D)",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Bouwt de digitale of fysieke versies van alles wat in de animatie op het scherm te zien is. Vertaalt concept art, karakterontwerpen en omgevingsontwerpen in modellen die, nadat de rigger daar de skeletstructuur aan heeft toegevoegd, klaar zijn om geanimeerd te worden. Voert vakinhoudelijke uitvoerende werkzaamheden voor het departement uit ten behoeve van een ondersteunend werkproces, signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team.",
    "bullets": [
      "Bouwt de digitale of fysieke versies van alles wat in de animatie op het scherm te zien is",
      "Vertaalt concept art, karakterontwerpen en omgevingsontwerpen in modellen die klaar zijn om geanimeerd te worden",
      "Begint nadat de rigger skeletstructuren aan heeft toegevoegd",
      "Voert vakinhoudelijke uitvoerende werkzaamheden voor het departement uit ten behoeve van een ondersteunend werkproces",
      "Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team"
    ],
    "volgorde": 50
  },
  {
    "dep": "Animatie",
    "rol": "Previz/Layout Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Werkt storyboards uit naar lay-outs en shotindelingen. Bepaalt, samen met de Regisseurs en productieontwerpers, de opzet van de set, de schaal, locaties voor scènes, camerastandpunten en bewegingen. Vertaalt animatics naar een overzichtelijk document dat het proces van visualisatie toont  voordat scènes worden gemaakt. Voert werkzaamheden uit met ruimte voor eigen inzicht, binnen de kaders van duidelijke instructies en volgens een gestructureerde aanpak.",
    "bullets": [
      "Werkt storyboards uit naar lay-outs en shotindelingen",
      "Bepaalt, samen met de Regisseurs en productieontwerpers, de opzet van de set, de schaal, locaties voor scènes, camerastandpunten en bewegingen",
      "Vertaalt animatics naar een overzichtelijk document dat het proces van visualisatie toont  voordat scènes worden gemaakt",
      "Voert werkzaamheden uit met ruimte voor eigen inzicht, binnen de kaders van duidelijke instructies en volgens een gestructureerde aanpak"
    ],
    "volgorde": 60
  },
  {
    "dep": "Animatie",
    "rol": "Puppet Builders (stopmotion)",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Bouwt de poppen voor stopmotion animatie naar ontwerp van de Regisseur of Character Designer. Voert vakinhoudelijke uitvoerende werkzaamheden voor het departement uit ten behoeve van een ondersteunend werkproces, signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team en daarbuiten, waaronder de gebruikers van sets (Animatoren), de Animation Director en de Regisseur.",
    "bullets": [
      "Bouwt de poppen voor stopmotion animatie",
      "Creëert binnen het ontwerp van de Regisseur of Character Designer",
      "Voert vakinhoudelijke uitvoerende werkzaamheden voor het departement uit ten behoeve van een ondersteunend werkproces",
      "Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team en daarbuiten, waaronder de gebruikers van sets (Animatoren), de Animation Director en de Regisseur"
    ],
    "volgorde": 70
  },
  {
    "dep": "Animatie",
    "rol": "Render Wrangler (Technical resource administrator)",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Monitort de computers om te zorgen dat alles goed gaat voor de (input/output) van data over verschillende bestandssystemen. Zorgt dat alles goed verloopt aan de rendering kant van de animatie pipeline. Voert vakinhoudelijke uitvoerende werkzaamheden voor het departement uit ten behoeve van een ondersteunend werkproces, signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team.",
    "bullets": [
      "Monitort de computers om te zorgen dat alles goed gaat voor de (input/output) van data over verschillende bestandssystemen",
      "Zorgt dat alles goed verloopt aan de rendering kant van de animatie pipeline",
      "Voert vakinhoudelijke uitvoerende werkzaamheden voor het departement uit ten behoeve van een ondersteunend werkproces",
      "Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team"
    ],
    "volgorde": 80
  },
  {
    "dep": "Animatie",
    "rol": "Rigger",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Maakt een 2D en/of 3D-rig (skeletstructuur) voor een 2D of 3D model dat bepaalt hoe een karakter of object kan bewegen en dus kan worden geanimeerd. Voert specialistische vakinhoudelijke uitvoerende werkzaamheden voor het departement uit ten behoeve van een ondersteunend werkproces, signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn vooral, maar niet uitsluitend, gericht op het ophalen en uitwisselen van informatie binnen eigen team.",
    "bullets": [
      "Maakt een 2D en/of 3D-rig (skeletstructuur) voor een 2D of 3D model",
      "Bepaalt hoe een karakter of object kan bewegen en dus kan worden geanimeerd",
      "Voert vakinhoudelijke uitvoerende werkzaamheden voor het departement uit ten behoeve van een ondersteunend werkproces",
      "Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen",
      "Contacten zijn vooral, maar niet uitsluitend, gericht op het ophalen en uitwisselen van informatie binnen eigen team"
    ],
    "volgorde": 90
  },
  {
    "dep": "Animatie",
    "rol": "Set Dressers (Stopmotion Animatie)",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Bouwt de digitale of fysieke versies van alles wat in de animatie op het scherm te zien is. Vertaalt de gemaakte setdesigns en omgevingsontwerpen in modellen die, nadat de rigger daar de skeletstructuur aan heeft toegevoegd, klaar zijn om geanimeerd te worden. Voert vakinhoudelijke uitvoerende werkzaamheden voor het departement uit ten behoeve van een ondersteunend werkproces, signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team.",
    "bullets": [
      "Bouwt en construeert de tafels/werkplaatsen waarop de stopmotion sets geplaatst worden",
      "Voert vakinhoudelijke uitvoerende werkzaamheden uit op basis van het ontwerp van set designer, ten behoeve van een ondersteunend werkproces",
      "Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team"
    ],
    "volgorde": 100
  },
  {
    "dep": "Animatie",
    "rol": "Sets en Props builder (Stop Motion Animatie)",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Bouwt en construeert de tafels/werkplaatsen waarop de stopmotion sets geplaatst worden. Voert vakinhoudelijke uitvoerende werkzaamheden uit op basis van het ontwerp van set designer, ten behoeve van een ondersteunend werkproces. Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team.",
    "bullets": [],
    "volgorde": 110
  },
  {
    "dep": "Animatie",
    "rol": "Texture Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Creëert kleuren, texturen en materialen om de werelden en personages te bouwen voor alles wat je ziet in de uiteindelijke animatie. Voert vakinhoudelijke uitvoerende werkzaamheden voor het departement uit ten behoeve van een ondersteunend werkproces, signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team.",
    "bullets": [
      "Creëert de kleuren, texturen en materialen om de werelden en personages te bouwen",
      "Voert vakinhoudelijke uitvoerende werkzaamheden voor het departement uit ten behoeve van een ondersteunend werkproces",
      "Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team"
    ],
    "volgorde": 120
  },
  {
    "dep": "Animatie",
    "rol": "Art Director",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het uitvoeren van de door de Producton Designer bepaalde stijl t.b.v. van het beoogde resultaat. Regelt inhoudelijke, organisatorische en budgettaire randvoorwaarden in. Is verantwoordelijk voor de constructie en ontwerp van de sets, binnen richtlijnen van en in dialoog met regie, production design en camera en stelt continue bij. Doet creatieve voorstellen binnen het eigen departement en/of richting regie en production design. Sluit andere specialisten van het eigen en andere vakgebieden binnen het eigen departement en andere departementen aan bij de uitvoering van het eigen werk. Stuurt assistenten aan door werk te coördineren, te verdelen en inhoudelijke aanwijzingen te geven.",
    "bullets": [
      "Bepaalt, in overleg met Regisseur, de visuele stijl en look voor decors, karakters en props",
      "Stuurt het art team aan en voorziet hen van creatieve en technische input",
      "Stemt stijl- en ontwerpvraagstukken af met de Regisseur, Production Designer (en Animation Director)",
      "Ziet toe op uniformiteit in het design binnen de gehele productie",
      "Werkt zelfstandig binnen de kaders van de opdracht, vanuit specialistische kennis",
      "Heeft een grote invloed op het eindresultaat van personages en omgevingen",
      "Maakt creatieve keuzes om problemen op te lossen, vanuit eigen expertise",
      "Stemt departement overstijgend af met Heads of Department (HoD's). Die contacten zijn inhoudelijk creatief en sturend en beïnvloedend van aard op de totale productie"
    ],
    "volgorde": 130
  },
  {
    "dep": "Animatie",
    "rol": "Character Designer",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Ontwerpt schetsen van karakters in 2D of 3D of zet deze over van 2D naar 3D. Maakt vormgevingkeuzes met oog op de “animeerbaarheid” van het ontwerp, communiceert en vult de persoonlijkheid van de karakters in door het ontwerpen van poses en expression sheets. \nHeeft grote invloed op de het eindresultaat en geeft specifieke invulling aan de (conceptuele) vormgeving van de karakters vanuit diepgaande specialistische kennis, vaardigheden en creativiteit. Werkt samen met de (Art) Director en (her-)ontwerpt ten behoeve de animatieproductie.",
    "bullets": [
      "Ontwerpt schetsen van karakters in 2D of 3D of zet deze over van 2D naar 3D",
      "Maakt vormgevingkeuzes met oog op de “animeerbaarheid” van het ontwerp",
      "Communiceert en vult de persoonlijkheid van de karakters in door het ontwerpen van poses en expression sheets",
      "Heeft grote invloed op de het eindresultaat",
      "Geeft specifieke invulling aan de (conceptuele) vormgeving van de karakters vanuit specialistische kennis, vaardigheden en creativiteit",
      "Werkt samen met de (Art) Director en (her-)ontwerpt ten behoeve de animatieproductie"
    ],
    "volgorde": 140
  },
  {
    "dep": "Animatie",
    "rol": "Compositor",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Voert specialistische werkzaamheden uit ter verbetering van bewegende beelden en geeft advies hierover. Analyseert en brengt bestaande materialen samen met (technische) oplossingen tot het gewenste eindresultaat. Het kan gaan om het samenvoegen van beeldlagen en/of het toepassen van technieken als maskeren. Ontvangt kaders en verwachtingen ten aanzien van het beoogde eindresultaat vanuit het Head of Department (HoD). Stemt departement overstijgend af met andere specialisten en andere Heads of Department (HoD). Kan programmeren en/of scripten om analyses en berekeningen te standaardiseren. Heeft inhoudelijk kennis van aanverwante departementen, waaronder photography en licht.",
    "bullets": [
      "Analyseert en brengt bestaande materialen samen met (technische en creatieve ) oplossingen tot het gewenste eindresultaat",
      "Combineert verschillende beeldlagen, animaties, VFX en achtergronden tot één geheel",
      "Past kleurcorrecties, licht- en schaduweffecten en retouches toe",
      "Ontvangt kaders en verwachtingen vanuit het Head of Department (HoD)",
      "Voert specialistische werkzaamheden uit ter verbetering van bewegende beelden en geeft advies hierover",
      "Werkt nauw samen met render, VFX en animation teams om shots technisch en visueel samen te brengen",
      "Signaleert technische issues en lost deze op binnen de compositing-software",
      "kan programmeren en/of scripten om analyses en berekeningen te standaardiseren",
      "Heeft inhoudelijk kennis van aanverwante departementen, waaronder photography en licht",
      "Stemt departement overstijgend af met andere specialisten en andere Heads of Department (HoD)"
    ],
    "volgorde": 150
  },
  {
    "dep": "Animatie",
    "rol": "Director of Photography en Lay Out Artist (2D en 3 D)",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Draagt zorg voor het ontwerpen, vastleggen en uitvoeren van de cameravoering voor stop-motion shots. Draagt zorg voor technisch optimale opnamekwaliteit zoals focus, belichting en compositie. Stelt een camera- en stage-setup en shotplanning op en ziet samen met de Regisseur toe op de consistentie van de visuele stijl. Levert een inhoudelijke, creatieve bijdrage op basis van specialistische kennis en ervaring, ten behoeve van het beoogde eindresultaat. De werkzaamheden hebben invloed op andere departementen en activiteiten worden afgestemd op de gehele productie. Heeft diverse interne en externe contacten die sturend en beïnvloedend zijn op het resultaat van  de productie.",
    "bullets": [
      "Bepaalt en voert belichting, camera-instellingen en kadering uit voor stop-motion shots",
      "Draagt zorg voor technisch optimale opnamekwaliteit (focus, belichting, compositie)",
      "Ziet samen met de Regisseur toe op de consistentie van de visuele stijl",
      "Werkt samen aan shotplanning, camera- en stage-setup",
      "Levert een inhoudelijke, creatieve bijdrage op basis van specialistische kennis en ervaring, ten behoeve van het beoogde eindresultaat",
      "Heeft invloed op andere departementen - activiteiten worden afgestemd op de gehele productie",
      "Heeft diverse interne en externe contacten die sturend en beïnvloedend zijn op het resultaat van  de productie"
    ],
    "volgorde": 160
  },
  {
    "dep": "Animatie",
    "rol": "Editor",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Smeedt alle opgenomen en aangeleverde beelden, dialogen en geluiden samen tot de exacte lengte en definitieve volgorde van de scenes. Verricht diepgaande specialistische werkzaamheden op zowel technisch als creatief vlak ten aanzien van beeld en werkt binnen de kaders van Producent en Regisseur, ten behoeve van het beoogde eindresultaat. Maakt creatieve keuzes bij het oplossen van problemen die mogelijk consequenties hebben voor de vertelling van het verhaal, de uitwerking daarvan in storyboard en andere departementen. Signaleert technische en inhoudelijke issues en stemt aanpassingen af binnen het team. Levert diverse editversies op voor feedbackrondes en verwerkt input van de Regisseur, Storyboarder en animatieafdeling tot een samenhangend verhaalritme. Heeft diverse contacten die sturend en bëinvloedend zijn op het resultaat van de productie.",
    "bullets": [
      "Smeedt alle opgenomen en aangeleverde beelden, dialogen en geluiden samen tot de exacte lengte en definitieve volgorde van de scenes",
      "Verricht diepgaande specialistische werkzaamheden op zowel technisch als creatief vlak ten aanzien van beeld",
      "Werkt binnen kaders van Producent en Regisseur ten behoeve van het beoogde eindresultaat",
      "Maakt creatieve keuzes bij het oplossen van problemen die mogelijk consequenties hebben voor de vertelling van het verhaal, de uitwerking daarvan in storyboard en andere departementen",
      "Signaleert technische en inhoudelijke issues en stemt aanpassingen af binnen het team",
      "Levert editversies op voor feedbackrondes",
      "Verwerkt input van Regisseur, Storyboarder en animatieafdeling tot een samenhangend verhaalritme",
      "Heeft diverse contacten die sturend en bëinvloedend zijn op het resultaat van de productie"
    ],
    "volgorde": 170
  },
  {
    "dep": "Animatie",
    "rol": "Lead Animator",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Animeert modellen en poppen per frame om de actie in het project te vertellen. Acteert door middel van het animeren (beeld-voor-beeld bewegen of tekenen) van dieren, objecten, karakters/modellen/poppen en brengt daarmee de juiste emotie van het karakter over in de betreffende scène. Animeert complexe sleutelscènes en fungeert als voorbeeld voor het animatieteam. Geeft begeleiding en kwaliteitsfeedback aan junior/medior animators en controleert de continuïteit in personagebeweging en timing binnen de productie. Werkt zelfstandig binnen de kaders van de opdracht, waarbij afstemming benodigd is die diepgaand specialistisch van aard is en een informerend en beïnvloedend karakter heeft. Ondersteunt Animation Director bij verdeling van taken, maakt creatieve keuzes bij het oplossen van problemen en stemt deze af met de Animation Director/supervisor.",
    "bullets": [
      "Animeert modellen en poppen per frame om de actie in het project te vertellen",
      "Acteert d.m.v. het animeren (beeld-voor-beeld bewegen of tekenen) van dieren, objecten, karakters/modellen/poppen en brengt daarmee de juiste emotie van het karakter over in de betreffende scène",
      "Animeert complexe sleutelscènes, fungeert als voorbeeld voor het animatieteam",
      "Geeft begeleiding en kwaliteitsfeedback aan junior/medior animators",
      "Controleert de continuïteit in personagebeweging en timing binnen de productie",
      "Werkt zelfstandig binnen de kaders van de opdracht, waarbij afstemming benodigd is die specialistisch van aard is en een informerend en beïnvloedend karakter heeft",
      "Ondersteunt Animation Director bij verdeling van taken",
      "Maakt creatieve keuzes en lost moeilijke animatieproblemen op samen met de Animation Director/supervisor"
    ],
    "volgorde": 180
  },
  {
    "dep": "Animatie",
    "rol": "Lead Storyboarder",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Bepaalt samen met de Regisseur de visuele vertaling van het script. Stuurt een specialistisch storyboard-team aan  en coördineert de verdeling van scenes. Bewaakt de consistentie in stijl, timing en logica binnen storyboards. Zet, in overleg met de Regisseur en Editor, het verhaal en de beeldtaal in elkaar, neemt revisies door met team en verwerkt feedback in nieuwe storyboardversies. Verricht diepgaand specialistische werkzaamheden op zowel technisch als creatief vlak en werkt binnen de kaders van Producent en Regisseur, ten behoeve van het beoogde eindresultaat. Maakt creatieve keuzes bij het oplossen van problemen die mogelijk consequenties hebben voor de vertelling van het verhaal en andere departementen. Signaleert technische en inhoudelijke issues en stemt aanpassingen af binnen het team. Heeft diverse contacten die sturend en bëinvloedend zijn op het eindresultaat van de productie.",
    "bullets": [
      "Stuurt een specialistisch storyboard-team aan; coördineert verdeling van scènes",
      "Bewaakt stijlconsistentie, timing en logica binnen storyboards",
      "Zet (in overleg met regisseur en editor) verhaal ritmisch en en de beeldtaal in elkaar",
      "Neemt revisies door met team en verwerkt feedback in nieuwe storyboardversies",
      "Verricht specialistische werkzaamheden op zowel technisch als creatief vlak",
      "Werkt binnen de kaders van Producent en Regisseur, ten behoeve van het beoogde eindresultaat",
      "Maakt creatieve keuzes bij het oplossen van problemen die mogelijk consequenties hebben voor de vertelling van het verhaal en andere departementen",
      "Signaleert technische en inhoudelijke issues en stemt aanpassingen af binnen het team",
      "Heeft diverse contacten die sturend en bëinvloedend zijn op het eindresultaat van de productie"
    ],
    "volgorde": 190
  },
  {
    "dep": "Animatie",
    "rol": "Production Coördinator",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Regelt praktische details zoals callsheets, transport, communicatie, assets tussen afdelingen. Houdt administratie en bestanden up-to-date en distribueert de benodigde middelen en illustraties naar de relevante afdelingen. Overziet de dagelijkse gang van zaken in een specifiek departement en zorgt dat iedereen over de informatie beschikt die nodig is om effectief te werken. Verricht uitvoerende werkzaamheden in een ondersteunend werkproces. Is aanspreekpunt voor vragen over logistiek, deadlines en communicatie tussen teams en stemt departement overstijgend af met andere specialisten, o.a. met de Postproduction Supervisor.",
    "bullets": [
      "Regelt praktische details: callsheets, transport, communicatie, assets tussen afdelingen",
      "Draagt zorg voor het up-to-date houden van administratie en bestanden",
      "Distribueert de benodigde middelen en illustraties naar de relevante afdelingen",
      "Overziet de dagelijkse gang van zaken in een specifiek departement en zorgt dat iedereen over de informatie beschikt die nodig is om effectief te werken",
      "Verricht uitvoerende werkzaamheden in een ondersteunend werkproces",
      "Is aanspreekpunt voor vragen over logistiek, deadlines en communicatie tussen teams",
      "Stemt departement overstijgend af met andere specialisten, o.a. met de Postproduction Supervisor"
    ],
    "volgorde": 200
  },
  {
    "dep": "Animatie",
    "rol": "Production Manager",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Handelt naar de beslissingen die zijn genomen door de Line Producer. Maakt concrete planningen, bewaakt milestones en verdeelt taken. Monitort uren, budgetten en personeel- of materiaalplanning. Signaleert bottlenecks in werkstromen en schakelt Productieassistenten in.\nDraagt verantwoordelijkheid voor de dagelijkse gang van zaken in productie, speelt zelfstandig in op (on)voorbereide veranderende omstandigheden binnen gegeven kaders en weet vanuit eigen vakkennis wat daarvoor nodig is. Stemt departement overstijgend af met andere specialisten en stuurt een team van Productiecoördinatoren aan.",
    "bullets": [
      "Handelt naar de beslissingen die zijn genomen door de Line Producer",
      "Maakt concrete planningen, bewaakt milestones en verdeelt taken",
      "Signaleert bottlenecks in werkstromen en schakelt Productieassistenten in",
      "Monitort uren, budgetten en personeel- of materiaalplanning",
      "Draagt verantwoordelijkheid voor de dagelijkse gang van zaken in productie",
      "Speelt zelfstandig in op (on)voorbereide veranderende omstandigheden binnen gegeven kaders en weet vanuit eigen vakkennis wat daarvoor nodig is",
      "Stemt departement overstijgend af met andere specialisten",
      "Stuurt een team van Productiecoördinatoren aan"
    ],
    "volgorde": 210
  },
  {
    "dep": "Animatie",
    "rol": "Prop Designer",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Ontwerpt, visualseert en geeft de props vorm binnen de opgezette visuele stijl. Beheert en onderhoudt materialen, maakt technische werktekeningen en draagt zorg voor schaal, stevigheid en repliceerbaarheid van decors en props voor opname. Werkt zelfstandig binnen de kaders van de opdracht, waarbij afstemming benodigd is die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft. Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden, zoals het aanpassen van sets en props tijdens stop-motion productie.",
    "bullets": [
      "Ontwerpt, visualseert en geeft de props vorm binnen de opgezette visuele stijl",
      "Beheert en onderhoudt materialen, maakt technische werktekeningen",
      "Draagt zorg voor schaal, stevigheid en repliceerbaarheid van decors en props voor opname",
      "Werkt zelfstandig binnen de kaders van de opdracht, waarbij afstemming benodigd is die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft",
      "Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden",
      "Past sets en props aan indien nodig tijdens stop-motion productie"
    ],
    "volgorde": 220
  },
  {
    "dep": "Animatie",
    "rol": "Set Designer",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Ontwerpt, visualseert en geeft de sets vorm binnen de opgezette visuele stijl. Beheert en onderhoudt materialen, maakt technische werktekeningen en draagt zorg voor schaal, stevigheid en repliceerbaarheid van decors en props voor opname. Werkt zelfstandig binnen de kaders van de opdracht, waarbij afstemming benodigd is die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft. Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden, zoals het aanpassen van sets en props tijdens stop-motion productie.",
    "bullets": [
      "Ontwerpt, visualseert en geeft de sets vorm binnen de opgezette visuele stijl",
      "Beheert en onderhoudt materialen, maakt technische werktekeningen",
      "Draagt zorg voor schaal, stevigheid en repliceerbaarheid van decors en props voor opname",
      "Werkt zelfstandig binnen de kaders van de opdracht, waarbij afstemming benodigd is die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft",
      "Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden",
      "Past sets en props aan indien nodig tijdens stop-motion productie"
    ],
    "volgorde": 230
  },
  {
    "dep": "Animatie",
    "rol": "Storyboard artist",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Maakt duidelijke tekeningen en/of digitale schetsen van scènes ter visualisatie van het script. Visualiseert actie, emotie, kadering en staging van van ieder shot ten behoeve van heldere communicatie in de voorbereidingen van de productie. Werkt met de Regisseur, Editor en Director of Photography (DOP) samen om timing en cameravoering vast te leggen. Werkt zelfstandig binnen de kaders van de opdracht en het beoogde eindresultaat, waarbij afstemming benodigd is die specialistisch van aard is en een informerend en een beïnvloedend karakter heeft. Past storyboards aan op basis van inhoudelijke feedback en voortschrijdend inzicht en maakt creatieve keuzes bij het oplossen van problemen die mogelijk consequenties hebben voor de vertelling van het verhaal en andere departementen.",
    "bullets": [
      "Maakt duidelijke visuele en alternatieve vertalingen van scriptscènes (shot voor shot)",
      "Visualiseert actie, emotie, kadering en staging van scènes binnen de animatie",
      "Werkt samen met regisseur, editor en DoP om timing en cameravoering vast te leggen",
      "Werkt zelfstandig binnen de kaders van de opdracht en het beoogde eindresultaat, waarbij afstemming benodigd is die specialistisch van aard is en een informerend en een beïnvloedend karakter heeft",
      "Past storyboards aan op basis van inhoudelijke feedback en voortschrijdend inzicht",
      "Maakt creatieve keuzes bij het oplossen van problemen die mogelijk consequenties hebben voor de vertelling van het verhaal en andere departementen"
    ],
    "volgorde": 240
  },
  {
    "dep": "Animatie",
    "rol": "Character Animator Junior",
    "niveaus": [
      "G"
    ],
    "aliases": [],
    "omschrijving": "Werkt aan de hand van storyboards om geanimeerde scènes te creëren. Animeert beweging en uitvoering, ontwikkelt, beweegt en verplaatst de objecten waaraan wordt gewerkt. Draagt zorg voor de best mogelijke en passende beweging binnen de scène. Voert specialistische vakinhoudelijke werkzaamheden voor het departement uit ten behoeve van het primaire werkproces, signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team.",
    "bullets": [
      "Creëert en animeert personages o.b.v. de creatieve briefing en storyboard",
      "Animeert characters en brengt emoties, expressies en timing/bewegingen overtuigend over",
      "Werkt vanuit storyboards en/of lay-outs,",
      "Voert aanpassingen door o.b.v. feedback van Regisseur, Animation Director/Animation Supervisor (en storyrevisies)",
      "Neemt deel aan animatiedailies",
      "Bewaakt stijl en continuïteit binnen sequenties en shots"
    ],
    "volgorde": 250
  },
  {
    "dep": "Animatie",
    "rol": "(Post)production Supervisor",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Fungeert vanuit de Producent als eerste aanspreekpunt voor de (post)productie. Beheert een deelbudget van een grote productie en maakt afspraken over de invulling daarvan met stakeholders binnen de postproductiefase. Overziet meerdere planningen en integreert wensen en consequenties voor departementen in de postproductie in het eigen aandachtsgebied. Signaleert knelpunten daarbinnen, doet voorstellen om die op te lossen en bespreekt die met de Producent. Heeft contact met onder andere de Producent en regie, deze contacten zijn veelal zakelijk en beïnvloedend van aard. De Post-production manager heeft voor en tijdens de draaiperiode contact met productie in verband met de workflow van de postproductie/VFX.",
    "bullets": [
      "Beheert planning en deelbudget voor postproductie (editing, VFX, audio, grading)",
      "Plant, bewaakt en optimaliseert het postproductieproces in samenspraak met producent",
      "Fungeert vanuit de Producent als eerste aanspreekpunt voor de postproductie",
      "Signaleert knelpunten in de workflow, doet voorstellen en coördineert oplossingen",
      "Heeft contact met o.a. de Producent en regie, t.b.v. afstemming en uitwisseling, met een beïnvloedende aard"
    ],
    "volgorde": 260
  },
  {
    "dep": "Animatie",
    "rol": "All supervisors ( Layout, lighting -each departement)",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Overziet het werk voor een specifiek departement in de productie zoals lay-out, lighting en rendering, layout, animatie, compositing, VFX etc. Maakt planningen en bewaakt deadlines en stuurt een team aan op creatief inhoudelijk niveau. Signaleert knelpunten daarbinnen, doet voorstellen om die op te lossen en bespreekt die met de Producent of Line Producer. Rapporteert knelpunten en strategische keuzes aan de Producent of Regisseur. Contacten zijn veelal creatief en beïnvloedend van aard. Heeft gedurende preproductie en productie contact met het productie team in verband met de workflow en de haalbaarheid van de plannig. Werkt nauw samen met andere departementen.",
    "bullets": [
      "Stuurt de eigen afdeling functioneel aan (bijv. layout, lighting, compositing, rendering)",
      "Maakt planningen en bewaakt deadlines per team",
      "Signaleert knelpunten daarbinnen, doet voorstellen om die op te lossen en bespreekt die met de Producent of Line Producer",
      "Rapporteert knelpunten en strategische keuzes aan Producent of Regisseur",
      "Contacten zijn veelal creatief en beïnvloedend van aard",
      "Zorgt dat de output van de eigen afdeling aan kwaliteits- en timingseisen voldoet",
      "Lost probleemsituaties op binnen het eigen specialisme",
      "Werkt nauw samen met andere departementen"
    ],
    "volgorde": 270
  },
  {
    "dep": "Animatie",
    "rol": "Character Animator Senior",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Werkt aan de hand van storyboards om geanimeerde scènes te creëren. Animeert beweging en uitvoering, ontwikkelt, beweegt en verplaatst de objecten waaraan wordt gewerkt. Draagt zorg voor de best mogelijke en passende beweging binnen de scène. Voert specialistische vakinhoudelijke werkzaamheden voor het departement uit ten behoeve van het primaire werkproces, signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team.",
    "bullets": [
      "Acteert en animeert personages volgens de creatieve briefing en storyboard",
      "Maakt op basis van storyboard, previz en analyse een interpretatie van het karakter",
      "Creëert vertalingvoorstellen op basis van de wens en richtlijn van de productie en regie",
      "Animeert characters en brengt emoties, expressies en timing/bewegingen overtuigend over",
      "Bewaakt stijl en continuïteit binnen sequenties en shots",
      "Neemt deel aan animatiedailies, maakt aanpassingen op basis van feedback van de Regisseur, Animation Director/-Supervisor en storyrevisies",
      "Verricht adviserende en diepgaande, specialistische werkzaamheden",
      "Wisselt informatie uit binnen het eigen departement. Contacten zijn adviserend en  beïnvloedend van aard"
    ],
    "volgorde": 280
  },
  {
    "dep": "Animatie",
    "rol": "Animation Director",
    "niveaus": [
      "J"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor de creatieve visie tijdens het hele animatieproces en beoordeelt het werk van Animatoren. Zet de grote lijnen uit op het eigen werkgebied en anticipeert op externe ontwikkelingen. Geeft inhoudelijk advies aan de Regisseur. Contacten zijn diepgaand, adviserend en beïnvloedend en gericht op het eindproduct en/of geeft bepalende inhoudelijke en creatieve sturing aan een team met specialistische werkzaamheden. Stelt met de Line Producer het uitvoeringsplan op en draagt na akkoord zorg voor de realisatie van de eindresultaten. Heeft nauw contact met de Regisseur en het team over het eindproduct als de verschillende onderdelen van het eindproduct.",
    "bullets": [
      "Bepaalt, vaak op basis van input van de regisseur de creatieve/visuele visie en stijl van de animatieproductie (Style Guide)",
      "Stuurt specialisten binnen het animatieteam aan",
      "Bewaakt de consistentie in animatiestijl, karakterontwikkeling en emoties",
      "Beoordeelt de kwaliteit en creatieve richting van shots en sequences",
      "Geeft feedback op voice acting en animatics",
      "Monitort de voortgang en deadlines zoals weergegeven in het uitvoeringsplan",
      "Lost creatieve en productiegebonden knelpunten op in overleg met andere teamleden",
      "Werkt nauw samen met regisseur, producent, supervisors en andere departementen",
      "Contacten zijn diepgaand, adviserend en beïnvloedend en gericht op het eindproduct"
    ],
    "volgorde": 290
  },
  {
    "dep": "Animatie",
    "rol": "Line Producer",
    "niveaus": [
      "J",
      "K"
    ],
    "aliases": [],
    "omschrijving": "Beheert het volledige budget van een productie en maakt afspraken over de invulling daarvan met verschillende Heads of Department (HoD). Overziet lange termijn planningen en integreert zelfstandig wensen en consequenties voor departementen in de pre- en postproductie. Beoordeelt daarbij de haalbaarheid van en communiceert intensief daarover met de verschillende HoD. Doet verbetervoorstellen en levert input op het beleid ten aanzien van het beoogde eindresultaat. Signaleert afwijkingen, informeert en draagt zorg voor afstemming met producent. Stuurt een team met assistenten en Productieleiders aan, dat draagt zorg voor verdere concrete invulling van deelbudgetten en -planningen. Fungeert vanuit de productie als eerste aanspreekpunt voor de HoD.",
    "bullets": [
      "Bewaakt het (deel)budget binnen de productie",
      "Monitort werkbelasting en verdeelt middelen (geld, tijd, specialisten en assistenten) praktisch over de teams",
      "Overziet lange termijn planningen en integreert zelfstandig wensen en consequenties voor departementen in de pre- en postproductie",
      "Levert input op het beleid van de Producent",
      "Stelt detailplanningen op, verbetert processen en beoordeelt daarbij de haalbaarheid daarvan",
      "Communiceert intensief met verschillende Heads of Department (HoD),  signaleert afwijkingen, informeert en draagt zorg voor afstemming met Producent",
      "Stuurt een team van productie coördinatoren en Productiemanagers aan",
      "Is eerste aanspreekpunt voor dagelijkse productievragen"
    ],
    "volgorde": 300
  },
  {
    "dep": "Animatie",
    "rol": "Technical director",
    "niveaus": [
      "J",
      "K"
    ],
    "aliases": [],
    "omschrijving": "Komt met oplossingen op technisch gebied om de creatieve visie voor het project mogelijk te maken binnen de kaders van het vastgestelde budget en planning. Fungeert als eerste aanspreekpunt betreffende de technische workflow van een animatie of VFX project. Ontwerpt in-house tools, scripts en test software ter ondersteuning van de animatie en VFX crew om zo efficient mogelijk te kunnen werken. Stuurt technisch team aan en ondersteunt artists met technische vragen en draagt zorg voor de technische kwaliteitscontrole van animatiebestanden, rendering output en storage. Lost technische problemen op bij software, plugins en data-uitwisseling tussen afdelingen, signaleert knelpunten en doet voorstellen om die op te lossen. Wisselt informatie uit met de Production Manager en werkt samen met verschillende departementen.",
    "bullets": [
      "Richt de technische pipeline en werkprocessen (workflow) voor animatie en rendering in",
      "Werkt binnen de kaders van het vastgestelde budget en planning",
      "Fungeert als eerste aanspreekpunt betreffende de technische workflow van een animatie of VFX project",
      "Ontwikkelt in-house tools, scripts en test software ter optimalisatie van productieprocessen",
      "Stuurt technisch team aan en ondersteunt artists met technische vragen",
      "Draagt zorg voor de technische kwaliteitscontrole van animatiebestanden, rendering output en storage",
      "Lost technische problemen op bij software, plugins en data-uitwisseling tussen afdelingen",
      "Signaleert knelpunten en doet voorstellen om die op te lossen",
      "Wisselt informatie uit met de Production Manager en werkt samen met verschillende departementen"
    ],
    "volgorde": 310
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Art Department Runner (junior/ driver)",
    "niveaus": [
      "A",
      "B",
      "C"
    ],
    "aliases": [],
    "omschrijving": "Vervoert, monteert en repareert gehuurde of aangeschafte props, meubilair, kunst en materiaal. Beschikt over materialen en gereedschappen ten behoeve van transport en set op- en afbouw en heeft hier een brede kennis van. Draagt verantwoordelijkheid voor gehuurde transportwagens en inhoud, aankopen en voorschotten. Denkt mee binnen gestelde kaders over adhoc oplossingen en speelt in op (onvoorbereide) veranderende omstandigheden. Voert zelfstandig of in een teamondersteunende werkzaamheden uit op concreet verzoek en volgens duidelijke aanwijzingen, op basis van routine. Heeft contact met externe leveranciers en binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Vervoert en/of monteert rekwisieten, meubels, kunst en decorstukken",
      "Ondersteunt bij de opbouw en/of installatie van sets",
      "Voert zelfstandig of in een team ondersteunende werkzaamheden uit volgens instructie of routine",
      "Beschikt over gereedschap en ondersteunende transportmiddelen",
      "Heeft inzicht en materiaalkennis om adhoc oplossingen te kunnen voorstellen",
      "Heeft contact met externe leveranciers en binnen het eigen team voor afstemming en informatieuitwisseling"
    ],
    "volgorde": 10
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Ass. Art Department",
    "niveaus": [
      "A",
      "B",
      "C"
    ],
    "aliases": [],
    "omschrijving": "Ondersteunt bij het inrichten van een set en assisteert het productie art departement ten behoeve van het het werkproces. De werkzaamheden zijn volgens instructies. De contacten zijn binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Ondersteunt bij het inrichten van een set, assisteert het productie art departmen ten behoeve van het werkproces",
      "Voert uitvoerende taken uit volgens instructies",
      "Heeft contact binnen het eigen team voor afstemming en informatie-uitwisseling"
    ],
    "volgorde": 20
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Assistent kostuum",
    "niveaus": [
      "A",
      "B",
      "C"
    ],
    "aliases": [],
    "omschrijving": "Voert technische en praktische ondersteunende werkzaamheden binnen de kostuumafdeling uit op concreet verzoek en volgens de duidelijke aanwijzingen. Is actief op zowel kantoor, het atelier en op de set. Er is geen tot zeer weinig ruimte voor eigen prioritering van werkzaamheden. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Voert technische en praktische ondersteunende werkzaamheden uit op concreet verzoek van Kostuum Ontwerper",
      "Werkt volgens duidelijke aanwijzingen",
      "Is zowel actief op kantoor als atelier en set, binnen de kostuumafdeling",
      "Heeft vooral contact binnen het eigen team voor afstemming en informatie-uitwisseling"
    ],
    "volgorde": 30
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Assistent Rekwisiteur",
    "niveaus": [
      "A",
      "B",
      "C"
    ],
    "aliases": [],
    "omschrijving": "Verricht uitvoerende werkzaamheden op verzoek van de Rekwisiteur, zoals het organiseren, verzamelen of voorbereiden van materialen en meubels. Werkt volgens duidelijke aanwijzingen, voorschriften en praktische kennis. Ideeën worden aangedragen door specialisten vanuit het eigen departement. Eventuele gevolgen van verkeerd handelen zijn direct zichtbaar en ook direct op te lossen.",
    "bullets": [
      "Verricht uitvoerende werkzaamheden op verzoek van de Rekwisiteur voor de inkoop en inrichting van sets",
      "Voert werk uit volgens duidelijke aanwijzingen, voorschriften en praktische kennis",
      "Ontvangt ideeën en instructies van specialisten binnen het eigen departement",
      "Gevolgen van fouten zijn direct zichtbaar en kunnen meteen worden opgelost"
    ],
    "volgorde": 40
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Assistent Set Dresser",
    "niveaus": [
      "A",
      "B",
      "C"
    ],
    "aliases": [],
    "omschrijving": "Verricht uitvoerende werkzaamheden uit op verzoek van de (on) Set Dresser, zoals het omdressen van sets en het leveren van materialen ten behoeve van continuiteit. Ideeën worden aangedragen door specialisten vanuit het eigen departement. Eventuele gevolgen van verkeerd handelen zijn direct zichtbaar en ook direct op te lossen.",
    "bullets": [
      "Verricht uitvoerende werkzaamheden op verzoek van de setdresser, zoals het omdressen van sets en het leveren van materialen ten behoeve van continuïteit",
      "Ontvangt ideeën en instructies van specialisten binnen het eigen departement",
      "Gevolgen van fouten zijn direct zichtbaar en kunnen meteen worden opgelost"
    ],
    "volgorde": 50
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Naaister",
    "niveaus": [
      "A",
      "B",
      "C"
    ],
    "aliases": [],
    "omschrijving": "Naait kleding volgens patronen of voorbeeld, verstelt en werkt (details van) kledingstukken af. Voert ondersteunende werkzaamheden uit op concreet verzoek en volgens duidelijke aanwijzingen van specialisten vanuit eigen departement. Ideeën worden aangedragen door specialisten vanuit het eigen departement. Eventuele gevolgen van verkeerd handelen zijn direct zichtbaar en ook direct op te lossen.",
    "bullets": [
      "Naait kleding volgens patronen of voorbeeld, verstelt en werkt (details van) kledingstukken af",
      "Maakt aanpassingen naar aanleiding van een doorpas",
      "Voert werkzaamheden uit in eigen atelier of kostuumholding",
      "Verricht zelfstandig uitvoerende werkzaamheden op concreet verzoek van anderen",
      "Voert werk uit volgens duidelijke aanwijzingen, voorschriften en praktische kennis",
      "Kan, indien gewenst, bij een doorpas aanwezig zijn om maten op te nemen en/of af te passen",
      "Gevolgen van fouten zijn direct zichtbaar en kunnen meteen worden opgelost"
    ],
    "volgorde": 60
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Schilder",
    "niveaus": [
      "A"
    ],
    "aliases": [],
    "omschrijving": "Voert uitvoerende taken uit binnen een afgebakend werkgebied, zoals bijvoorbeeld het decor in een atelier of op de set schilderen of bijwerken. De werkzaamheden zijn volgens instructies en in overleg met de Art Director en Production Designer. Beschikt over kennis van materialen en historische kleuren en draagt voorbeelden en stalen aan. De contacten zijn binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Schildert het decor op de set, locatie, atelier of werkt schilderwerk bij",
      "Levert stalen en voorbeelden aan",
      "Beschikt over kennis van materialen en historische kleuren",
      "Verricht uitvoerende taken binnen een afgebakend werkgebied",
      "Werkt volgens gegeven instructies",
      "Heeft contact binnen het eigen team voor afstemming en informatie-uitwisseling"
    ],
    "volgorde": 70
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Swinggang lid",
    "niveaus": [
      "A",
      "B",
      "C"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het in- en uitruimen van de sets en het in goede staat achterlaten van de studio en locaties. Het betreft uitvoerende taken uit binnen een afgebakend werkgebied. De werkzaamheden zijn volgens instructies. De contacten zijn binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Ondersteunt met de opbouw, inrichting en afbouw van sets",
      "Zorgt ervoor dat studio en locaties in goede staat worden achtergelaten",
      "Voert uitvoerende taken uit binnen een afgebakend werkgebied",
      "Werkt volgens gegeven instructies",
      "Heeft contact binnen het eigen team voor afstemming en informatie-uitwisseling"
    ],
    "volgorde": 80
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Ager/Dyer (kostuum)",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Bewerkt de kostuums ten behoeve van het verloop in een productie - waaronder oud, vies en kapot maken, verven en manipuleren. Werkt zelfstandig binnen gegeven kaders, ten behoeve van een ondersteunend werkproces en ten aanzien van het beoogde eindresultaat. Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team.",
    "bullets": [
      "Bewerkt kostuums ten behoeve van het verloop in een productie  (bijv. oud, vies, kapot)",
      "Voert technieken uit zoals verven en manipuleren van stoffen",
      "Werkt binnen het kader van het production design aan het beoogde resultaat",
      "Signaleert problemen tijdens de uitvoering en meldt deze bij anderen",
      "Onderhoudt contact om informatie op te halen en uit te wisselen binnen het eigen team"
    ],
    "volgorde": 90
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Art Department Runner (senior)",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Vervoert, monteert en repareert gehuurde of aangeschafte props, meubilair, kunst en materiaal. Beschikt over materialen en gereedschappen ten behoeve van transport en set op- en afbouw en heeft hier een brede kennis van. Draagt verantwoordelijkheid voor gehuurde transportwagens en inhoud, aankopen en voorschotten. Denkt mee binnen gestelde kaders over adhoc oplossingen en speelt in op (onvoorbereide) veranderende omstandigheden. Voert zelfstandig of in een teamondersteunende werkzaamheden uit op concreet verzoek en volgens duidelijke aanwijzingen, op basis van routine. Heeft contact met externe leveranciers en binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Vervoert rekwisieten, meubels en decorstukken",
      "Ondersteunt bij de opbouw en installatie van sets",
      "Voert zelfstandig of in teamverband ondersteunende werkzaamheden uit volgens instructies",
      "Bezit en beheerst ondersteunend gereedschap (en transportmiddelen)",
      "Heeft basis ervaring in het rijden en laden van grote voertuigen (B-rijbewijs)",
      "Heeft contact met externe leveranciers en binnen het eigen team voor planning en informatie-uitwisseling"
    ],
    "volgorde": 100
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Coupeuse",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Ontwerpt naaipatronen voor kostuums op maat, maakt aanpassingen voor (bestaande) kledingstukken en adviseert over keuzes van stoffen en materialen. Voert zelfstandig ondersteunende werkzaamheden uit op concreet verzoek en volgens duidelijke aanwijzingen van specialisten vanuit eigen departement. Eventuele gevolgen van verkeerd handelen zijn direct zichtbaar en ook direct op te lossen.",
    "bullets": [
      "Tekent patronen, maakt zelfstandig (onderdelen van) kostuums, kleding en eventueel accessoires naar het idee van en in overleg met de Kostuumontwerper",
      "Verricht zelfstandig uitvoerende werkzaamheden op concreet verzoek van specialisten vanuit eigen departement",
      "Voert werk uit volgens duidelijke aanwijzingen, voorschriften en praktische kennis",
      "Kan, indien gewenst, bij een doorpas aanwezig zijn om maten op te nemen en/of af te passen",
      "Voert werkzaamheden uit in eigen of productie atelier",
      "Gevolgen van fouten zijn direct zichtbaar en kunnen direct worden opgelost"
    ],
    "volgorde": 110
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Decorateur / Decorschilder",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Vertaalt de creatieve visie van de Production Designer en Art Director naar praktische uitvoering. Bewaakt de kwaliteit en stijl van het schilderwerk en zorgt ervoor dat de deadlines en veiligheidsnormen worden gehaald. Coördineert en stuurt het schilderteam aan binnen het Art Departement. Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team.",
    "bullets": [
      "Vertaalt de creatieve visie van de Production Designer en Art Director naar praktische uitvoering",
      "Bewaakt de kwaliteit en stijl van het schilderwerk",
      "Zorgt ervoor dat de deadlines en veiligheidsnormen worden gehaald",
      "Plant, verdeelt en voert schilder- en afwerkingstaken uit voor decors, sets en rekwisieten",
      "Coördineert en stuurt het schilderteam aan binnen het Art Departement",
      "Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen",
      "Onderhoudt contact om informatie op te halen en uit te wisselen binnen het eigen team"
    ],
    "volgorde": 120
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Kostuum op set",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Kleedt cast en figuratie op de set. Beheert en onderhoudt de kostuums, bewaakt de continuïteit ervan en zorgt ervoor dat kostuums optimaal in beeld komen. Is op set de stem en aanspreekpunt van het kostuum departement en stuurt, indien aanwezig, assistenten aan door het werk te verdelen en inhoudelijke aanwijzingen en/of instructies te geven. Werkt zelfstandig binnen de door de Kostuumontwerper bepaalde stijl en kaders ten aanzien van het beoogde resultaat en speelt in op (onvoorbereide) veranderende omstandigheden.",
    "bullets": [
      "Kleedt cast en figuratie op de set",
      "Beheert, onderhoudt en bewaakt de continuïteit van de kostuums",
      "Zorgt ervoor dat kostuums optimaal in beeld komen",
      "Werkt zelfstandig binnen de door de Kostuumontwerper bepaalde stijl en kaders ten aanzien van het beoogde resultaat",
      "speelt in op (onvoorbereide) veranderende omstandigheden",
      "Onderhoudt contact om informatie op te halen en uit te wisselen binnen het eigen team"
    ],
    "volgorde": 130
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Kostuum Productie",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Draagt zorg voor verplaatsing kleding, accessoires en overige relevante benodigdheden van en naar de set, werkruimtes en winkels. Biedt ondersteuning ten behoeve van het werkproces en organisatie van het kostuumdepartement, signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team.",
    "bullets": [
      "Draagt zorg voor verplaatsing kleding, accessoires en overige relevante benodigdheden van en naar de set, werkruimtes en winkels",
      "Voert uitvoerende werkzaamheden uit ter ondersteuning van het werkproces en organisatie van het kostuumdepartement",
      "Signaleert problemen tijdens de uitvoering en meldt deze bij anderen",
      "Onderhoudt contact om informatie op te halen en uit te wisselen binnen het eigen team"
    ],
    "volgorde": 140
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Make-up Assistent",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Verzorgt de make-up van de acteurs en/of figuranten op de set. Onderhoudt nauw contact met de Make-up Artist, ten behoeve van een ondersteunend werkproces en werkt zelfstandig binnen gegeven kaders ten aanzien van het beoogde eindresultaat. Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen team.",
    "bullets": [
      "Verzorgt de make-up van de acteurs en/of figuranten op de set",
      "Werkt zelfstandig binnen gegeven kaders ten aanzien van het beoogde eindresultaat",
      "Voert vakinhoudelijke, uitvoerende werkzaamheden uit ter ondersteuning van het werkproces",
      "Signaleert problemen tijdens de uitvoering en meldt deze bij anderen",
      "Onderhoudt nauw contact met de Make-up Artist en uit te wisselt informatie uit binnen het eigen team"
    ],
    "volgorde": 150
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Setbouwer",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Bouwt sets en verricht overige uitvoerende werkzaamheden op verzoek van de Construction Manager. Ideeën worden aangedragen door specialisten vanuit het eigen departement. Eventuele gevolgen van verkeerd handelen zijn direct zichtbaar en ook direct op te lossen.",
    "bullets": [
      "Bouwt decors op basis van het design, op verzoek van de Construction Manager of Art Director",
      "Werkt in de werkplaats en op locatie en begeleidt soms de ombouw van sets",
      "Ontvangt ideeën en instructies van specialisten binnen het eigen departement",
      "Gevolgen van fouten zijn direct zichtbaar en kunnen meteen worden opgelost"
    ],
    "volgorde": 160
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "(On) Set dresser / Stand by props",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Beheert, onderhoudt en positioneert de (hand)props, bewaakt de continuïteit ervan en zorgt ervoor dat sets optimaal in beeld komen. Is op set de stem en aanspreekpunt van het art departement en stuurt, indien aanwezig, assistenten aan door het werk te verdelen en inhoudelijke aanwijzingen en/of instructies te geven. Werkt zelfstandig binnen de door de Production Designer bepaalde stijl en kaders ten aanzien van het beoogde resultaat en speelt in op (onvoorbereide) veranderende omstandigheden vanuit eigen vakkennis.",
    "bullets": [
      "Beheert, onderhoudt en positioneert (hand)props en bewaakt de continuïteit als standby props",
      "Zorgt als on-setdresser dat sets optimaal in beeld komen tijdens opnames",
      "Maakt creatieve en script-inhoudelijke aanpassingen tijdens de opnames",
      "Is op de set het aanspreekpunt en de stem van het Art Department",
      "Werkt zelfstandig binnen de stijl en kaders van de production designer ten aanzien van het beoogde resulaat",
      "Speelt in op (on)voorbereide veranderende omstandigheden met eigen vakkennis",
      "Heeft contact om informatie op te halen en uit te wisselen",
      "Stuurt assistenten aan (indien aanwezig) door werk te verdelen en instructies te geven"
    ],
    "volgorde": 170
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Assistent Art Director",
    "niveaus": [
      "F"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het uitvoeren van de door de Producton Designer bepaalde stijl t.b.v. van het beoogde resultaat. Regelt inhoudelijke, organisatorische en budgettaire randvoorwaarden in. Is verantwoordelijk voor de constructie en ontwerp van de sets, binnen richtlijnen van en in dialoog met regie, production design en camera en stelt continue bij. Doet creatieve voorstellen binnen het eigen departement en/of richting regie en production design. Sluit andere specialisten van het eigen en andere vakgebieden binnen het eigen departement en andere departementen aan bij de uitvoering van het eigen werk. Stuurt assistenten aan door werk te coördineren, te verdelen en inhoudelijke aanwijzingen te geven.",
    "bullets": [
      "Levert een bijdrage aan de uitvoering van creatieve ideeën van een Head of Department (HoD) of specialist",
      "Voert productionele werkzaamheden uit voor het eigen departement",
      "Assisteert inhoudelijk, technisch en praktisch binnen het eigen vakgebied",
      "Stemt voornamelijk af over het eigen werk tijdens het assisteren",
      "Signaleert problemen bij de uitvoering en kaart deze aan bij anderen om tot een oplossing te komen"
    ],
    "volgorde": 180
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Assistent Kostuumontwerper",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Analyseert het script en stelt op basis daarvan een plan op. Regelt inhoudelijke, organisatorische en budgettaire randvoorwaarden. Ontwerpt de look van de karakters en bepaalt zo de kostuums, binnen richtlijnen van en in dialoog met regie, production design en camera en stelt continue bij. Doet creatieve voorstellen binnen het eigen departement en/of richting regie, production design en camera. Draagt indien van toepassing vanuit het eigen vakgebied bij aan een optimaal comfortabel gevoel van acteurs. Sluit andere specialisten van het eigen en andere vakgebieden binnen het eigen departement en andere departementen aan bij de uitvoering van het eigen werk. Stuurt assistenten aan door werk te coördineren, te verdelen en inhoudelijke aanwijzingen te geven.",
    "bullets": [
      "Levert een bijdrage aan de creatieve ideeën van de kostuumontwerper",
      "Voert productionele werkzaamheden uit, zoals script-breakdowns en kostuumpassen",
      "Stemt het eigen werk af met anderen tijdens het assisteren",
      "Werkt praktisch en inhoudelijk binnen het eigen vakgebied",
      "Signaleert problemen bij de uitvoering en brengt deze onder de aandacht van anderen om op te lossen"
    ],
    "volgorde": 190
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Assistent Make-up en Hair/ Daily Artist on set",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Verzorgt tijdens de productieperiode make-up en haar van de cast en figuratie. Werkt zelfstandig op basis van duidelijke richtlijnen vanuit het eigen specialisme ten behoeve van het beoogde eindresultaat. Signaleert problemen tijdens de uitvoering en meldt deze bij anderen. Onderhoudt nauw contact met de Make-up Artist en wisselt informatie uit binnen het eigen team.",
    "bullets": [
      "Verzorgt tijdens de productieperiode make-up en haar van de cast en figuratie",
      "Werkt zelfstandig op basis van duidelijke richtlijnen vanuit het eigen specialisme ten behoeve van het beoogde eindresultaat",
      "Signaleert problemen tijdens de uitvoering en meldt deze bij anderen",
      "Onderhoudt nauw contact met de Make-up Artist en wisselt informatie uit binnen het eigen team"
    ],
    "volgorde": 200
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Concept Artist",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Bedenkt en maakt visuele voorstellen, zoals (experimentele) schetsen van shots, sets en decors van belangrijke momenten in het verhaal die inzicht bieden als mogelijke eindresultaten voor regie, production design, camera en VFX/Postproductie. Werkt vanuit concrete richtlijnen gegeven door de Head of Department en vertaalt deze naar creatieve keuzes die tevens dienen als visuele gids voor de creatieve teams (Art, Kostuum, VFX en Hair & Make-up). Stuurt, indien aanwezig, assistenten aan door het werk te verdelen en inhoudelijke aanwijzingen en/of instructies te geven ten behoeve van het beoogde resultaat.",
    "bullets": [
      "Bedenkt en maakt (experimentele) schetsen van shots, sets en decors",
      "Biedt inzichten als mogelijke eindresultaten voor zowel het eigen departement als regie, camera en VFX/Postproductie",
      "Werkt op basis van concrete richtlijnen van de HoD en vertaalt deze naar creatieve keuzes die tevens dienen als visuele gids voor de creatieve teams (Art, Kostuum, VFX en Hair & Make-up)",
      "Stuurt assistenten aan (indien aanwezig) door werk te verdelen en instructies te geven ten behoeve van het beoogde eindresultaat"
    ],
    "volgorde": 210
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Construction Manager",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Ontwerpt en ontwikkelt constructieve oplossingen voor de bouw van sets en decors in afstemming met de Production Designer. Adviseert op basis van technische tekeningen over geschikte materialen en bouwmethoden, afgestemd op ontwerp, budget en locatie. Stuurt de werkplaats en het bouwteam aan, bestelt materialen, bewaakt de kwaliteit en ziet toe op een veilige en efficiënte (op)bouw in studio of op locatie. Overziet een interne planning en budget en werkt zelfstandig binnen gegeven kaders ten aanzien van het beoogde resultaat. Wisselt continu informatie uit binnen het eigen departement voor afstemming en speelt in op (onvoorbereide) veranderende omstandigheden.",
    "bullets": [
      "Ontwerpt en ontwikkelt constructieve oplossingen voor de bouw van sets en decors in afstemming met de Production Designer",
      "Adviseert op basis van technische tekeningen over geschikte materialen en bouwmethoden, afgestemd op ontwerp, budget en locatie",
      "Stuurt de werkplaats en het bouwteam aan, bestelt materialen, bewaakt de kwaliteit en ziet toe op een veilige en efficiënte (op)bouw in studio of op locatie",
      "Maakt planningen en beheert het budget van de eigen afdeling",
      "Werkt zelfstandig binnen het gegeven kaders ten aanzien van het beoogde resultaat",
      "Speelt in op (on)voorbereide veranderende omstandigheden vanuit eigen vakkennis",
      "Heeft contact binnen het eigen departement voor informatie-uitwisseling"
    ],
    "volgorde": 220
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Coördinator productie Art Department",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Stelt samen met de Production Designer het budget op van de productie, verzorgt en beheert de financiële administratie en communiceert daarover met de Production Designer, Productieleider en Producent. Vraagt geldstromen aan, verdeelt en beheert deze. Zoekt crew bij elkaar en onderhandelt over contractuele voorwaarden binnen het Art Departement. Heeft kennis van budgettaire administratie, materialen en kosten. Fungeert als organisatorische spil tussen alle disciplines van het Art Department en het productieteam. Anticipeert op veranderingen en wisselende vragen gedurende de productie en draagt zorg voor een efficiënte communicatiestroom.",
    "bullets": [
      "Stelt samen met de Production Designer het budget op van de productie",
      "Verzorgt en beheert de financiële administratie en communiceert daarover met de Production Designer, Productieleider en Producent",
      "Vraagt geldstromen aan, verdeelt en beheert deze",
      "Zoekt crew bij elkaar en onderhandelt over contractuele voorwaarden binnen het Art Departement",
      "Heeft kennis van budgettaire administratie, materialen en kosten",
      "Heeft begrip van de research en het creatieve ontwikkelingsproces van het project",
      "Fungeert als organisatorische spil tussen alle disciplines van het Art Department en het productieteam",
      "Anticipeert op veranderingen en wisselende vragen gedurende de productie en draagt zorg voor een efficiënte communicatiestroom",
      "De financiële taken kunnen op grote producties worden uitgevoerd door een financial controller"
    ],
    "volgorde": 230
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Grafisch Ontwerper",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Bedenkt, ontwerpt en realiseert alle grafische elementen die in beeld komen variërend van posters, typografie en digitale interfaces tot grafische props die onderdeel zijn van de set. Werkt zelfstandig binnen de door de Production Designer bepaalde stijl en kaders ten aanzien van het beoogde resultaat. Houdt rekening met de technische uitvoering, zodat de grafische uitingen geschikt zijn voor gebruik tijdens de opname. Werkt nauw samen met de Art Director, Production Designer, Set Decorator en Prop Master voor afstemming en speelt in op (onvoorbereide) veranderende omstandigheden.",
    "bullets": [
      "Ontwerpt de grafische uitingen die nodig en zichtbaar zijn in een productie, zoals bijvoorbeeld verpakkingen, computerschermen of fictieve branding",
      "Werkt zelfstandig binnen de stijl en kaders van de production designer ten aanzien van het beoogde resulaat",
      "Speelt in op (on)voorbereide veranderende omstandigheden met eigen vakkennis",
      "Heeft contact binnen het eigen departement om informatie op te halen en uit te wisselen"
    ],
    "volgorde": 240
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Kapper",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Bedenkt en maakt naar eigen inzicht kapsels en pruiken voor cast en figuratie. Werkt zelfstandig binnen gegeven kaders ten aanzien van het beoogde eindresultaat, speelt in op (on)voorbereide veranderende omstandigheden en weet vanuit eigen vakkennis wat daarvoor nodig is. Contacten zijn gericht op het ophalen en uitwisselen van informatie en binnen eigen departement.",
    "bullets": [
      "Maakt kapsels en pruiken voor cast en figuratie",
      "Werkt zelfstandig binnen de gegeven kaders aan het beoogde eindresultaat",
      "Speelt flexibel in op (on)voorbereide, veranderende omstandigheden",
      "Weet op basis van eigen vakkennis wat nodig is in verschillende situaties",
      "Onderhoudt contact om informatie op te halen en uit te wisselen binnen het eigen departement"
    ],
    "volgorde": 250
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Key Hair en Make-up Artist",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Prepareert en draagt zorg voor make-up en haar van de cast en figuratie op basis van concrete richtlijnen ten aanzien van het beoogde resultaat en maakt daarvoor keuzes vanuit het eigen specialisme. Wordt betrokken bij het proces na de preproductiefase. Bewaakt gedurende de productiefase de continuïteit van creaties en resultaten over het eigen en het uitgevoerde werk van assistenten, mits aanwezig.",
    "bullets": [
      "Verdeelt taken en voert lastminute aanpassingen door",
      "Bereidt en verzorgt make-up en haar van cast en figuratie",
      "Ondersteunt bij de inventarisatie en inrichting van de make-up en haar ruimte",
      "Werkt zelfstandig op basis van duidelijke richtlijnen vanuit het eigen specialisme ten behoeve van het beoogde eindresultaat",
      "Signaleert problemen tijdens de uitvoering en meldt deze bij anderen",
      "Onderhoudt nauw contact met de Make-up Artist en wisselt informatie uit binnen het eigen team"
    ],
    "volgorde": 260
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Kostuum Supervisor",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Ziet toe op het functioneren van het kostuumdepartement in pre-productie en op de set. Bewaakt gedurende de productiefase de continuïteit van creaties en resultaten over het eigen en het uitgevoerde werk van assistenten. Stuurt, indien aanwezig, assistenten aan door het werk te verdelen en inhoudelijke aanwijzingen en/of instructies te geven ten behoeve van het beoogde resultaat.",
    "bullets": [
      "Ziet toe op het functioneren van het kostuumdepartement tijdens pre-productie en op de set",
      "Bewaakt tijdens de productiefase de continuïteit van kostuumcreaties en -resultaten",
      "Controleert zowel eigen werk als dat van eventuele assistenten op conformiteit met het beoogde resultaat van de productie",
      "Stuurt assistenten aan (indien aanwezig) door werk te verdelen en inhoudelijke instructies te geven ten behoeve van het beoogde eindresultaat"
    ],
    "volgorde": 270
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Props Master / Hand Props Master",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Regelt of maakt alle handprops en/of action props, die door acteurs in beeld worden gebruikt. Zorgt dat de rekwisieten tijdig beschikbaar zijn, functioneel werken en passen bij de stijl, periode en continuïteit van het script. Ziet toe op het beheer van de aantallen en de overdracht naar Set Prop Master of Set Dresser en werkt zelfstandig binnen de door de Production Designer bepaalde stijl en kaders ten aanzien van het beoogde resulaat. Werkt nauw samen met de regisseur, Production Designer, Art Director en On Set Dresser voor afstemming en speelt in op (onvoorbereide) veranderende omstandigheden.",
    "bullets": [
      "Regelt of maakt alle handprops en/of action props, die door acteurs in beeld worden gebruikt",
      "Zorgt dat de rekwisieten tijdig beschikbaar zijn, functioneel werken en passen bij de stijl, periode en continuïteit van het script",
      "Ziet toe op het beheer van de aantallen en de overdracht naar Set Prop Master of Set Dresser",
      "Werkt zelfstandig binnen de stijl en kaders van de production designer ten aanzien van het beoogde resulaat",
      "Speelt in op (on)voorbereide veranderende omstandigheden met eigen vakkennis",
      "Heeft contact binnen het eigen departement om informatie op te halen en uit te wisselen"
    ],
    "volgorde": 280
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Rekwisiteur",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Doet research, selecteert passende materialen en coördineert de uitvoering van een team, waaronder de Rekwisiteur en Hand Props Master. Is verantwoordelijk voor de inrichting, aankleding en afwerking van sets, waarbij de visuele stijl van de productie wordt vertaald naar meubels, accessoires en decoratieve elementen. Werkt nauw samen met de Production Designer en stemt af over creatieve voorstellen ten behoeve van het beoogde resultaat.",
    "bullets": [
      "Werkt zelfstandig binnen het kader van het production design en de set decorator",
      "Zoekt, koopt en beheert alle meubels en rekwisieten (props)",
      "Speelt flexibel in op veranderende (on)voorbereide omstandigheden",
      "Gebruikt eigen vakkennis om passende oplossingen te vinden",
      "Onderhoudt contact om informatie op te halen en uit te wisselen binnen het eigen departement"
    ],
    "volgorde": 290
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Set Ontwerper / schetser",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Ontwerpt de look & feel van (studio)decors en vertaalt de creatieve visie van de productie naar concrete ontwerpen. Maakt een artistiek concept en ontwikkelt technische tekeningen die als basis dienen voor de bouw en inrichting van de sets. Werkt nauw samen met de Production Designer en andere leden van het art team voor afstemming en uitwisseling ten behoeve van het beoogde resultaat.",
    "bullets": [
      "Ontwerpt de look & feel van studiodecors",
      "Vertaalt de creatieve visie van de productie naar concrete ontwerpen design bepaalde stijl en kaders;",
      "Maakt een artistiek concept en ontwikkelt technische tekeningen die als basis dienen voor de bouw en inrichting van de sets",
      "Werkt nauw samen met de Production Designer en andere leden van het art team voor afstemming en uitwisseling ten behoeve van het beoogde resultaat"
    ],
    "volgorde": 300
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Special Prop Maker",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het ontwerpen, ontwikkelen en vervaardigen van unieke rekwisieten die speciaal worden gemaakt voor een productie. Beschikt over creativiteit, technisch inzicht en ambachtelijk vakmanschap en draagt zorg voor het hele proces: van het vertalen van een ontwerp of idee naar een uitvoerbaar plan, tot het bouwen, afwerken en eventueel installeren van het object. Ziet erop toe dat de rekwisieten veilig, functioneel en visueel overtuigend zijn en aansluiten bij de stijl, sfeer en boodschap van de productie en werkt in samenspraak met de Production Designer en de Regisseur.",
    "bullets": [
      "Is verantwoordelijk voor het ontwerpen, ontwikkelen en vervaardigen van unieke rekwisieten die speciaal worden gemaakt voor een productie",
      "Beschikt over creativiteit, technisch inzicht en ambachtelijk vakmanschap",
      "Draagt zorg voor het hele proces: van het vertalen van een ontwerp of idee naar een uitvoerbaar plan, tot het bouwen, afwerken en eventueel installeren van het object",
      "Ziet erop toe dat de rekwisieten veilig, functioneel en visueel overtuigend zijn en aansluiten bij de stijl, sfeer en boodschap van de productie",
      "Werkt in samenspraak met de Production Designer en de Regisseur"
    ],
    "volgorde": 310
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Wig Maker/ Wig Technician",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Ontwerpt, creëert en onderhoudt pruiken voor cast en figuratie. Maakt aanpassingen ten behoeve van een personage of specifieke stijl en werkt zelfstandig op basis van duidelijke richtlijnen. Onderhoudt nauw contact met de Make Up Designer.",
    "bullets": [
      "Ontwerpt, creëert en onderhoudt pruiken voor cast en figuratie",
      "Maakt aanpassingen ten behoeve van een personage of specifieke stijl",
      "Werkt zelfstandig op basis van duidelijke richtlijnen",
      "Onderhoudt nauw contact met de Make Up Designer"
    ],
    "volgorde": 320
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Make-up Artist",
    "niveaus": [
      "G"
    ],
    "aliases": [],
    "omschrijving": "Prepareert en draagt zorg voor make-up en haar van de cast en figuratie op basis van concrete richtlijnen ten aanzien van het beoogde resultaat en maakt daarvoor keuzes vanuit het eigen specialisme. Wordt betrokken bij het proces na de preproductiefase. Bewaakt gedurende de productiefase de continuïteit van creaties en resultaten over het eigen en het uitgevoerde werk van assistenten, mits aanwezig.",
    "bullets": [
      "Ontwerpt, bereidt voor en verzorgt make-up en haar van de cast",
      "Werkt op basis van duidelijke richtlijnen en eigen vakspecialisme",
      "Wordt betrokken bij het proces na de preproductiefase",
      "Bewaakt tijdens de productiefase de continuïteit van make-up en haar",
      "Controleert eigen werk en dat van eventuele assistenten",
      "Stuurt assistenten aan door werk te verdelen en inhoudelijke instructies te geven"
    ],
    "volgorde": 330
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Art Director",
    "niveaus": [
      "H"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het uitvoeren van de door de Producton Designer bepaalde stijl t.b.v. van het beoogde resultaat. Regelt inhoudelijke, organisatorische en budgettaire randvoorwaarden in. Is verantwoordelijk voor de constructie en ontwerp van de sets, binnen richtlijnen van en in dialoog met regie, production design en camera en stelt continue bij. Doet creatieve voorstellen binnen het eigen departement en/of richting regie en production design. Sluit andere specialisten van het eigen en andere vakgebieden binnen het eigen departement en andere departementen aan bij de uitvoering van het eigen werk. Stuurt assistenten aan door werk te coördineren, te verdelen en inhoudelijke aanwijzingen te geven.",
    "bullets": [
      "Verantwoordelijk voor het uitvoeren van de door de Production Designer bepaalde stijl, gericht op het beoogde resultaat",
      "Regelt de inhoudelijke, organisatorische en budgettaire randvoorwaarden",
      "Is verantwoordelijk voor het ontwerp en de constructie van sets, binnen de richtlijnen van en in dialoog met regie, production design en camera, en stuurt dit continu bij",
      "Doet creatieve voorstellen binnen het eigen departement en/of richting regie, production design en camera",
      "Betrekt andere specialisten uit het eigen en andere vakgebieden bij de uitvoering van het eigen werk",
      "Stuurt assistenten aan door werkzaamheden te coördineren, te verdelen en inhoudelijke aanwijzingen te geven"
    ],
    "volgorde": 340
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Kostuumontwerper",
    "niveaus": [
      "H"
    ],
    "aliases": [],
    "omschrijving": "Analyseert het script en stelt op basis daarvan een plan op. Regelt inhoudelijke, organisatorische en budgettaire randvoorwaarden. Ontwerpt de look van de karakters en bepaalt zo de kostuums, binnen richtlijnen van en in dialoog met regie, production design en camera en stelt continue bij. Doet creatieve voorstellen binnen het eigen departement en/of richting regie, production design en camera. Draagt indien van toepassing vanuit het eigen vakgebied bij aan een optimaal comfortabel gevoel van acteurs. Sluit andere specialisten van het eigen en andere vakgebieden binnen het eigen departement en andere departementen aan bij de uitvoering van het eigen werk. Stuurt assistenten aan door werk te coördineren, te verdelen en inhoudelijke aanwijzingen te geven.",
    "bullets": [
      "Analyseert het script en stelt op basis daarvan een plan op voor de kostuums",
      "Ontwerpt de look van de karakters en bepaalt daarmee de kostuums, binnen het beoogde resultaat van en in dialoog met regie, production design en camera, en stuurt dit continu bij",
      "Doet creatieve voorstellen binnen het eigen departement en/of richting regie, production design en camera",
      "Regelt de inhoudelijke, organisatorische en budgettaire randvoorwaarden",
      "Draagt vanuit het eigen vakgebied bij aan een optimaal comfortabel gevoel van acteurs",
      "Betrekt andere specialisten uit het eigen en andere vakgebieden bij de uitvoering van het werk",
      "Stuurt assistenten aan door het werk te coördineren, te verdelen en inhoudelijke aanwijzingen te geven"
    ],
    "volgorde": 350
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Make up & Hair Designer",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Ontwerpt, prepareert en draagt zorg voor de visuele stijl van make-up en haar voor de cast. Werkt op basis van concrete richtlijnen ten aanzien van het beoogde resultaat in samenwerking met de Regisseur en Costume Designer. Wordt betrokken tijdens de preproductiefase, beheert het budget, de planning en stelt het team samen. Maakt keuzes vanuit het eigen specialisme en bewaakt gedurende de productiefase de continuïteit van creaties en resultaten. Stuurt, indien aanwezig, assistenten aan door het werk te verdelen en inhoudelijke aanwijzingen en/of instructies te geven.",
    "bullets": [
      "Ontwerpt, prepareert en draagt zorg voor de visuele stijl van make-up en haar voor de cast",
      "Werkt op basis van concrete richtlijnen ten aanzien van het beoogde resultaat in samenwerking met de Regisseur en Costume Designer",
      "Wordt betrokken tijdens de preproductiefase, beheert het budget, de planning en stelt het team samen",
      "Maakt keuzes vanuit het eigen specialisme en bewaakt gedurende de productiefase de continuïteit van creaties en resultaten",
      "Stuurt, indien aanwezig, assistenten aan door het werk te verdelen en inhoudelijke aanwijzingen en/of instructies te geven"
    ],
    "volgorde": 360
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Set Decorator",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Doet research, selecteert passende materialen en coördineert de uitvoering van een team, waaronder de Rekwisiteur en Hand Props Master. Is verantwoordelijk voor de inrichting, aankleding en afwerking van sets, waarbij de visuele stijl van de productie wordt vertaald naar meubels, accessoires en decoratieve elementen. Werkt nauw samen met de Production Designer en stemt af over creatieve voorstellen ten behoeve van het beoogde resultaat.",
    "bullets": [
      "Doet research en selecteert passende materialen",
      "Coördineert de uitvoering van een team, waaronder de Rekwisiteur en Hand Props Master",
      "Is verantwoordelijk voor de inrichting, aankleding en afwerking van sets, waarbij de visuele stijl van de productie wordt vertaald naar meubels, accessoires en decoratieve elementen",
      "Doet creatieve voorstellen binnen het eigen departement ten behoeve van het beoogde resultaat"
    ],
    "volgorde": 370
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Special Effects Supervisor",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Bedenkt en ziet toe op de uitvoering van de special effects. Onderhoudt hierover tijdens de productiefase in nauw contact met regie, production design en camera ten aanzien van het beoogde resultaat. Bewaakt de continuïteit van creaties en de resultaten over zowel het eigen als het uitgevoerde werk van assistenten. Stuurt, indien aanwezig, assistenten aan door het werk te verdelen en inhoudelijke aanwijzingen en/of instructies te geven ten behoeve van het beoogde resultaat.",
    "bullets": [
      "Bedenkt en ziet toe op uitvoering special effects",
      "Onderhoudt tijdens de productiefase nauw contact met regie, production design en camera ten aanzien van het beoogde resultaat",
      "Wordt betrokken bij het proces na de pre-productiefase",
      "Stuurt assistenten aan door taken te verdelen en inhoudelijke instructies te geven",
      "Bewaakt de continuïteit van creaties en de resultaten over zowel het eigen als het uitgevoerde werk van assistenten"
    ],
    "volgorde": 380
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Special Make up Supervisor",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Ontwerpt special make-up en protheses, vanuit de visie van de Make-up Artist en aanvullende keuzes vanuit het eigen specialisme. Wordt betrokken bij het proces na de pre-productiefase. Bewaakt en brengt gedurende de productiefase de continuïteit van creaties en resultaten over het eigen en het uitgevoerde werk van anderen. Stuurt, indien aanwezig, specialisten aan door het werk te verdelen en inhoudelijke aanwijzingen en/of instructies te geven ten behoeve van het beoogde resultaat.",
    "bullets": [
      "Ontwerpt special make-up en protheses, vanuit de visie van de Make-up Artist en aanvullende keuzes vanuit het eigen specialisme",
      "Wordt betrokken bij het proces na de pre-productiefase",
      "Bewaakt en brengt gedurende de productiefase de continuïteit van creaties en resultaten over het eigen en het uitgevoerde werk van anderen",
      "Stuurt, indien aanwezig, specialisten aan door het werk te verdelen en inhoudelijke aanwijzingen en/of instructies te geven"
    ],
    "volgorde": 390
  },
  {
    "dep": "Art, Kostuum, Hair & Make Up",
    "rol": "Production designer",
    "niveaus": [
      "I"
    ],
    "aliases": [],
    "omschrijving": "Ontwerpt op basis van het script een concept voor de visuele stijl. Geeft richting aan de stijl voor sets, locaties, grafische uitingen, licht en camera. Maakt en beheert het budget van het eigen departement. Bedenkt vanuit creativiteit een inhoudelijk visueel concept in afstemming met regie en camera dat bepalend is voor het eindresultaat. Bedenkt diverse activiteiten en plannen om het concept te realiseren. Stuurt creatieve specialisten aan ten behoeve van het beoogde eindresultaat bij het realiseren van plannen. De eigen werkzaamheden hebben grote invloed op andere departementen en op andere vakgebieden binnen het eigen departement. Onderhoudt voor creatieve afstemming nauw contact met productie en regie. Heeft diverse contacten met regie, camera en andere Heads of Department (HoD) die inhoudelijk creatief zijn en van invloed op de totale productie.",
    "bullets": [
      "Ontwerpt op basis van het script een concept voor de visuele stijl",
      "Geeft richting aan de stijl voor sets, locaties, grafische uitingen, licht, camera",
      "Maakt en beheert het budget van het eigen departement",
      "Bedenkt een inhoudelijk visueel concept in afstemming met regie en camera",
      "Het concept is bepalend voor het eindresultaat",
      "Ontwikkelt diverse activiteiten en plannen om het concept te realiseren",
      "Stuurt creatieve specialisten aan ten behoeve van het beoogde resultaat",
      "De werkzaamheden hebben grote invloed op andere departementen en andere vakgebieden binnen het eigen departement",
      "Heeft inhoudelijk creatieve en invloedrijke contacten met regie, camera en andere Heads of Department"
    ],
    "volgorde": 400
  },
  {
    "dep": "Beeld postproductie",
    "rol": "Conform Editor",
    "niveaus": [
      "F"
    ],
    "aliases": [],
    "omschrijving": "Verricht binnen de richtlijnen van Head of Department (HoD) die kenbaar zijn gemaakt ten aanzien van het beoogde eindresultaat vaktechnische werkzaamheden in de post-productie fase, zoals het nabouwen van de picture-lock montage in de hoogst mogelijke resolutie en het pullen van de VFX shots. Vereist vakinhoudelijke kennis van het eigen werkproces. Heeft voornamelijk informerend en regelend contact binnen het eigen departement.",
    "bullets": [
      "Zet de offline edit om naar een high-res versie voor kleurcorrectie en afwerking",
      "Verbindt het gemonteerde beeld met het originele bronmateriaal (camera rushes)",
      "Controleert op fouten zoals verkeerde framerates, resoluties of ontbrekende shots",
      "Bereidt het project technisch voor op grading, VFX en mastering",
      "Werkt nauw samen met de Editor, Colorist en Postproducer",
      "Beheerst vakinhoudelijke kennis van het eigen werkproces",
      "Heeft voornamelijk informerend en regelend contact binnen het eigen departement"
    ],
    "volgorde": 10
  },
  {
    "dep": "Beeld postproductie",
    "rol": "Grafisch Ontwerper",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Ontwerpt grafische elementen zoals titelontwerp en aftiteling in de audiovisuele productie. Maakt vormgeving zoals infographics, kaarten, schermcontent of animaties. Zorgt ervoor dat het grafisch werk past bij de stijl en toon van de productie en levert bestanden aan in het juiste formaat ten behoeve van montage of VFX-integratie. Verricht vaktechnische werkzaamheden vanuit een autonome positie en heeft contact met editors, motion designers, regie en productie  om af te stemmen en soms te beïnvloeden.",
    "bullets": [
      "Ontwerpt grafische elementen zoals titels, ondertitels, intro's en credits",
      "Maakt vormgeving zoals infographics, kaarten, schermcontent of animaties",
      "Zorgt dat grafisch werk past bij de stijl en toon van de productie",
      "Verricht vaktechnische werkzaamheden vanuit een autonome positie",
      "Werkt samen met Editors, Motion Designers, regie en productie om af te stemmen en soms te beïnvloeden",
      "Levert bestanden aan in het juiste formaat voor montage of VFX-integratie"
    ],
    "volgorde": 20
  },
  {
    "dep": "Beeld postproductie",
    "rol": "In-House (post)producer (beeld nabewerking)",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Verricht specialistische werkzaamheden zoals het stroomlijnen van de post workflow en de planning binnen een posthuis/faciliteit. Beheert onderdelen van budgetten die bij het postbhuis ondergebracht zijn en onderhandelt binnen de (financiele) kaders over kosten en uitgaven. Ziet toe op de naleving van gemaakte afspraken en overziet consequenties van problemen en oplossingen voor aanverwante departementen. Werkt vanuit een autonome positie binnen de richtlijnen ten behoeve van het beoogde eindresultaat en fungeert als eerste aanspreekpunt voor klanten van het post-bedrijf en heeft contact dat adviserend en overtuigend is.",
    "bullets": [
      "Verricht specialistische werkzaamheden zoals het stroomlijnen van de post workflow en de planning binnen een posthuis/faciliteit",
      "Richt zich op een deel van het postproductietraject  (bijv. editing, grading, audio en/of beeldnabewerking, VFX)",
      "Beheert interne budgetten en stelt offertes voor producties op",
      "Stuurt teams aan ten aanzien van het beoogde resultaat Editors, Coloristen, Geluidsmensen) en bewaakt deadlines",
      "Zorgt voor technische levering van het eindproduct in juiste formats",
      "Overziet consequenties van problemen en oplossingen voor aanverwante departementen",
      "Is aanspreekpunt voor klanten en vertaalt feedback naar het team",
      "Heeft contact dat adviserend en overtuigend is"
    ],
    "volgorde": 30
  },
  {
    "dep": "Beeld postproductie",
    "rol": "Online Editor",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Verwerkt elementen als titels, kleurgecorrigeerde masters, graphics, eindmixen, VFX shots etc. in de eindmontage/mastering van een audiovisuele productie. Zorgt voor technische correctheid (framerate, resolutie, codec, aspectratio) en voert kleine correcties toe. Beschikt over vakinhoudelijke kennis van het eigen werkproces en verricht uitvoerende, vaktechnische werkzaamheden ten behoeve van de technische realisatie van een productie. Levert de masterbestanden aan en heeft voornamelijk informerend en regelend contact binnen het eigen departement.",
    "bullets": [
      "Voert de laatste beeldbewerking uit op de definitieve, high-res montage",
      "Integreert kleurcorrectie, VFX, graphics en titels in één eindversie",
      "Zorgt voor technische correctheid (framerate, resolutie, codec, aspectratio)",
      "Past kleine correcties toe (reframing, retouching, beeldstabilisatie)",
      "Werkt vanuit vakinhoudelijke kennis over het eigen werkproces",
      "Levert de masterbestanden aan voor distributie (cinema, tv, online)",
      "Heeft voornamelijk informerend en regelend contact binnen het eigen departement",
      "Werkt nauw samen met de Conform Editor, Colorist en Postproducer"
    ],
    "volgorde": 40
  },
  {
    "dep": "Beeld postproductie",
    "rol": "Colorist",
    "niveaus": [
      "G"
    ],
    "aliases": [],
    "omschrijving": "Verricht specialistische vaktechnische werkzaamheden op het gebied van het gradingproces door via kleurcorrectie creatief vorm te geven aan sfeer en uiterlijk van een productie. Zorgt dat de verschillende cuts op elkaar afgestemd zijn qua kleur. Heeft een autonome positie, werkt zelfstandig binnen het eigen deelspecialisme en de richtlijnen van regie en Head of Department (HoD) die kenbaar zijn gemaakt ten aanzien van het beoogde eindresultaat. Signaleert ontwikkelingen binnen het departement. Bedenkt en levert eigen ideeën omtrent het gradingproces. Heeft diverse contacten binnen en buiten het eigen departement, om af te stemmen en soms te beïnvloeden.",
    "bullets": [
      "Corrigeert en stylt het beeldmateriaal om een consistente en visueel aantrekkelijke look te creëren",
      "Werkt vanuit een autonome positie zelfstandig binnen het eigen deelspecialisme en vertaalt de creatieve visie van regisseur en DoP naar kleurgebruik en beeldbalans ten behoeve van het beoogde resultaat",
      "Past kleurcorrectie en grading toe met professionele software",
      "Bewaakt de technische kwaliteit en kleurconsistentie voor verschillende outputformaten",
      "Draagt zorg voor oplevering van eindversies voor bioscoop, tv, online of andere distributiekanalen",
      "Adviseert over visuele stijl en bijdragen aan de esthetiek van het eindproduct",
      "Signaleert ontwikkelingen binnen het departement",
      "Bedenkt en levert eigen ideeën omtrent het gradingproces",
      "Heeft diverse contacten binnen en buiten het eigen departement, om af te stemmen en  soms te beïnvloeden"
    ],
    "volgorde": 50
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "2nd AC",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Houdt de voorraad bij (onder meer camera equipment), maakt camerarapporten, laadt accu's op en houdt de urenregistratie bij van het camera department. Voert praktische en assisterende werkzaamheden uit ten behoeve van een ondersteunend werkproces. Contacten zijn gericht op het ophalen en uitwisselen van informatie en binnen eigen departement.",
    "bullets": [
      "Houdt de voorraad bij van o.m. camera equipment",
      "Maakt camerarapporten, laadt accu's op en houdt de urenregistratie bij van het camera department",
      "Voert praktische en assisterende werkzaamheden uit ten behoeve van een ondersteunend werkproces",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie en binnen eigen departement"
    ],
    "volgorde": 10
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Belichter / Lichtassistent",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Zet verlichtingsapparatuur op en draagt zorg voor de bediening. Beschikt over vakkennis van elektriciteit en verlichting. Verricht uitvoerende werkzaamheden op aanwijzing van Best Boy en/of Gaffer, ten behoeve van een ondersteunend werkproces en heeft contacten gericht op het ophalen en uitwisselen van informatie binnen eigen lichtdepartement.",
    "bullets": [
      "Zet verlichtingsapparatuur op en draagt zorg voor de bediening",
      "Beschikt over vakkennis van elektriciteit en verlichting",
      "Verricht uitvoerende werkzaamheden op aanwijzing van Best Boy, ten behoeve van een ondersteunend werkproces",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen lichtdepartement"
    ],
    "volgorde": 20
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Cameracar operator",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Rijdt en bedient voertuigen om de camera mee voort te bewegen. Volgt de creatieve visie van de DoP en werkt samen met de camera crew om dynamische, veilige en technisch correcte opnames te realiseren. Verricht uitvoerende werkzaamheden ten behoeve van een ondersteunend werkproces. Contacten zijn gericht op het ophalen en uitwisselen van informatie en binnen eigen departement.",
    "bullets": [
      "Rijdt en bedient voertuigen om de camera mee voort te bewegen",
      "Volgt de creatieve visie van de DoP en werkt samen met de camera crew om dynamische, veilige en technisch correcte opnames te realiseren",
      "Verricht uitvoerende werkzaamheden ten behoeve van een ondersteunend werkproces",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie en binnen eigen departement"
    ],
    "volgorde": 30
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Clapper Loader",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Laadt en beheert filmrollen of geheugenkaarten in en draagt zorg voor het (belichte) materiaal en de administratie hiervan. Voert vakinhoudelijke regelende en assisterende werkzaamheden uit ten behoeve van een ondersteunend werkproces, waaronder de informatie op de clapper en slate. Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen binnen het eigen departement. Beschikt over een hoge mate van accuratesse voor het uitvoeren van de werkzaamheden en onderhoudt contacten gericht op het ophalen en uitwisselen van informatie.",
    "bullets": [
      "Laadt en beheert filmrollen of geheugenkaarten in en draagt zorg voor het (belichte) materiaal en de administratie hiervan",
      "Voert vakinhoudelijke regelende en assisterende werkzaamheden uit ten behoeve van ondersteunend werkproces, waaronder de informatie op de clapper en slate",
      "Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen binnen het eigen departement",
      "Beschikt over een hoge mate van accuratesse voor het uitvoeren van de werkzaamheden",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie en binnen eigen departement"
    ],
    "volgorde": 40
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Crane Grip",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Bouwt en bedient camerakranen op aanwijzing van Key Grip. Voert vakinhoudelijke regelende en assisterende werkzaamheden uit ten behoeve van een ondersteunend werkproces, signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen. Contacten zijn gericht op het ophalen en uitwisselen van informatie en binnen eigen departement.",
    "bullets": [
      "Bouwt en bedient de camerakranen op aanwijzing van Key Grip",
      "Voert vakinhoudelijke regelende en assisterende werkzaamheden uit ten behoeve van een ondersteunend werkproces",
      "Signaleert problemen bij de realisatie en brengt deze onder de aandacht van anderen",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie en binnen eigen departement"
    ],
    "volgorde": 50
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Data Handler",
    "niveaus": [
      "D"
    ],
    "aliases": [],
    "omschrijving": "Verricht administratieve, uitvoerende werkzaamheden ten behoeve van een ondersteunend werkproces, bijvoorbeeld het zorgdragen voor viewingsmogelijkheden via monitoren tijdens de opnamen en na afloop van een draaidag. Zorgt voor nazorg, zoals het overbrengen van opgenomen materiaal van de camera naar een computer. Contacten zijn gericht op het ophalen en uitwisselen van informatie. Een hoge mate van accuratesse is benodigd bij het uitvoeren van de werkzaamheden.",
    "bullets": [
      "Zorgt voor nazorg, zoals het overbrengen van opgenomen materiaal van de camera naar een computer",
      "Kan zorgdragen voor viewingsmogelijkheden via monitoren tijdens de opnamen en na afloop van een draaidag",
      "Verricht administratieve, uitvoerende werkzaamheden ten behoeve van een ondersteunend werkproces",
      "Beschikt over een hoge mate van accuratesse bij het uitvoeren van de werkzaamheden",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie"
    ],
    "volgorde": 60
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "DMX-controller",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Bedient belichting bij studio-opnamen, zoals aangegeven door de Head of Departement. Verricht uitvoerende werkzaamheden ten behoeve van een ondersteunend werkproces en heeft contacten gericht op het ophalen en uitwisselen van informatie en binnen eigen departement.",
    "bullets": [
      "Bedient belichting bij studio opnamen, zoals aangegeven door de Head of Department",
      "Verricht uitvoerende werkzaamheden ten behoeve van een ondersteunend werkproces ten behoeve van het beoogde eindresultaat",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie en binnen eigen departement"
    ],
    "volgorde": 70
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Grip Assistent",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Beheert het gripmateriaal op de set. Voert werkzaamheden uit volgens instructies en zijn op basis van routine. Verricht uitvoerende werkzaamheden ten behoeve van een ondersteunend werkproces en heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Beheert het gripmateriaal op de set",
      "Voert werkzaamheden uit volgens instructies en zijn op basis van routine",
      "Verricht uitvoerende werkzaamheden ten behoeve van een ondersteunend werkproces",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 80
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Video Assist operator",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Verricht uitvoerende werkzaamheden ten behoeve van een ondersteunend werkproces. Zorgt voor de beschikbaarheid van beelden voor terugkijken (viewingsmogelijkheden). Verzorgt de opnameweergave, zodat de regisseur en crew de geschoten beelden kunnen evalueren. Contacten zijn gericht op het ophalen en uitwisselen van informatie.",
    "bullets": [
      "Zorgt voor de beschikbaarheid van beelden voor terugkijken (viewingsmogelijkheden) op de set",
      "Verricht uitvoerende werkzaamheden ten behoeve van een ondersteunend werkproces",
      "Verzorgt de opnameweergave, zodat de regisseur en crew de geschoten beelden kunnen evalueren",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie"
    ],
    "volgorde": 90
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Best Boy",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Organiseert de logistiek van de lichtapparatuur, boekt crew en beheert de administratie voor het licht departement. Regelt en ondersteunt vanuit vaktechnische kennis en vaardigheden, signaleert problemen bij de realisatie en brengt deze onder de aandacht van de Gaffer en anderen. Stuurt assistenten en eventuele stagiairs aan en neemt veiligheidsmaatregelen op basis van werk met hoge amperes. Inzicht in de gang van zaken op de set is noodzakelijk om mee te denken en ad hoc oplossingsvoorstellen te kunnen doen. Heeft contact voornamelijk binnen eigen departement en soms met productie.",
    "bullets": [
      "Organiseert de logistiek van de lichtapparatuur, boekt crew en beheert de administratie voor het licht departement",
      "Regelt en ondersteunt vanuit vaktechnische kennis en vaardigheden",
      "Signaleert problemen bij de realisatie en brengt deze onder de aandacht van de Gaffer en anderen",
      "Stuurt assistenten en eventuele stagiairs aan en neemt veiligheidsmaatregelen op basis van werk met hoge amperes",
      "Inzicht in de gang van zaken op de set is noodzakelijk om mee te denken en ad hoc oplossingsvoorstellen te kunnen doen",
      "Heeft contact voornamelijk binnen eigen departement en soms met productie"
    ],
    "volgorde": 100
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Camera Operator",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Zorgt voor en bedient de camera-apparatuur conform de beeldcompositie die is aangegeven door de Director of Photagraphy. Beslissingen hebben consequenties voor de beeldopnames. Verricht zelfstandig voorbereidende en uitvoerende taken binnen een bepaalde productiefase. Er kan sprake zijn van fysiek belastende houdingen tijdens uitvoeren van werk. Is communicatief vaardig en heeft grotendeels contacten binnen het eigen departement.",
    "bullets": [
      "Zorgt voor en bedient de camera-apparatuur conform de beeldcompositie die is aangegeven door de Director of Photagraphy",
      "Beslissingen hebben consequenties voor de beeldopnames",
      "Verricht zelfstandig voorbereidende en uitvoerende taken binnen een bepaalde productiefase",
      "Is communicatief vaardig en heeft grotendeels contacten binnen het eigen departement",
      "Er kan sprake zijn van fysiek belastende houdingen tijdens uitvoeren van werk"
    ],
    "volgorde": 110
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Drone Operator",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Bedient de drone camera ten behoeve van arial shots conform de beeldcompositie die is aangegeven door de Director of Photography. Beschikt over technische kennis met betrekking tot het prepareren, opbouwen en besturen van de drone en kennis van benodigde vergunnningen om ermee te vliegen. Beslissingen hebben consequenties voor de beeldopnames. Verricht voorbereidende en uitvoerende taken binnen een bepaalde productiefase. Is communicatief vaardig en heeft contacten binnen het eigen departement.",
    "bullets": [
      "Bedient de drone camera t.b.v arial shots conform de beeldcompositie die is aangegeven door de Director of Photography",
      "Beschikt over technische kennis m.b.t. het prepareren, opbouwen en besturen van de drone en kennis van benodigde vergunningen om ermee te vliegen",
      "Genomen beslissingen hebben consequenties voor de beeldopnames",
      "Verricht voorbereidende en uitvoerende taken binnen een bepaalde productiefase",
      "Is communicatief vaardig en heeft contacten binnen het eigen departement"
    ],
    "volgorde": 120
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "ENG camera Operator",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Zorgt voor en bedient de camera-apparatuur in een autonoom opererend team voor korte locatie opnamen van actualiteiten, nieuws of documentaires. Werkt hiervoor samen met een ENG geluidspersoon, conform de beeldcompositie die is aangegeven door de Head of Department. Ruimte voor beslissingen over eigen werk bestaat met consequenties voor de beeldopnames. Verricht zelfstandig specialistische, voorbereidende en uitvoerende taken binnen een bepaalde productiefase. Heeft contact met andere departementen die meestal adviserend en/of beïnvloedend van aard zijn.",
    "bullets": [
      "Zorgt voor en bedient de camera-apparatuur in een autonoom opererend team voor korte locatie opnamen van actualiteiten, nieuws of documentaires",
      "Werkt conform de beeldcompositie die is aangegeven door de Head of Department, samen met een ENG geluidspersoon",
      "Maakt beslissingen o.b.v. specialistische kennis en vaardigheden die consequenties hebben voor beeldopnamen",
      "Verricht zelfstandig voorbereidende en uitvoerende taken binnen een bepaalde productiefase",
      "Heeft adviserend en/of beïnvloedend contact met andere departementen, waaronder met regie"
    ],
    "volgorde": 130
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Focus Puller/1st AC",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Past de scherpte van de lens aan ten behoeve van het shot, beheert en onderhoudt de camera-apparatuur. Maakt beslissingen op basis van specialistische kennis en vaardigheden die consequenties hebben voor beeldopnamen. Selecteert en stuurt het verdere camerateam aan en heeft contact met andere departementen die meestal adviserend en/of beïnvloedend van aard zijn.",
    "bullets": [
      "Past de scherpte van de lens aan ten behoeve van het shot, beheert en onderhoudt de camera-apparatuur",
      "Maakt beslissingen o.b.v. specialistische kennis en vaardigheden die consequenties hebben voor beeldopnamen",
      "Selecteert en stuurt het verdere camerateam aan",
      "Heeft adviserende en/of beïnvloedende contacten met andere departementen"
    ],
    "volgorde": 140
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Key Grip",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Bouwt en onderhoudt apparatuur die de camera op elke plek kan plaatsen of doen voortbewegen. Vertaalt de visie van de DoP in praktische en veilige oplossingen voor camerabewegingen. Verplaatst camera's, regelt en ondersteunt vanuit vaktechnische kennis en vaardigheden. Inzicht in de gang van zaken op de set is noodzakelijk om mee te denken en ad hoc oplossingsvoorstellen te kunnen doen. Heeft contact met andere departementen en adviserende en/of signalerende rol richting de 1st AD inzake setveiligheid.",
    "bullets": [
      "Bouwt en onderhoudt apparatuur die de camera op elke plek kan plaatsen of doen voortbewegen",
      "Vertaalt de visie van de DoP in praktische en veilige oplossingen voor camerabewegingen",
      "Verplaatst camera's, regelt en ondersteunt vanuit vaktechnische kennis en vaardigheden",
      "Inzicht in de gang van zaken op de set is noodzakelijk om mee te denken en ad hoc oplossingsvoorstellen te kunnen doen",
      "Heeft contact met andere departementen en adviserende en/of signalerende rol richting de 1st AD inzake setveiligheid"
    ],
    "volgorde": 150
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Steadicam Operator",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Bedient de steadicam camera en draagt zorg voor de framing en timing van shots. Verricht zelfstandig voorbereidende en uitvoerende taken binnen een bepaalde productiefase. Werkt conform de beeldcompositie die is aangegeven door de Director of Photagraphy, maakt beslissingen op basis van specialistische kennis en vaardigheden die consequenties hebben voor beeldopnamen. Er kan sprake zijn van fysiek belastende houdingen tijdens uitvoeren van werk. Is communicatief vaardig en heeft contacten binnen het eigen departement.",
    "bullets": [
      "Bedient de steadicam camera en draagt zorg voor de framing en timing van de shots",
      "Verricht zelfstandig voorbereidende en uitvoerende taken binnen een bepaalde productiefase",
      "Werkt conform de beeldcompositie die is aangegeven door de Director of Photagraphy",
      "Beslissingen hebben consequenties voor de beeldopnames",
      "Er kan sprake zijn van fysiek belastende houdingen tijdens uitvoeren van werk",
      "Is communicatief vaardig en heeft contacten binnen het eigen departement"
    ],
    "volgorde": 160
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Gaffer",
    "niveaus": [
      "H"
    ],
    "aliases": [],
    "omschrijving": "Ontwikkelt vanuit het eigen specialisme creatief, technische en logistieke het lichtplan voor de productie en neemt beslissingen binnen richtlijnen en informatie van regie, productie en in dialoog met Head of Department (HoD). Is betrokken bij het proces vanaf de pre-productiefase en heeft departement-overstijgende contacten. Overziet consequenties van problemen en oplossingen voor aanverwante departementen en geeft advies aan productie. Ziet erop toe dat tijdens de productie de resultaten van het eigen werk en het werk van assistenten gehaald worden. Stuurt de assistenten binnen het lichtteam aan door het werk te coördineren, te verdelen en inhoudelijke aanwijzingen of instructies te geven. Beheert het eigen budget en stemt af met de HoD en Productie.",
    "bullets": [
      "Ontwikkelt vanuit het eigen specialisme een lichtplan ten behoeve van de visie van de Regisseur en Director of Photography",
      "Draagt zorg voor zowel het creatieve deel als de technische en logistieke organisatie van het lichtplan",
      "Neemt beslissingen binnen richtlijnen en informatie van regie, productie en in dialoog met Director of Photography",
      "Is betrokken bij het proces vanaf de pre-productiefase en heeft departement-overstijgende contacten",
      "Overziet consequenties van problemen en oplossingen voor aanverwante departementen en geeft advies aan productie",
      "Ziet erop toe dat tijdens de productie de resultaten van het eigen werk en het werk van assistenten gehaald worden",
      "Stuurt de assistenten binnen het lichtteam aan door het werk te coördineren, te verdelen en inhoudelijke aanwijzingen of instructies te geven ten aanzien van het beoogde resultaat"
    ],
    "volgorde": 170
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Lichtontwerper studio",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Ontwikkelt vanuit het eigen specialisme het lichtplan voor studio-opnames op zowel creatief, technisch als logistiek vlak. Neemt beslissingen binnen richtlijnen en informatie van regie, productie en in dialoog met Head of Department (HoD). Is betrokken bij het proces vanaf de pre-productiefase en heeft departement-overstijgende contacten. Overziet consequenties van problemen en oplossingen voor aanverwante departementen en geeft advies aan productie. (Bij film/commercial/serie is dit de verantwoordelijkheid van de Gaffer).",
    "bullets": [
      "Ontwikkelt vanuit het eigen specialisme het lichtplan voor studio-opnames op zowel creatief, technisch als logistiek vlak",
      "Neemt beslissingen binnen richtlijnen en informatie van regie, productie en in dialoog met Head of Department (HoD)",
      "Is betrokken bij het proces vanaf de pre-productiefase en heeft departement-overstijgende contacten",
      "Overziet consequenties van problemen en oplossingen voor aanverwante departementen en geeft advies aan productie. (Bij film/commercial/serie is dit de verantwoordelijkheid van de Gaffer)"
    ],
    "volgorde": 180
  },
  {
    "dep": "Camera, Licht en Grip",
    "rol": "Director of Photography",
    "niveaus": [
      "I"
    ],
    "aliases": [
      "DoP"
    ],
    "omschrijving": "Verricht specialistische coördinerende werkzaamheden op het gebied van beeld. Draagt zorg voor het vastleggen en ontwerpen van de fotografie van een productie en denkt vooraf creatief en inhoudelijk mee over hoe het eindproduct moet worden opgenomen. Stuurt inhoudelijk specialisten aan, zoals camera operators en belichting, bij de ontwikkeling en uitvoering van werkzaamheden. De werkzaamheden hebben invloed op andere departementen en activiteiten worden afgestemd op de gehele productie. Heeft diverse interne en externe contacten die sturend en beïnvloedend zijn op het resultaat van de productie.",
    "bullets": [
      "Ontwikkelt een cameravisie waarin keuzes op het gebied van decoupage, licht, kleur, lenskeuze en camerabewegingen worden uitgewerkt",
      "Stelt o.b.v. de cameravisie een plan op om deze keuzes toepasbaar te maken binnen de productie",
      "Draagt zorg voor het vastleggen van de fotografie van een productie",
      "Verricht specialistische, coördinerende werkzaamheden op het gebied van beeld",
      "Stuurt de  gaffer, grip en camera-assistenten aan op de set de en in de postproductie de colorist bij beslissingen over licht en kleur in het eindproduct",
      "Stuurt inhoudelijk specialisten aan bij de ontwikkeling en uitvoering van werkzaamheden",
      "Heeft diverse interne en externe contacten die sturend en beïnvloedend zijn op het resultaat van de productie"
    ],
    "volgorde": 190
  },
  {
    "dep": "Casting en Acteren",
    "rol": "Dialect Coach",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Analyseert het script en adviseert over de benodigde dialecten. Begeleidt Acteurs in het leren van tekst en uitspraak in de juiste taal of dialect, met name bij repetities, soms op de set en soms in een nasynchronisatieproces. Heeft met name contacten met Regisseur, Acteurs en specialisten ten behoeve van een kwalitatief geloofwaardig eindresultaat.",
    "bullets": [
      "Analyseert het script en adviseert over de benodigde dialecten",
      "Coacht Acteurs in het correct aanleren en toepassen van een dialect of accent, met name bij repetities, soms op de set en soms in een nasynchronisatieproces",
      "Bereidt uitspraakvoorbeelden, transcripties en fonetisch materiaal voor",
      "Werkt samen met Regisseur en Acteurs om authenticiteit te waarborgen",
      "Corrigeert uitspraak tijdens repetities en opnames indien nodig",
      "Helpt Acteurs het dialect geloofwaardig en natuurlijk te laten klinken"
    ],
    "volgorde": 10
  },
  {
    "dep": "Casting en Acteren",
    "rol": "Figuratie casting",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Bedenkt, organiseert en realiseert de invulling van rollen die niet vallen onder de definitie hoofdrol, middenrol of bijrol binnen een productie. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van het beoogde eindresultaat van de productie. De rol kan worden vervuld door een persoon vanuit het productieteam zijn, of een apart bedrijf.",
    "bullets": [
      "Zoekt en selecteert passende figuranten op basis van het script en de wensen van de regie",
      "Houdt contact met figuranten en plant hen in voor draaidagen",
      "Verzamelt en beheert gegevens zoals beschikbaarheid, uiterlijk en kledingmaten",
      "Brengt figuranten op de hoogte van draaidagdetails (tijd, locatie, kleding, gedrag op set)",
      "Werkt nauw samen met regie, productie en soms kleding/make-up"
    ],
    "volgorde": 20
  },
  {
    "dep": "Casting en Acteren",
    "rol": "Kinderbegeleider",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Begeleidt minderjarige Acteurs op de set. Heeft onder meer contacten met regie, productie, ouders en school om wensen en grenzen af te stemmen en informatie uit te wisselen. De inzet van kinderbegeleiders is geprotocoleerd om hun onafhankelijke inzet en werkzaamheden te waarborgen.",
    "bullets": [
      "Begeleidt minderjarige Acteurs op de set en zorgt voor hun veiligheid en welzijn",
      "Ondersteunt bij de voorbereiding op scènes",
      "Houdt toezicht op werktijden, rust en naleving van regelgeving",
      "Is aanspreekpunt voor ouders, regie en productie",
      "Zorgt voor rust, vertrouwen en een prettige werkomgeving voor het kind"
    ],
    "volgorde": 30
  },
  {
    "dep": "Casting en Acteren",
    "rol": "Agent",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Vertegenwoordigt en beheert zowel de zakelijke als praktische belangen van de Acteur. Analyseert aanvragen op basis van kwaliteit, planning en kansen, overlegt hierover met de Acteur en geeft advies. Fungeert als de verbindende link tussen verschillende partijen, zoals productie en regie en plant afspraken in. Voert contractonderhandelingen en biedt begeleiding en ondersteuning ten behoeve van het carrièrepad van de Acteur.",
    "bullets": [
      "Vertegenwoordigt en beheert de zakelijke en praktische belangen van de Acteur",
      "Analyseert aanvragen op basis van kwaliteit, planning en kansen, overlegt hierover met de Acteur en geeft advies",
      "Fungeert als verbindende schakel tussen Acteur en andere partijen",
      "Onderhandelt over contracten, tarieven en afspraken",
      "Plant afspraken en bewaakt verplichtingen en deadlines",
      "Ontzorgt de Acteur zodat creatieve processen doorgang vinden",
      "Beoordeelt en interpreteert informatie op basis van vakkennis en ervaring"
    ],
    "volgorde": 40
  },
  {
    "dep": "Casting en Acteren",
    "rol": "Casting Assistent",
    "niveaus": [
      "F"
    ],
    "aliases": [],
    "omschrijving": "Fungeert als de verbindende link tussen verschillende partijen. Verricht ondersteunende en organisatorische werkzaamheden bij castings. Maakt een korte analyse van de vraag en stemt de dienstverlening daarop af. Ontzorgt zodat andere werkprocessen doorgang kunnen vinden. Doet tevens inhoudelijke voorstellen ten aanzien van het eigen werk en de dienstverlening. Beoordeelt en interpreteert (kwalitatieve) informatie op basis van opgedane vakkennis en instructies.",
    "bullets": [
      "Ondersteunt de Casting Director bij organisatie en uitvoering van het castingproces",
      "Regelt planning, communicatie met Producent, Agent of Acteurs en logistiek rond audities",
      "Ontvangt en begeleidt Acteurs tijdens audities",
      "Houdt administratie bij en verzamelt castinggegevens",
      "Ondersteunt bij selectie van Acteurs en het voorbereiden van auditietapes"
    ],
    "volgorde": 50
  },
  {
    "dep": "Casting en Acteren",
    "rol": "Puppeteer",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Bedient poppenpersonages of speelt zelf in poppenkostuums. Ontvangt en analyseert concrete richtlijnen voor het beoogde resultaat van de productie en regie, vertaalt naar (de rol van) een personage, geeft die vorm en brengt die over. Stelt continue de vertaling bij op basis van inleving, neer te zetten prestatie en script. Levert individueel een relevante, creatieve en complementerende bijdrage op het geheel van het departement. De gevolgen van het handelen zijn betrekkelijk (immaterieel). Het afbreukrisico is in mindere mate aanwezig vanwege het vangen van zichtbaarheid. Kan een bijdrage leveren aan representatie.",
    "bullets": [
      "Bedient poppenpersonages of speelt zelf in poppenkostuums",
      "Ontwikkelt karakter en stem van het personage van de pop",
      "Repeteert bewegingen en coördinatie met andere spelers",
      "Bedient poppen handmatig of met mechaniek (bijv. stangen, touwen of animatronic) of speelt in poppenkostuum",
      "Analyseert richtlijnen voor het beoogde resultaat en vertaalt deze naar een geloofwaardig personage, geeft dit vorm en brengt dit over",
      "Past spel continu aan op basis van eigen inleving, het neerzetten van de prestatie en het script en zorgt dat scènes synchroon met dialoog en actie worden uitgevoerd"
    ],
    "volgorde": 60
  },
  {
    "dep": "Casting en Acteren",
    "rol": "Stem Acteur",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Leent diens stem aan personages/karakters in audiovisuele producties of verricht voice-overwerk. Ontvangt en analyseert concrete richtlijnen van de productie en regie, vertaalt deze naar een personage, geeft dit vorm en brengt dit over. Stelt continue de vertaling bij op basis van inleving, neer te zetten prestatie en script. Levert individueel een relevante, creatieve en complementerende bijdrage op het geheel van het departement. De gevolgen van het handelen zijn betrekkelijk (immaterieel).",
    "bullets": [
      "Leent diens stem aan personages/karakters in audiovisuele producties of verricht voice-overwerk",
      "Leest en analyseert scripts om toon en intentie te bepalen",
      "Ontwikkelt passende stemklanken en personages",
      "Neemt stemopnames op in studio, met aandacht voor timing en dictie",
      "Past stemgebruik aan op basis van inleving, neer te zetten prestatie en script",
      "Zorgt voor consistente stemkwaliteit bij vervolgsessies of series"
    ],
    "volgorde": 70
  },
  {
    "dep": "Casting en Acteren",
    "rol": "Acteur bijrol",
    "niveaus": [
      "G"
    ],
    "aliases": [],
    "omschrijving": "Levert individueel een relevante, creatieve en complementerende bijdrage op het geheel van het departement door een naamdragende, niet dominante, rol te spelen die relevant is voor de verhaallijn. Ontvangt en analyseert concrete richtlijnen voor het beoogde resultaat van de productie en regie, vertaalt naar (de rol van) een personage, geeft die vorm en brengt die over. Stelt continue de vertaling bij op basis van inleving, neer te zetten prestatie en script. De gevolgen van het handelen zijn betrekkelijk (immaterieel). Het afbreukrisico is aanwezig vanwege het vangen van zichtbaarheid. Kan een bijdrage leveren aan representatie.",
    "bullets": [
      "Speelt een naamdragende, niet-dominante maar betekenisvolle rol in het verhaal",
      "Analyseert richtlijnen voor het beoogde resultaat en vertaalt deze naar een geloofwaardig personage",
      "Geeft dit personage vorm en brengt het overtuigend over",
      "Past spel aan op basis van script, neer te zetten prestatie en inleving",
      "Levert zo nodig een bijdrage aan representatie en promotie van de productie;                                                                                                      ◦ De omvang van de rol varieert van een grotere terugkerende bijrol tot een dayplayer"
    ],
    "volgorde": 80
  },
  {
    "dep": "Casting en Acteren",
    "rol": "Casting director",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Analyseert het script en de (creatieve en productionele) wensen en richtlijnen van regie en producent voor de invulling van rollen. Organiseert het hele castingproces en geeft beïnvloedend advies. Doet voorstellen van Acteurs voor de personages uit de hoofdcast en bijrollen. Fungeert als sparringpartner voor hoofdzakelijk de Regisseur, Producent en streamer/omroep en onderhoudt contact met Acteurs en/of Agenten over de voortgang.",
    "bullets": [
      "Analyseert het script en de (creatieve en productionele) wensen en richtlijnen van regie en productie",
      "Stelt profielen op voor de invulling van rollen en adviseert hierbij over castbudget naar Producent",
      "Doet voorstellen van acteurs voor de hoofd- & bijpersonages",
      "Organiseert castings en is aanwezig bij castings met of zonder Regisseur",
      "Onderhoudt contacten met Acteurs en/of Agenten, Regisseur, Producent, omroep en streamers",
      "Adviseert over castingkeuzes"
    ],
    "volgorde": 90
  },
  {
    "dep": "Casting en Acteren",
    "rol": "Acteur",
    "niveaus": [
      "I"
    ],
    "aliases": [],
    "omschrijving": "Levert individueel een bepalende bijdrage aan het eindresultaat van een (aflevering van) de productie door een naamdragende, dominante en betekenisvolle hoofdrol te spelen. Analyseert het script, de creatieve wensen en richtlijnen voor het beoogde resultaat van de productie en regie, vertaalt deze naar een personage en geeft dit personage vorm. Stelt de vertaling naar het personage continue bijop basis van eigen inzicht, script en regie. Wisselt tijdens bepaalde productiefasen ideeën en visies uit, geeft beïnvloedend advies en doet voorstellen richting productie en regie. De gevolgen van het handelen zijn groot (immaterieel). Het afbreukrisico is tevens hoog vanwege het vangen van veel zichtbaarheid en het leveren van een actieve bijdrage aan de representatie over een lange periode verspreid.",
    "bullets": [
      "Levert een bepalende bijdrage aan het eindresultaat van (een aflevering van) de productie",
      "Speelt een naamdragende, dominante en betekenisvolle rol in (een aflevering van) de productie",
      "Analyseert het script en de creatieve wensen en richtlijnen voor het beoogde resultaat",
      "Vertaalt het beoogde resultaat naar een geloofwaardig personage",
      "Geeft het personage vorm en brengt dit overtuigend over",
      "Past het spel continu aan op basis van eigen inzicht, de regie en het script",
      "Deelt actief ideeën en visies, geeft beïnvloedend advies en doet voorstellen ter verbetering",
      "Draagt zichtbaar (en langdurig) bij aan de representatie en/of promotie van een (aflevering van de) productie"
    ],
    "volgorde": 100
  },
  {
    "dep": "Geluid postproductie",
    "rol": "Assistent Re-Recording Mixer",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Brengt alle opgenomen en gemonteerde geluiden bij elkaar om tot een gebalanceerd eindresultaat te komen. Neemt besluiten om eventueel nieuwe bronnen te verwerven. Ontvangt kaders vanuit het Head of Department (HoD) t.b.v. het beoogde eindresultaat. Doet inhoudelijke en technische voorstellen en geeft advies. Heeft overzicht over het werk dat wordt uitgevoerd in de pre- en de productiefase binnen aanverwante departementen. Begrijpt hierdoor de gevolgen van eerder in het proces genomen besluiten voor het eigen specialisme en acteert hierop met oplossingen. Communiceert departementoverstijgend om afstemming te waarborgen en kwaliteit te leveren en levert de eindmix aan in de juiste formaten voor bioscoop, tv of online distributie. In Nederland is de Sound Designer/Supervising Sound Editor vaak ook zelf de Re-Recording Mixer.",
    "bullets": [
      "Voert praktische werkzaamheden uit ter ondersteuning van de eindmix, zoals het voorbereiden van mixsessies en bedienen van de recorder",
      "Maakt en beheert back-ups, sessiebestanden en master files volgens technische standaarden",
      "Bereidt stems en geluidslagen (dialogen, foley, effecten, muziek) technisch voor",
      "Werkt met vakinhoudelijke kennis binnen de kaders van de opdracht en technische eisen",
      "Lost technische problemen op binnen bestaande werkstructuren",
      "Heeft contact binnen het eigen geluidsdepartement en handelt naar verkregen informatie",
      "Draagt bij aan een efficiënt en stabiel verloop van het mixproces in samenwerking met de Re-Recording Mixer"
    ],
    "volgorde": 10
  },
  {
    "dep": "Geluid postproductie",
    "rol": "ADR Editor",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Begeleidt en monteert opnieuw opgenomen dialogen (ADR) tijdens de sound post, in sync met beeld en geluid. Begeleidt en beheert de bijbehorende administratie hier omheen en werkt zelfstandig binnen de kaders van de opdracht ten aanzien van het beoogde resultaat. Maakt creatieve keuzes binnen bestaande oplossingsrichtingen bij technische of inhoudelijke problemen en stemt op specialistisch niveau af met collega's binnen het geluidsdepartement dat een informerend en licht beïnvloedend karakter heeft.",
    "bullets": [
      "Monteert opnieuw opgenomen dialogen (ADR) nauwkeurig in sync met beeld en geluid",
      "Past specialistische vakkennis toe om ADR technisch én inhoudelijk passend te maken",
      "Begeleidt het ADR-proces en beheert de bijbehorende administratieve verwerking",
      "Werkt zelfstandig binnen de opdrachtkaders en ten aanzien van het beoogde eindresultaat",
      "Maakt creatieve keuzes binnen bestaande oplossingsrichtingen bij technische of inhoudelijke problemen",
      "Stemt op specialistisch niveau af met collega's binnen het geluidsdepartement",
      "Heeft voornamelijk intern contact met collega’s en werkt in een informerende en licht beïnvloedende rol"
    ],
    "volgorde": 20
  },
  {
    "dep": "Geluid postproductie",
    "rol": "ADR Recordist",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Neemt tijdens de soundpost de dialogen en walla’s van acteurs en figuranten op. Zorgt voor nauwkeurige lipsync, juiste opnamekwaliteit en realistische perspectiefmix tijdens de sessie en werkt zelfstandig binnen de kaders van de opdracht t.b.v. het beoogde resultaat. Stemt af op specialistisch niveau binnen het geluidsdepartement, vanuit een informerende en licht beïnvloedende rol en maakt creatieve keuzes bij technische uitdagingen, binnen bestaande oplossingsrichtingen. Bereidt de opnames technisch voor en draagt deze over aan de ADR Editor of soundteam.",
    "bullets": [
      "Neemt tijdens de soundpost dialogen en walla’s op van acteurs en figuranten",
      "Zorgt voor nauwkeurige lipsync, juiste opnamekwaliteit en realistische perspectiefmix tijdens de sessie",
      "Levert een specialistische vaktechnische bijdrage aan de kwaliteit van de ADR-opnames",
      "Werkt zelfstandig binnen de kaders van de opdracht en het beoogde resultaat",
      "Stemt af op specialistisch niveau binnen het geluidsdepartement, met een informerende en licht beïnvloedende rol",
      "Maakt creatieve keuzes bij technische uitdagingen binnen bestaande oplossingsrichtingen",
      "Bereidt de opnames technisch voor en draagt deze over aan de ADR Editor of soundteam"
    ],
    "volgorde": 30
  },
  {
    "dep": "Geluid postproductie",
    "rol": "ADR Supervisor",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Beoordeelt welke dialogen opnieuw moeten worden opgenomen (ADR) en coördineert de opnamesessies. Bedenkt en draagt zorg voor het integreren van synchrone en niet synchrone contactgeluiden, stuurt op timing, emotie en synchroniciteit in samenwerking met Acteurs en Regisseur. Levert een specialistische, vaktechnische bijdrage en werkt zelfstandig binnen de kaders van de opdracht t.b.v. het beoogde eindresultaat. De benodigde afstemming is tamelijk specialistisch van aard, met een informerend en licht beïnvloedend karakter. Maakt creatieve keuzes bij het oplossen van problemen, binnen reeds bestaande oplossingsmogelijkheden. Heeft vooral contact binnen het eigen departement en zorgt voor een goede overdracht aan Dialoog Editor en eindmix. In Nederland wordt deze rol meestal vervuld door de Re-Recording Mixer, ook wel Supervising Sound Editor genoemd.",
    "bullets": [
      "Beoordeelt welke dialogen opnieuw moeten worden opgenomen (ADR) en coördineert de opnamesessies",
      "Bedenkt en draagt zorg voor het integreren van synchrone en niet-synchrone dialogen",
      "Stuurt op timing, emotie en synchroniciteit in samenwerking met Acteurs en Regisseur",
      "Werkt zelfstandig binnen de opdrachtkaders ten behoeve van het beoogde eindresultaat",
      "Afstemming is voornamelijk specialistisch en gebeurt vooral binnen het eigen geluidsdepartement",
      "Maakt creatieve keuzes binnen bestaande oplossingen en standaarden",
      "Zorgt voor goede overdracht aan Dialoog Editor en eindmix",
      "In Nederland wordt deze rol meestal vervuld door de Re-Recording Mixer, ook wel Supervising Sound Editor genoemd"
    ],
    "volgorde": 40
  },
  {
    "dep": "Geluid postproductie",
    "rol": "Foley Artist",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Creëert en neemt geluiden op die synchroon lopen met de actie op beeld (zoals stappen, kleding, aanrakingen) en draagt bij aan een rijk, geloofwaardig en meeslepend geluidsbeeld. Werkt in een foley-studio met opnameapparatuur en verschillende oppervlaktes/materialen. Gebruikt creatieve technieken en objecten om realistische of gestileerde geluidseffecten te maken en zorgt dat geluiden naadloos aansluiten bij timing, ritme en sfeer van het beeld. Werkt zelfstandig binnen de kaders van de opdracht en overlegt met de Sound Designer of Re-Recording Mixer over stijl en toon van de foley t.b.v. het beoogde resultaat. Maakt creatieve keuzes bij het oplossen van problemen, binnen reeds bestaande oplossingsmogelijkheden. Heeft vooral contact binnen het eigen departement en levert de foley-tracks aan ter integratie in de geluidsmontage en eindmix. Er is vooral contact binnen het eigen departement.",
    "bullets": [
      "Creëert en neemt geluiden op die synchroon lopen met de actie op beeld (zoals stappen, kleding, aanrakingen)",
      "Draagt bij aan een rijk, geloofwaardig en meeslepend geluidsbeeld",
      "Werkt in een foley-studio met opnameapparatuur en verschillende oppervlaktes/materialen",
      "Gebruikt creatieve technieken en objecten om realistische of gestileerde geluidseffecten te maken",
      "Zorgt dat geluiden naadloos aansluiten bij timing, ritme en sfeer van het beeld",
      "Werkt zelfstandig binnen de kaders van de opdracht en overlegt met de Sound Designer of Re-Recording Mixer over stijl en toon van de foley ten behoeve van het beoogde resultaat",
      "Levert de foley-tracks aan ter integratie in de geluidsmontage en eindmix:",
      "Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden",
      "Er is vooral contact binnen het eigen departement"
    ],
    "volgorde": 50
  },
  {
    "dep": "Geluid postproductie",
    "rol": "Foley editor",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Monteert de opgenomen foley-geluiden (zoals voetstappen en kleding) en zorgt dat foley synchroon loopt met beeld en realistisch klinkt binnen de context van de scène. Past timing, toon en dynamiek aan voor een natuurlijke inpassing in het geluidsbeeld en maakt creatieve keuzes bij technische of inhoudelijke problemen, binnen bestaande oplossingen. Werkt zelfstandig binnen de kaders van de opdracht t.b.v. het beoogde resultaat en stemt op specialistisch niveau af binnen het eigen geluidsdepartement, vanuit een informerende en licht beïnvloedende rol. Werkt samen met de Foley Artist, Sound Designer en Re-Recording Mixer richting de eindmix.",
    "bullets": [
      "Monteert vanuit specialistische vakkennis de opgenomen foley-geluiden (zoals voetstappen, kleding, objectbewegingen)",
      "Zorgt dat foley synchroon loopt met beeld en realistisch klinkt binnen de context van de scène",
      "Past timing, toon en dynamiek aan voor een natuurlijke inpassing in het geluidsbeeld",
      "Maakt creatieve keuzes bij technische of inhoudelijke problemen, binnen bestaande oplossingen",
      "Werkt zelfstandig binnen de kaders van de opdracht en draagt bij aan het beoogde eindresultaat",
      "Stemt af op specialistisch niveau binnen het eigen geluidsdepartement, met een informerende en licht beïnvloedende rol",
      "Werkt samen met de Foley Artist, Sound Designer en Re-Recording Mixer richting de eindmix"
    ],
    "volgorde": 60
  },
  {
    "dep": "Geluid postproductie",
    "rol": "Foley Recordist",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Neemt contactgeluiden op van de Foley Artist en mixt perspectief en ruimtelijkheid in realtime tijdens de opnamesessie. Zorgt voor optimale microfoonplaatsing, geluidskwaliteit en registratie en levert technisch hoogwaardige opnames. Maakt creatieve keuzes bij technische uitdagingen, binnen bestaande oplossingsmogelijkheden en stemt op specialistisch niveau af binnen het geluidsdepartement, vanuit een informerend en licht beïnvloedende rol. Werkt zelfstandig, op basis van specialistische vakkennis binnen de kaders van de opdracht t.b.v. het beoogde resultaat, bereidt opnames voor en draagt deze over aan de Foley Editor of voor verdere geluidsmontage.",
    "bullets": [
      "Neemt contactgeluiden van de Foley Artist op met specialistische opnamekennis",
      "Mixt perspectief en ruimtelijkheid in realtime tijdens de opnamesessie",
      "Zorgt voor optimale microfoonplaatsing, geluidskwaliteit en registratie",
      "Maakt creatieve keuzes bij technische uitdagingen, binnen bestaande oplossingsmogelijkheden",
      "Stemt af op specialistisch niveau binnen het geluidsdepartement, met een informerende en licht beïnvloedende rol",
      "Werkt zelfstandig binnen de kaders van de opdracht en levert technisch hoogwaardige opnames",
      "Bereidt opnames voor, ter overdracht aan de foley editor of voor verdere geluidsmontage"
    ],
    "volgorde": 70
  },
  {
    "dep": "Geluid postproductie",
    "rol": "In-House (post) producer (geluidsnabewerking)",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Stroomlijnt van de post workflow en de planning binnen een posthuis/faciliteit voor een deel van het postproductietraject  (bijv. editing, grading, audio en/of beeldnabewerking, VFX). Beheert onderdelen van budgetten die bij het posthuis ondergebracht zijn en onderhandelt binnen de (financiele) kaders over kosten en uitgaven. Ziet toe op de naleving van gemaakte afspraken, overziet consequenties van problemen en oplossingen voor aanverwante departementen en zorgt voor technische levering van het eindproduct in juiste formats. Werkt vanuit een autonome positie binnen de richtlijnen ten behoeve van het beoogde eindresultaat en fungeert als eerste aanspreekpunt voor klanten van het post-bedrijf en heeft contact dat adviserend en overtuigend is.",
    "bullets": [
      "Verricht specialistische werkzaamheden zoals het stroomlijnen van de post workflow en de planning binnen een posthuis/faciliteit",
      "Richt zich op een deel van het postproductietraject  (bijv. editing, grading, audio en/of beeldnabewerking, VFX)",
      "Beheert interne budgetten en stelt offertes voor producties  op",
      "Stuurt teams aan ten aanzien van het beoogde resultaat (Editors, Coloristen, Geluidsmensen) en bewaakt deadlines",
      "Zorgt voor technische levering van het eindproduct in juiste formats",
      "Overziet consequenties van problemen en oplossingen voor aanverwante departementen",
      "Is aanspreekpunt voor klanten en vertaalt feedback naar het team",
      "Heeft contact dat adviserend en overtuigend is"
    ],
    "volgorde": 80
  },
  {
    "dep": "Geluid postproductie",
    "rol": "Sound Effects editor",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Monteert de geluidseffecten ter versterking van het verhaal en de beleving en past specialistische kennis toe om geluidseffecten technisch en creatief vorm te geven. Werkt zelfstandig binnen de kaders van de opdracht ten behoeve van het beoogde resultaat en zorgt dat effecten ritmisch, inhoudelijk en technisch aansluiten op het beeld. Stemt af op inhoudelijk niveau binnen het eigen (geluids)departement, met een informerende en licht beïnvloedende rol. Maakt creatieve keuzes binnen bestaande oplossingsmogelijkheden bij technische of inhoudelijke knelpunten en werkt nauw samen met de Sound Designer en Re-Recording Mixer.",
    "bullets": [
      "Monteert geluidseffecten ter versterking van het verhaal en de beleving",
      "Zorgt dat effecten ritmisch, inhoudelijk en technisch aansluiten op het beeld",
      "Past specialistische kennis toe om geluidseffecten technisch en creatief vorm te geven",
      "Werkt zelfstandig binnen de kaders van de opdracht ten aanzien van het beoogde eindresultaat",
      "Stemt af op inhoudelijk niveau binnen het eigen (geluids)departement, met een informerende en licht beïnvloedende rol",
      "Maakt creatieve keuzes binnen bestaande oplossingsmogelijkheden bij technische of inhoudelijke knelpunten",
      "Werkt nauw samen met de Sound Designer en Re-Recording Mixer"
    ],
    "volgorde": 90
  },
  {
    "dep": "Geluid postproductie",
    "rol": "Dialoog Editor",
    "niveaus": [
      "G"
    ],
    "aliases": [],
    "omschrijving": "Monteert het opgenomen setgeluid, waaronder hoofdzakelijk dialogen. Brengt informatie vanuit verschillende bronnen bij elkaar om tot een goed eindresultaat te komen. Neemt besluiten om eventueel nieuwe bronnen te verwerven. Ontvangt kaders vanuit het Head of Department (HoD) ten aanzien van het beoogde eindresulaat. Doet inhoudelijke en technische voorstellen en geeft advies. Heeft overzicht over het werk dat wordt uitgevoerd in de pre- en de productiefase binnen aanverwante departementen. Begrijpt hierdoor de gevolgen van eerder in het proces genomen besluiten voor het eigen specialisme en acteert hierop met oplossingen. Er wordt dan ook departementoverstijgend gecommuniceerd.",
    "bullets": [
      "Monteert dialogen en het opgenomen setgeluid",
      "Reinig en optimaliseert dialogen (verwijdert ruis, bijgeluiden, storingen)",
      "Brengt geluidsmateriaal uit verschillende bronnen samen tot één coherent resultaat",
      "Neemt inhoudelijke beslissingen over vervanging of aanvulling van opnamen (bijv. ADR)",
      "Werkt toe naar een technisch schone en creatief passende dialoogtrack voor de eindmix",
      "Ontvangt kaders van het Head of Department (HoD) m.b.t. het gewenste eindresultaat",
      "Doet technische en inhoudelijke voorstellen en geeft advies binnen het geluidsdepartement",
      "Begrijpt gevolgen van keuzes uit eerdere fases (preproductie en setgeluid) en anticipeert daarop",
      "Communiceert departementoverstijgend met andere teams om afstemming en kwaliteit te waarborgen"
    ],
    "volgorde": 100
  },
  {
    "dep": "Geluid postproductie",
    "rol": "Re-Recording Mixer",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Brengt alle opgenomen en gemonteerde geluiden bij elkaar om tot een gebalanceerd eindresultaat te komen. Neemt besluiten om eventueel nieuwe bronnen te verwerven. Ontvangt kaders vanuit het Head of Department (HoD) t.b.v. het beoogde eindresultaat. Doet inhoudelijke en technische voorstellen en geeft advies. Heeft overzicht over het werk dat wordt uitgevoerd in de pre- en de productiefase binnen aanverwante departementen. Begrijpt hierdoor de gevolgen van eerder in het proces genomen besluiten voor het eigen specialisme en acteert hierop met oplossingen. Communiceert departementoverstijgend om afstemming te waarborgen en kwaliteit te leveren en levert de eindmix aan in de juiste formaten voor bioscoop, tv of online distributie. In Nederland is de Sound Designer/Supervising Sound Editor vaak ook zelf de Re-Recording Mixer.",
    "bullets": [
      "Brengt alle opgenomen en gemonteerde geluiden samen tot een gebalanceerde, filmische eindmix",
      "Neemt beslissingen over het gebruik van bestaande of nieuwe geluidsbronnen indien nodig",
      "Ontvangt creatieve en technische kaders van het Head of Department (HoD) en vertaalt deze naar de mix",
      "Doet inhoudelijke en technische voorstellen en adviseert over geluidsopbouw en -balans ten aanzien van het beoogde resultaat",
      "Begrijpt de impact van keuzes uit eerdere (pre)productiefases binnen aanverwante departementen en anticipeert daarop",
      "Communiceert departementoverstijgend om afstemming te waarborgen en kwaliteit te leveren",
      "Levert de eindmix aan in de juiste formaten voor bioscoop, tv of online distributie",
      "In Nederland is de Sound Designer/Supervising Sound Editor vaak ook zelf de Re-Recordings Mixer"
    ],
    "volgorde": 110
  },
  {
    "dep": "Geluid postproductie",
    "rol": "Supervising Sound Editor",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Stuurt het sound editing-team aan (dialogen, foley, SFX, ambiance) en bepaalt samen met regisseur en sound designer de geluidsaanpak en stijl. Beheert een deelbudget van een grote productie en maakt afspraken over de invulling daarvan met stakeholders binnen de postproductiefase. Overziet planningen en integreert wensen en consequenties voor departementen in de postproductie in het eigen aandachtsgebied. Signaleert knelpunten daarbinnen en doet voorstellen om die op te lossen. Fungeert als eerste aanspreekpunt van het soundpost-productieteam en heeft contact met verschillende departenten, die veelal zakelijk en beïnvloedend van aard zijn. In Nederland versmelt deze rol vaak met de Sound Designer en soms met de rol van Re-Recording Mixer.",
    "bullets": [
      "Stuurt het sound editing-team aan (dialogen, foley, SFX, ambiance)",
      "Bepaalt samen met regisseur en sound designer de geluidsaanpak en stijl",
      "Bewaakt de creatieve én technische kwaliteit van het totale geluidsbeeld",
      "Beheert het deelbudget voor geluid en maakt afspraken met betrokken stakeholders",
      "Plant en coördineert alle geluid-gerelateerde workflows binnen de postproductie",
      "Integreert wensen en afhankelijkheden van andere afdelingen (beeld, VFX, muziek, mixage)",
      "Signaleert knelpunten en doet proactief voorstellen voor oplossingen",
      "Fungeert als eerste aanspreekpunt van het soundpost-productieteam",
      "Onderhoudt zakelijke, beïnvloedende contacten met verschillende afdelingen en postproductiepartners",
      "Draagt eindverantwoordelijkheid voor de oplevering van het geluid voor de eindmix",
      "In Nederland versmelt deze rol vaak met de Sound Designer en soms met de rol van Re-Recording Mixer"
    ],
    "volgorde": 120
  },
  {
    "dep": "Geluid postproductie",
    "rol": "Sound Designer",
    "niveaus": [
      "I"
    ],
    "aliases": [],
    "omschrijving": "Geeft richting aan de creatie van en bewaakt totale geluidsbeeld tijdens de postproductiefase. Werkt binnen kaders van de Producent en regie. Voert specialistische werkzaamheden uit en/of coördineert werkzaamheden en/of stuurt inhoudelijk specialisten aan bij de ontwikkeling en uitvoering van werkzaamheden. Bij het oplossen van problemen is er ruimte voor het bedenken van creatieve en/of technisch alternatieven. Communiceert departementoverstijgend met andere specialisten. Heeft vaak nauw contact met de Producent en de Regisseur om te adviseren en te overtuigen.",
    "bullets": [
      "Geeft richting aan en bewaakt het totale geluidsbeeld in de postproductiefase",
      "Ontwerpt en creëert geluidseffecten, ambiance en geluidslagen passend bij het beeld",
      "Voert specialistisch werk uit en/of stuurt andere geluidsspecialisten inhoudelijk aan t.b.v. het beoogde eindresultaat",
      "Denkt mee in creatieve en technische oplossingen bij geluidsproblemen",
      "Werkt binnen de visie van regisseur en producent en stemt regelmatig met hen af ten aanzien van het beoogde resultaat",
      "Communiceert met andere afdelingen (edit, muziek, foley, mixage) voor een geïntegreerd eindresultaat"
    ],
    "volgorde": 130
  },
  {
    "dep": "Montage",
    "rol": "Montage-assistent",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Zorgt voor een gestroomlijnd werkproces en organiseert de montagekamer en -faciliteiten. Bereidt materiaal voor ten behoeve van de Editor en voert praktische werkzaamheden uit in de montagekamer. Verricht werkzaamheden vanuit vakinhoudelijke kennis en luistert en handelt naar verkregen informatie. Heeft inzicht in de gang van zaken om mee te denken, is communicatief vaardig en heeft contacten binnen en buiten het eigen departement met productie en postproductie.",
    "bullets": [
      "Zorgt voor een gestroomlijnd werkproces, organiseert de montagekamer en -faciliteiten",
      "Bereidt materiaal voor t.b.v. de Editor",
      "Voert praktische werkzaamheden uit in de montagekamer met eigen specifieke verantwoordelijkheden",
      "Verricht werkzaamheden vanuit vakinhoudelijke kennis",
      "Is communicatief vaardig en heeft contacten binnen en buiten het eigen departement waaronder met productie en postproductie",
      "Heeft inzicht in de gang van zaken om mee te denken en handelt naar verkregen informatie/aanwijzigingen t.b.v. het resultaat"
    ],
    "volgorde": 10
  },
  {
    "dep": "Montage",
    "rol": "Visual Effects Editor",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Maakt de tijdelijke VFX-composities en is verantwoordelijk voor de VFX-administratie tijdens en na de montage. Werkt zelfstandig binnen de kaders van de Editor, waarbij veel afstemming benodigd is die tamelijk specialistisch van aard is en een afstemmend en licht beïnvloedend karakter heeft. Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande mogelijkheden. Heeft contacten binnen en buiten het eigen departement waaronder met de VFX Supervisor.",
    "bullets": [
      "Maakt tijdelijke VFX-composities en draagt zorgt voor de administratie voor, tijdens en na de montage",
      "Werkt zelfstandig binnen de kaders die worden aangegeven door de Editor o.b.v. technische en inhoudelijke vakkennis",
      "Voert (specialistisch) overleg met de Editor t.b.v. de creatieve en technische workflow, waarbij de VFX Editor een licht beïnvloedende rol heeft",
      "Maakt (voor het oplossen van problemen) creatieve keuzes binnen bestaande mogelijkheden",
      "Heeft contacten binnen en buiten het eigen departement zoals met de VFX Supervisor",
      "Heeft inzicht in de gang van zaken en handelt naar verkregen informatie/aanwijzingen t.b.v. het resultaat"
    ],
    "volgorde": 20
  },
  {
    "dep": "Montage",
    "rol": "Assembly Editor",
    "niveaus": [
      "G"
    ],
    "aliases": [],
    "omschrijving": "Levert een specialistische vaktechnische bijdrage op het gebied van editing, zoals het maken van de eerste ruwe cut op basis van alle aangeleverde shots. Werkt zelfstandig binnen de kaders van de Editor, waarbij veel afstemming benodigd is die tamelijk specialistisch van aard is en een afstemmend en licht beïnvloedend karakter heeft. Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden.",
    "bullets": [
      "Maakt de eerste ruwe montage op basis van alle aangeleverde shots",
      "Werkt zelfstandig binnen de kaders die worden aangegeven door de Editor o.b.v. technische en inhoudelijke vakkennis",
      "Voert (specialistisch) overleg met de Editor om de werkzaamheden zo goed mogelijk in te passen in diens werkzaamheden en t.b.v. de creatieve en technische workflow, waarbij de Assembly Editor een licht beïnvloedende rol heeft",
      "Maakt (voor het oplossen van problemen) creatieve keuzes binnen bestaande mogelijkheden, die van invloed kunnen zijn op het eindresultaat",
      "Heeft inzicht in de gang van zaken en handelt naar verkregen informatie/aanwijzingen t.b.v. het resultaat"
    ],
    "volgorde": 30
  },
  {
    "dep": "Montage",
    "rol": "Editor",
    "niveaus": [
      "I"
    ],
    "aliases": [],
    "omschrijving": "Smeedt alle opgenomen en aangeleverde beelden en geluiden samen tot de exacte lengte en definitieve volgorde van de scenes. Diepgaande specialistische werkzaamheden op technisch en creatief gebied ten aanzien van beeld en/of coördineert alle creatieve, technische en logistieke werkzaamheden binnen een continue afstemmend proces of stuurt inhoudelijk specialisten aan bij de ontwikkeling en uitvoering van werkzaamheden. Werkt binnen de (inhoudelijke en financiële) kaders ten aanzien van het beoogde eindresultaat. Daarbij is de creatieve inbreng vanuit de eigen expertise groot. Oplossingen voor problemen moeten gezocht worden binnen bestaand materiaal, zijn bepalend voor het eindresultaat, en hebben consequenties voor andere departementen. Heeft diverse contacten die sturend en bëinvloedend zijn op het resultaat van de productie.",
    "bullets": [
      "Smeedt alle opgenomen en aangeleverde beelden en geluiden samen en bepaalt de definitieve volgorde van de scènes/shots",
      "Voert diepgaande specialistische werkzaamheden uit op technisch en creatief gebied ten aanzien van beeld en geluid",
      "Werkt binnen de (inhoudelijke en financiele) kaders van Producent en Regisseur ten aanzien van het beoogde eindresultaat",
      "Heeft een grote inhoudelijke en creatieve inbreng en verantwoordelijkheden",
      "Coördineert alle creatieve, technische en logistieke werkzaamheden binnen een continu afstemmend proces",
      "Stuurt inhoudelijk specialisten aan bij de ontwikkeling en uitvoering van werkzaamheden ten aanzien van het beoogde resultaat",
      "Zoekt oplossingen voor problemen binnen bestaand (film)materiaal die medebepalend zijn voor het eindresultaat en die consequenties kunnen hebben voor andere departementen",
      "Heeft diverse contacten die sturend en van invloed zijn op het eindresultaat van de productie",
      "Stuurt andere specialisten van het Montage-departement aan zoals Montage-assistent, Assembly-editor en Visual-Effects-editor"
    ],
    "volgorde": 40
  },
  {
    "dep": "Muziek",
    "rol": "Dirigent",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Leidt het orkest/ensemble in de uitvoering en opname van de score. Beoordeelt of het zelfstandig vervaardige eindproduct past bij het neer te zetten beeld en doet voorstellen om beter daarop aan te sluiten. Werkt binnen de aangegeven richtlijnen van de Componist ten behoeve van het eindresultaat en is het aanspreekpunt van de Componist tijdens opnamesessies. Vervult soms een adviserende rol binnen het eigen vakgebied.",
    "bullets": [
      "Leidt (en selecteert) het orkest/ensemble in de uitvoering en opname van de score",
      "Beoordeelt of het zelfstandig vervaardigde eindproduct past bij het neer te zetten beeld en doet voorstellen om beter daarop aan te sluiten",
      "Werkt binnen de aangegeven richtlijnen van de componist ten behoeve van het eindresultaat",
      "Is het aanspreekpunt van de componist tijdens opnamesessies",
      "Vervult soms een adviserende rol binnen het eigen vakgebied"
    ],
    "volgorde": 10
  },
  {
    "dep": "Muziek",
    "rol": "Muziek Mixer",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Mixt de opgenomen muziek tot een goed klinkend muzikaal product, in samenwerking met de componist. Voert dagelijks gelijksoortige taken uit en maakt zelfstandig technische keuzes ten behoeve van het beoogde resultaat. Laat het gemaakte product reviewen door anderen en vervult soms een adviserende rol binnen het eigen vakgebied.",
    "bullets": [
      "Mixt de opgenomen muziek tot een goed klinkend muzikaal product, in samenwerking met de componist",
      "Voert dagelijks zelfstandig gelijksoortige taken uit",
      "Maakt op eigen inbreng meerdere technische keuzes ten behoeve van het eindresultaat",
      "Laat het gemaakte product reviewen door anderen",
      "Vervult soms een adviserende rol binnen het eigen vakgebied"
    ],
    "volgorde": 20
  },
  {
    "dep": "Muziek",
    "rol": "Muziek opnametechnicus",
    "niveaus": [
      "F"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het opnemen van de uitgevoerde muziek. Beoordeelt of het zelfstandig vervaardige eindproduct past bij het neer te zetten beeld en doet voorstellen om beter daarop aan te sluiten. Voert dagelijks zelfstandig gelijksoortige taken uit en maakt naar eigen inzichten diverse, technische keuzes. Werkt binnen de aangegeven richtlijnen van de Componist ten behoeve van het eindresultaat en laat het gemaakte product reviewen door anderen. Vervult soms een adviserende rol binnen het eigen vakgebied.",
    "bullets": [
      "Is verantwoordelijk voor het opnemen van de uitgevoerde muziek",
      "Beoordeelt of het zelfstandig vervaardigde eindproduct past bij het neer te zetten beeld en doet voorstellen om beter daarop aan te sluiten",
      "Voert dagelijks zelfstandig gelijksoortige taken uit waarbij op eigen inbreng meerdere technische keuzes worden gemaakt",
      "Werkt binnen de aangegeven richtlijnen van de componist ten behoeve van het eindresultaat",
      "Laat het gemaakte product reviewen door anderen; Vervult soms een adviserende rol binnen het eigen vakgebied"
    ],
    "volgorde": 30
  },
  {
    "dep": "Muziek",
    "rol": "Muziek Producer",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het creatieve en technische proces van het opnemen, mixen en produceren van muzieknummers. Regelt composities, leidt opnamesessies en/of stelt wijzigingen voor aan instrumentatie, effecten en songteksten. Begeleidt de mix-, mastering- en opnametechnici en werkt binnen de aangegeven richtlijnen van de Componist ten behoeve van het eindresultaat. Heeft vooral contact binnen eigen departement.",
    "bullets": [
      "Is verantwoordelijk voor het creatieve en technische proces van het opnemen, mixen en produceren van muzieknummers",
      "Regelt composities en/of leidt opnamesessies en/of stelt wijzigingen voor aan instrumentatie, effecten en songteksten",
      "Werkt binnen de aangegeven richtlijnen van de Componist ten behoeve van het eindresultaat",
      "Begeleidt de mix-, mastering- en opnametechnici",
      "Heeft vooral contact binnen eigen departement"
    ],
    "volgorde": 40
  },
  {
    "dep": "Muziek",
    "rol": "Muzikant, Vocalist, Orkest",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Voert de gecomponeerde score van de componist uit door het bespelen van een instrument of door zang, in een studio. Werkt binnen de aangegeven richtlijnen van de Componist ten behoeve van het eindresultaat. Speelt zelfstandig binnen de gegeven kaders in op (on)voorbereide veranderende omstandigheden en weet vanuit eigen vakkennis wat daarvoor nodig is. Heeft vooral contact binnen eigen departement.",
    "bullets": [
      "Voert de gecomponeerde score van de componist uit door het bespelen van een instrument of door zang, in een studio",
      "Werkt binnen de aangegeven richtlijnen van de Componist ten behoeve van het eindresultaat",
      "Speelt zelfstandig binnen de gegeven kaders in op (on)voorbereide veranderende omstandigheden en weet vanuit eigen vakkennis wat daarvoor nodig is",
      "Heeft vooral contact binnen eigen departement"
    ],
    "volgorde": 50
  },
  {
    "dep": "Muziek",
    "rol": "Orkestrator",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het overzetten van de, door de componist gecomponeerde, demo score naar kloppende bladmuziek voor de desbetreffende muzikanten, het ensemble of orkest. Beoordeelt of het zelfstandig vervaardige eindproduct past bij het neer te zetten beeld en doet voorstellen om beter daarop aan te sluiten. Werkt binnen de aangegeven richtlijnen van de componist ten behoeve van het eindresultaat en laat het gemaakte product reviewen door anderen. Vervult soms een adviserende rol binnen het eigen vakgebied.",
    "bullets": [
      "Is verantwoordelijk voor het overzetten van de, door de componist gecomponeerde, demo score naar kloppende bladmuziek voor de desbetreffende muzikanten/ ensemble/ orkest",
      "Beoordeelt of het zelfstandig vervaardigde eindproduct past bij het neer te zetten beeld en doet voorstellen om beter daarop aan te sluiten",
      "Werkt binnen de aangegeven richtlijnen van de componist ten behoeve van het eindresultaat",
      "Laat het gemaakte product reviewen door anderen",
      "Vervult soms een adviserende rol binnen het eigen vakgebied"
    ],
    "volgorde": 60
  },
  {
    "dep": "Muziek",
    "rol": "Music Supervisor",
    "niveaus": [
      "H"
    ],
    "aliases": [],
    "omschrijving": "Vertaalt voorstellen van het HoD (Head of Department) ten aanzien van het beoogde resultaat naar creatieve resultaten door het uitvoeren van specialistische werkzaamheden met een diepgaand karakter, zoals ondersteunen componist, clearen van rechten, plaatsen/syncen van songs. Signaleert verbeteringen en voert die zelfstandig door. Draagt hiermee zorg voor technisch goed afgewerkte uitvoering van muziek, samenhang en interpretatie. Geeft advies en fungeert vanuit het eigen specialisme als eerste aanspreekpunt voor het HoD (Head of Department) tijdens onder andere opnamesessies.",
    "bullets": [
      "Vertaalt voorstellen van het HoD (Head of Department) ten aanzien van het beoogde resultaat naar creatieve resultaten door het uitvoeren van specialistische werkzaamheden met een diepgaand karakter, zoals ondersteunen componist, clearen van rechten, plaatsen/syncen van songs",
      "Signaleert verbeteringen en voert die zelfstandig door",
      "Draagt hiermee zorg voor technisch goed afgewerkte uitvoering van muziek, samenhang en interpretatie",
      "Geeft advies en fungeert vanuit het eigen specialisme als eerste aanspreekpunt voor het HoD (Head of Department) tijdens onder andere opnamesessies"
    ],
    "volgorde": 70
  },
  {
    "dep": "Muziek",
    "rol": "Componist",
    "niveaus": [
      "I"
    ],
    "aliases": [],
    "omschrijving": "Componeert en schrijft technisch muziek uit, passend bij het beeld, de sfeer en kaders gezet door regie. Overziet het volledige gewenste eindresultaat. Maakt de creatieve vertaling op basis van een diepgaande analyse, geeft advies en doet voorstellen. Geeft sturing aan de werkzaamheden van een team, die vaktechnische en/of specialistische werkzaamheden uitvoeren. Overtuigt stakeholders van de goede keuze en beïnvloedt om die keuze te nemen die het beste is voor de film.",
    "bullets": [
      "Componeert en schrijft technisch muziek uit, passend bij het beeld, de beoogde sfeer en kaders van regie",
      "Overziet het volledige gewenste eindresultaat",
      "Maakt de creatieve vertaling op basis van een diepgaande analyse, geeft advies en doet voorstellen",
      "Geeft sturing aan de werkzaamheden van een team, die vaktechnische en/of specialistische werkzaamheden uitvoeren",
      "Overtuigt stakeholders van de goede keuze en beïnvloedt om die keuze te nemen die het beste is voor de productie"
    ],
    "volgorde": 80
  },
  {
    "dep": "Productie geluid",
    "rol": "2e Ass. Boom Operator",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Bedient de boom ten behoeve van de geluidsopname. Werkt vanuit het eigen specialisme binnen kaders van het Head of Department (HoD) en regie ten aanzien van het eindresultaat. Ruimte voor beslissingen over eigen werk bestaat met consequenties voor het opnamegeluid en de geluidsnabewerking. Verricht voorbereidende en uitvoerende taken binnen een bepaalde productiefase. Er is sprake van fysiek belastende houdingen tijdens uitvoeren van werk. Is communicatief vaardig en heeft contacten binnen en buiten het eigen departement. Luisteren en handelen naar verkregen informatie is vereist.",
    "bullets": [
      "Bedient de tweede of derde boom t.b.v. de geluidsopnames",
      "Voert uitvoerende taken uit met een wederkerend karakter",
      "Voert werkzaamheden uit o.b.v. eigen inzicht, binnen de kaders van de instructies en een gestructureerde aanpak",
      "Contacten zijn voornamelijk gebaseerd op uitwisselen van informatie en vinden plaats binnen het eigen departement"
    ],
    "volgorde": 10
  },
  {
    "dep": "Productie geluid",
    "rol": "1e Boom Operator",
    "niveaus": [
      "F"
    ],
    "aliases": [
      "Boomer",
      "Boom operator"
    ],
    "omschrijving": "Bedient de boom ten behoeve van de geluidsopname. Werkt vanuit het eigen specialisme binnen kaders van het Head of Department (HoD) en regie ten aanzien van het eindresultaat. Ruimte voor beslissingen over eigen werk bestaat met consequenties voor het opnamegeluid en de geluidsnabewerking. Verricht voorbereidende en uitvoerende taken binnen een bepaalde productiefase. Er is sprake van fysiek belastende houdingen tijdens uitvoeren van werk. Is communicatief vaardig en heeft contacten binnen en buiten het eigen departement. Luisteren en handelen naar verkregen informatie is vereist.",
    "bullets": [
      "Bedient de boom ten behoeve van de geluidsopname",
      "Werkt zelfstandig vanuit het eigen specialisme binnen ontvangen kaders van de Head of Department (HoD) ten aanzien van het beoogde eindresultaat",
      "Neemt beslissingen over het eigen werk die invloed hebben op opnamekwaliteit en nabewerking",
      "Werkt nauw samen met camera- en regieteam om microfoons correct te plaatsen",
      "Minimaliseert storende geluiden op de set door actief te luisteren en direct te handelen",
      "Plaatst en verwijdert zenders bij castleden, waar nodig in een afgeschermde omgeving",
      "Stelt het logistieke boomplan op en stuurt de 2e en eventueel 3e boom operator aan",
      "Verricht voorbereidende en uitvoerende taken binnen een bepaalde productiefase",
      "Er is sprake van fysiek belastende houdingen tijdens uitvoeren van werk",
      "Is communicatief vaardig en heeft contacten binnen en buiten het eigen departement",
      "Luisteren en handelen naar verkregen informatie is vereist"
    ],
    "volgorde": 20
  },
  {
    "dep": "Productie geluid",
    "rol": "ENG geluidspersoon",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor geluidsopnamen tijdens korte periodes of losse draaidagen, veelal voor journalistieke, informatieve, infotainment- of reality-producties. Voert werkzaamheden doorgaans uit in samenwerking met een ENG-camerapersoon, conform de richtlijnen die zijn aangegeven door de Head of Department. Ruimte voor beslissingen over eigen werk bestaat met consequenties voor het opnamegeluid en de geluidsnabewerking. Verricht zelfstandig specialistische, voorbereidende en uitvoerende taken binnen een bepaalde productiefase. Heeft contact met andere departementen die meestal adviserend en/of beïnvloedend van aard zijn.",
    "bullets": [
      "Is verantwoordelijk voor geluidsopnamen tijdens korte periodes of losse draaidagen, veelal voor journalistieke, informatieve, infotainment- of reality-producties",
      "Voert werkzaamheden doorgaans uit in samenwerking met een ENG-camerapersoon, conform de richtlijnen die zijn aangegeven door de Head of Department",
      "Ruimte voor beslissingen over eigen werk bestaat met consequenties voor het opnamegeluid en de geluidsnabewerking",
      "Verricht zelfstandig specialistische, voorbereidende en uitvoerende taken binnen een bepaalde productiefase",
      "Heeft adviserend en/of beïnvloedend contact met andere departementen"
    ],
    "volgorde": 30
  },
  {
    "dep": "Productie geluid",
    "rol": "Geluidsassistent",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Plaatst en verwijdert zenders bij castleden, treft voorbereidingen en controleert de geluidsopnames. Heeft praktische kennis en inzicht in de gang van zaken op de set en denkt mee over ad hoc oplossingen. Voert werkzaamheden uit ter ondersteuning van het geluidsdepartement op praktisch, technisch en logistiek vlak, zowel in de pré-productie als tijdens draaidagen. Contacten zijn voornamelijk gebaseerd op uitwisselen van informatie en vinden plaats binnen het eigen departement.",
    "bullets": [
      "Plaatst en verwijdert zenders bij castleden, waar nodig in een afgeschermde omgeving",
      "Ondersteunt bij het uitladen, opbouwen, aansluiten en inpakken van geluidsapparatuur, inclusief kabelaanleg",
      "Controleert de opnamekwaliteit en verzorgt (gedeeltelijke) datahandling",
      "Ondersteunt waar mogelijk bij akoestische optimalisatie van de locatie",
      "Voert ondersteunende en uitvoerende werkzaamheden uit binnen het geluidsdepartement bij de geluidsopnamen tijdens voorbereidingen en op de set",
      "Heeft praktische kennis en inzicht in de gang van zaken op de set",
      "Werkt binnen de kaders van de Head of Department (HoD) en denkt mee over ad hoc oplossingen",
      "Onderhoudt contact met het locatie-departement en productiemedewerkers (PA’s) m.b.t. geluidsopstellingen",
      "Contacten zijn voornamelijk gebaseerd op uitwisselen van informatie en vinden plaats binnen het eigen departement"
    ],
    "volgorde": 40
  },
  {
    "dep": "Productie geluid",
    "rol": "Hoofd Geluid / Production Sound Mixer (PSM)",
    "niveaus": [
      "I"
    ],
    "aliases": [],
    "omschrijving": "Verricht specialistische werkzaamheden op het creatieve en technische gebied van geluid op set, zoals het beoordelen, interpreteren en analyseren van een script en het maken van de vertaling naar het benodigde geluid. Bij het oplossen van problemen moet aan consequenties voor andere departementen gedacht worden, zoals postproductie. Kan zorgdragen voor de werkverdeling of aansturing van de werkzaamheden van een klein team. De werkzaamheden zijn creatief, vaktechnisch en/of specialistisch van aard. Contacten zijn adviserend en overtuigend. Draagt zorg voor de realisatie van de teamresultaten.",
    "bullets": [
      "Interpreteert en analyseert het script en vertaalt dit naar een inhoudelijk startpunt voor sounddesign en een technisch opnameplan",
      "Creëert en bewaakt de geluidsstijl in samenwerking met regie, Director of Photography (DOP) en editorial",
      "Biedt meertalige en vertaalondersteuning tijdens het opnameproces van documentaire geënte draaidagen",
      "Stuurt het geluidsteam aan (1e boom operator, geluidsassistenten) en bewaakt het teamresultaat",
      "Beheert budget en stelt het equipmentpakket samen, afgestemd op de gewenste geluidsstijl en de productie-eisen",
      "Fungeert als eerste aanspreekpunt voor de productie op het gebied van geluid en maakt inhoudelijke keuzes, eventueel in overleg met de Sounddesigner indien aanwezig",
      "Communiceert met castleden over zowel inhoudelijke alsmede  privacy gerelateerde beslissingen",
      "Verzorgt en bewaakt het IFB-signaal en de dailies-mix (privacygevoelige informatie)",
      "Verricht specialistische werkzaamheden o.b.v. creatieve en technische kennis en vaardigheden binnen het vakgebied geluid",
      "Neemt bij het oplossen van problemen de consequenties voor andere departementen in acht,  zoals postproductie",
      "Is eindverantwoordelijk voor het overdragen van alle geluidsbestanden, inclusief recorderfiles, eventuele zenderopnamen en geluidsrapporten",
      "Registreert speciale geluiden die in postproductie nodig zijn",
      "Is (mede)verantwoordelijk voor playback, on-set composities en samenwerking met de muziekafdeling m.b.t. af te spelen content op de set",
      "Contacten zijn adviserend en overtuigend"
    ],
    "volgorde": 50
  },
  {
    "dep": "Regie",
    "rol": "3rd Assistant Director",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Ondersteunt de 1st AD bij setwerkzaamheden. Is actief rondom de set en zorgt tijdens opnames voor een effectieve communicatie met productie, crew en cast. Speelt in op onvoorziene omstandigheden die zich buiten het blikveld van de 1st AD afspelen. Begeleidt en geeft aanwijzingen aan de figuranten volgens richtlijnen van de 1st AD.",
    "bullets": [
      "Ondersteunt de 1st AD bij setwerkzaamheden",
      "Is actief rondom de set",
      "Zorgt tijdens opnames voor een effectieve communicatie tussen productie, crew en cast",
      "Speelt in op onvoorziene omstandigheden die zich buiten het blikveld van de 1st AD afspelen",
      "Begeleidt en geeft aanwijzingen aan de figuranten volgens richtlijnen van de 1st AD"
    ],
    "volgorde": 10
  },
  {
    "dep": "Regie",
    "rol": "Figurantenbegeleider",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Coördineert, begeleidt en stuurt (grote groepen) figuranten aan, volgens de richtlijnen van de Regisseur en 1st AD. Contacten zijn gericht op het ophalen en uitwisselen van informatie met diverse departementen, zoals kleding, make-up en haar en productie.",
    "bullets": [
      "Coördineert, begeleidt en stuurt (grote groepen) figuranten aan, volgens de richtlijnen van de Regisseur en 1st AD",
      "Heeft contact met diverse departementen, zoals kleding, make-up en haar en productie t.b.v. het ophalen en uitwisselen van informatie"
    ],
    "volgorde": 20
  },
  {
    "dep": "Regie",
    "rol": "Intimiteits Coordinator",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Begeleidt en ondersteunt Acteurs en regie tijdens de repetities en opnamen van intieme scènes door veilige en respectvolle werkomstandigheden te creëren. Stemt wensen af met de Regisseur, 1st AD en/of productie en vertaalt deze naar concrete handelingen, binnen de grenzen van Acteurs.",
    "bullets": [
      "Begeleidt en ondersteunt Acteurs en regie tijdens de repetities en opnamen van intieme scènes door veilige en respectvolle werkomstandigheden te creëren",
      "Stemt wensen af met de Regisseur, 1st AD en/of productie en vertaalt deze naar concrete handelingen, binnen de grenzen van Acteurs"
    ],
    "volgorde": 30
  },
  {
    "dep": "Regie",
    "rol": "Script-Continuiteit",
    "niveaus": [
      "E"
    ],
    "aliases": [],
    "omschrijving": "Bewaakt in overleg met de Regisseur scriptconsistentie en continuïteit, en controleert de detailuitvoering op de set, onder meer wat betreft garderobe, rekwisieten, setdressing, haar, make-up en handelingen van de acteurs. Houdt rapporten bij van op de set gemaakte technische en inhoudelijke keuzes ten behoeve van de montage en dagrapporten ten behoeve van productie. Is tijdens draaidagen gebonden aan de set. Heeft diverse contacten die afstemmend en licht adviserend zijn over de uitvoering van werkzaamheden.",
    "bullets": [
      "Bewaakt i.o.m. de Regisseur scriptconsistentie en continuïteit, en controleert de detailuitvoering op de set onder meer wat betreft garderobe, rekwisieten, setdressing, haar, make-up en handelingen van de Acteurs",
      "Houdt t.b.v. montage rapporten bij van op de set gemaakte technische en inhoudelijke keuzes en dagrapporten t.b.v. productie",
      "Is tijdens draaidagen gebonden aan de set",
      "Heeft diverse contacten die afstemmend en licht adviserend zijn over de uitvoering van werkzaamheden"
    ],
    "volgorde": 40
  },
  {
    "dep": "Regie",
    "rol": "2nd Assistant Director",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Fungeert tijdens de draaiperiode en op coördinerend vlak als rechterhand van de 1st AD. Is de link tussen 1st AD en overige departmenten en werkenden op en rondom de set. Bereidt in overleg met de 1st AD en productieleider callsheets voor en zorgt dat iedereen over de juiste informatie beschikt.",
    "bullets": [
      "Is de rechterhand van de 1st AD tijdens de draaiperiode",
      "Is de link tuseen 1st AD en overige departments en werkenden op en rondom de set",
      "Bereidt in overleg met de 1st AD en productieleider de callsheets voor en zorgt dat iedereen over de juiste informatie beschikt"
    ],
    "volgorde": 50
  },
  {
    "dep": "Regie",
    "rol": "Regie-assistent",
    "niveaus": [
      "F"
    ],
    "aliases": [],
    "omschrijving": "Is tijdens de preproductie en draaiperiode op inhoudelijk vlak de rechterhand van de Regisseur. Denkt inhoudelijk mee, controleert, corrigeert en borgt de inhoudelijke lijn en fungeert als link tussen regie en productie, cast en overige departmenten voor informatie-uitwisseling. Is betrokken bij inhoudelijke beslissingen over cast, figuratie, planning en organisatie. De Regie-assistent is tijdens draaidagen aanwezig maar ook daarbuiten.",
    "bullets": [
      "Is tijdens de preproductie en draaiperiode op inhoudelijk vlak de rechterhand van de Regisseur",
      "Denkt inhoudelijk mee, controleert, corrigeert en borgt de inhoudelijke lijn",
      "Fungeert als link tussen regie en productie, cast en overige departmenten en draagt hiertoe zorg voor informatie-uitwisseling Is betrokken bij inhoudelijke beslissingen over cast, figuratie, planning en organisatie;",
      "Administreert alle inhoudelijke keuzes",
      "Kan, in afstemming met de Regisseur, zelfstandig beslissingen nemen ten behoeve van het draaiproces",
      "Is tijdens draaidagen aanwezig op de set maar kan ook daarbuiten voorbereidende werkzaamheden uitvoeren of superviseren"
    ],
    "volgorde": 60
  },
  {
    "dep": "Regie",
    "rol": "Story Board Artist",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Creëert visuele vertalingen van het script in schetsvorm ten behoeve van heldere communicatie tijdens de preproductiefase en/of de draaiperiode. Werkt zelfstandig binnen gegeven kaders en in afstemming met de Regisseur en Director of Photography (DOP) om scènes te visualiseren. De werkzaamheden zijn tamelijk specialistisch van aard en biedt voortschrijdende informatie en inzichten ten behoeve van het beoogde resultaat. Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden.",
    "bullets": [
      "Creëert visuele vertalingen in schetsvorm van het script t.b.v. heldere communicatie in de voorbereidingen van de productie",
      "Werkt hiertoe samen met de Regisseur en Director of Photography (DOP)",
      "Werkt zelfstandig binnen de kaders van de opdracht ten behoeve van het beoogde resultaat",
      "Afstemming is specialistisch, informerend en licht beïnvloedend",
      "Creatieve keuzes worden gemaakt binnen reeds bestaande oplossingsmogelijkheden"
    ],
    "volgorde": 70
  },
  {
    "dep": "Regie",
    "rol": "Stunt Coordinator",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Bedenkt, repeteert en begeleidt fysieke stunts met cast en/of Stuntpersoon op basis van concrete richtlijnen vanuit regie (inhoudelijk/creatief) en uitvoerende productie (logistiek/veiligheid) ten behoeve van het beoogde resultaat. Coördineert de uitvoering in overleg en op aanwijzing van regie, production design en camera en stuurt het stuntteam aan door het werk te verdelen en inhoudelijke aanwijzingen en/of instructies te geven.",
    "bullets": [
      "Ontwerpt, repeteert en coördineert stunts",
      "Werkt in overleg met regie, production design en camera",
      "Analyseert richtlijnen van de Head of Department over het gewenste resultaat",
      "Stuurt het stuntteam aan door werk te verdelen en inhoudelijke instructies te geven"
    ],
    "volgorde": 80
  },
  {
    "dep": "Regie",
    "rol": "Stuntpersoon",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Geeft fysieke stunts vorm en voert deze uit volgens aanwijzingen van de Stunt Coördinator. Kan fungeren als stand-in voor acteurs en houdt rekening met timing, camerastandpunten en eventuele props, ten behoeve van het beoogde resultaat. Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen departement.",
    "bullets": [
      "Voert stunts uit op aanwijzing van de Stunt Coördinator",
      "Analyseert richtlijnen over het gewenste resultaat en zet deze om in actie",
      "Brengt het stuntontwerp tot leven",
      "Kan stand in zijn voor Acteurs",
      "Heeft contact binnen het eigen departement om informatie op te halen en uit te wisselen"
    ],
    "volgorde": 90
  },
  {
    "dep": "Regie",
    "rol": "1st Assistant Director",
    "niveaus": [
      "H"
    ],
    "aliases": [],
    "omschrijving": "Bewaakt en coordineert de opzet en uitvoering van de opname logistiek en planning van de productie. Heeft de bevoegdheid om werkzaamheden over te dragen aan leden van de crew. Heeft een controlerende rol, signaleert afwijkingen en blijft actief op de hoogte van actuele ontwikkelingen op het departement. Coördineert de opstelling van callsheets. Heeft diverse contacten over de departementen heen, o.a. contact met heads of department om af te stemmen, te coördineren en/of te beïnvloeden.",
    "bullets": [
      "Maakt tijdens de preproductie, in overleg met de regisseur, productie en Heads of Department, de draaiplanning",
      "Is tijdens de draaiperiode hoofdverantwoordelijk voor het handhaven, behalen en waar nodig bijstellen van deze planning",
      "Is soms verantwoordelijk voor het maken van de breakdown",
      "Zorgt er tijdens de draaidagen voor dat de Regisseur, uitvoerende productie en andere afdelingen goed samenwerken en op één lijn zitten",
      "Kan set-werkzaamheden aansturen en aanpassen om het beste eindresultaat te bereiken",
      "Superviseert de vervaardiging van de callsheets",
      "Draagt medeverantwoordelijkheid voor veiligheid op of rondom de set"
    ],
    "volgorde": 100
  },
  {
    "dep": "Regie",
    "rol": "Opnameleider",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Ziet toe op de draaiplanning op de set zodat alle scènes gedraaid worden. Zorgt, gedurende opnames, dat crew en cast op de hoogte zijn van het verloop van de dag. Kijkt vooruit en maakt een inschatting welke scènes haalbaar zijn binnen de tijd die er is en stelt de draaiplanning waar nodig bij, in overleg met productie en regie. Houdt contact met heads of department voor coördinatie en afstemming van de grote lijnen en werkt nauw samen met de Regieassistenten, Productieassistenten en Locatiemanager voor setwerkzaamheden en logistiek op de set.",
    "bullets": [
      "Zorgt dat alle scènes gedraaid worden",
      "Houdt, gedurende opnames, de crew op de hoogte van draaiplanning",
      "Kijkt vooruit en maakt een inschatting welke scènes haalbaar zijn binnen de tijd die er is en stelt waar nodig de draaiplanning bij in overleg met productie en regie",
      "Coördineert setwerkzaamheden en logistiek op de set en zorgt dat cast en crew geïnformeerd zijn",
      "Werkt nauw samen met heads of department en assistenten voor afstemming en coördinatie"
    ],
    "volgorde": 110
  },
  {
    "dep": "Regie",
    "rol": "Regisseur",
    "niveaus": [
      "J",
      "K"
    ],
    "aliases": [],
    "omschrijving": "Visualiseert het script en vormt de creatieve inhoud en de overdacht van de vertelling door het bepalen van look en feel, camera-en shot compositie, acteerprestaties, montage, muziek, visual effects, beeld- en geluidsafwerking. Heeft de creatieve verantwoordelijkheid voor het eindproduct. Stuurt processen aan die bepalend zijn voor het creatieve resultaat, zoals het vormen van de creatieve inhoud en de overdracht hiervan naar alle departementen. Er is brede specialistische kennis nodig van meerdere met elkaar verwant houdende departementen. De problemen betreffen veelal (een substantieel deel) van de gehele productie. Geeft bepalende inhoudelijke en creatieve sturing aan crew binnen meerdere, uiteenlopende departementen. Beslissingen hebben grote gevolgen voor de productie als geheel (afbreukrisico). Er is sprake van beïnvloeding van in- en externe personen (van de productie).",
    "bullets": [
      "Draagt de creatieve eindverantwoordelijkheid voor een complexe productie (daarbij is sprake van bijv. groot budget, veel draaidagen, internationale coproducties, meerdere locaties binnen en buiten, grote cast en crew etc.)",
      "Stuurt tijdens preproductie, productie en postproductie, professionals en processen aan die creatief medebepalend zijn voor het beoogde eindproduct",
      "Visualiseert het script en bepaalt de look & feel",
      "Selecteert in afstemming met Producent en Casting Director de cast en houdt repetities",
      "Stuurt de Cast en de Heads of Department aan",
      "Begeleidt acteurs in hun interpretatie van de personages en zorgt dat scènes en karakters de gewenste emotie en spanning krijgen",
      "Beschikt over specialistische kennis van meerdere, met elkaar verweven disciplines en departementen",
      "Neemt beslissingen die directe impact hebben op zowel de kwaliteit van het eindresultaat als het financiële en organisatorische verloop van de productie (afbreukrisico)",
      "Is in staat om te navigeren tussen uiteenlopende belangen van interne (Producent(en), HoD's) en externe stakeholders (zoals opdrachtgevers en financiers) en daarbij de artistieke visie te bewaken"
    ],
    "volgorde": 120
  },
  {
    "dep": "Scenario",
    "rol": "Junior Schrijver",
    "niveaus": [
      "D"
    ],
    "aliases": [],
    "omschrijving": "Verricht als schrijver in opleiding werkzaamheden binnen ondersteunende processen die uitgevoerd worden binnen het departement. Draagt zorg voor het nabellen of verzenden van documentatie. Leert het vakgebied en de processen daarbinnen nog kennen, veel voorkomende werkzaamheden zijn het notuleren van scenario sessies, ondersteuning bij research, het proeflezen van scenario's en/of het coördineren van de logistieke organisatie van de scenario's. Contacten zijn gericht op het uitwisselen van informatie en afstemmen met anderen, zoals het beantwoorden van praktische vragen of het inplannen van afspraken.",
    "bullets": [
      "Verricht als schrijver in opleiding werkzaamheden ten behoeve van ondersteunende processen in het schrijfteam",
      "Draagt zorg voor het nabellen of verzenden van documentatie",
      "Leert het vakgebied en de processen daarbinnen nog kennen",
      "Notuleert waar nodig scenario sessies",
      "Ondersteunt bij research, het proeflezen van scenario's en/of het coördineren van de logistieke organisatie van de scenario’s",
      "Contacten zijn gericht op het uitwisselen van informatie en afstemmen met anderen, zoals het beantwoorden van praktische vragen of het inplannen van afspraken"
    ],
    "volgorde": 10
  },
  {
    "dep": "Scenario",
    "rol": "Dramaturg",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Analyseert vanuit vakkennis een treatment of scenario hoofdzakelijk op structuur en ontwikkeling en denkt mee vanuit zowel de Scenarioschrijver(s) als Regisseur(s), producent en eventuele omroep of andere geldschieter. Fungeert als sparringpartner voor aanpassingen die het script verbeteren of die noodzakelijk zijn door specifieke omstandigheden, zoals bijvoorbeeld financiering.",
    "bullets": [
      "Analyseert vanuit vakkennis een treatment of scenario op structuur en inhoudelijke ontwikkeling, waaronder spanningsboog, thematiek en geloofwaardigheid van personages",
      "Denkt mee vanuit zowel de Scenarioschrijver(s) als Regisseur(s), producent en eventuele omroep of andere geldschieter",
      "Fungeert als sparringpartner voor aanpassingen die het script verbeteren of die noodzakelijk zijn door specifieke omstandigheden, zoals bijvoorbeeld financiering"
    ],
    "volgorde": 20
  },
  {
    "dep": "Scenario",
    "rol": "Redacteur",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Analyseert scenario's en formats en voert inhoudelijke wijzigingen door in het scenario gericht op het goed integreren van een scenario binnen het geheel van een serie of documentaire. Werkt zelfstandig vanuit vakkennis en stemt de inhoud af op de financiële kaders ten aanzien van het beoogde resultaat. Werkt aan de hand van aanwijzingen van de Producent en/of externe partijen.",
    "bullets": [
      "Analyseert scenario's en formats en voert inhoudelijke wijzigingen door in het scenario gericht op het goed integreren van een scenario binnen het geheel van een serie of documentaire",
      "Werkt zelfstandig vanuit vakkennis en stemt de inhoud af op de financiële kaders ten aanzien van het beoogde resultaat",
      "Werkt aan de hand van aanwijzingen van de Producent en/of externe partijen"
    ],
    "volgorde": 30
  },
  {
    "dep": "Scenario",
    "rol": "Script Consultant/ Script Adviseur",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Analyseert vanuit vakkennis een treatment of scenario op structuur, karakterontwikkeling, plot, thematiek, genre of een specifiek gewenst onderdeel. Adviseert en biedt suggesties voor aanpassingen in het script - soms vanuit de inhoud, soms vanuit productionele of financiële overwegingen. Het betreft een autonome positie die vaak eenmalig voor een korte periode en een concreet doel wordt betrokken bij het schrijfproces.",
    "bullets": [
      "Analyseert vanuit vakkennis een treatment of scenario op structuur, karakterontwikkeling, plot, thematiek, genre of een specifiek gewenst onderdeel",
      "Adviseert en biedt suggesties voor aanpassingen in het script - soms vanuit de inhoud, soms vanuit productionele of financiële overwegingen",
      "Verricht specialistische werkzaamheden vanuit een autonome positie die vaak eenmalig voor een korte periode en een concreet doel wordt betrokken bij het schrijfproces"
    ],
    "volgorde": 40
  },
  {
    "dep": "Scenario",
    "rol": "Researcher",
    "niveaus": [
      "G"
    ],
    "aliases": [],
    "omschrijving": "Analyseert, interpreteert en komt met verbetervoorstellen voor de uitwerking van een idee tot een pitch en/of scenario. Voert regelende, ondersteunende en administratieve werkzaamheden uit binnen de gegeven kaders, zoals het zorgdragen voor de beschikbaarheid van documenten en/of (toestemmings)formulieren. Kan onderzoek uitvoeren in het kader van authenticiteit. De werkzaamheden beperken zich tot één vakgebied. Afstemmen en overtuigen is nodig om schrijvers te begeleiden en de werkzaamheden uit te voeren.",
    "bullets": [
      "Analyseert, interpreteert en komt met verbetervoorstellen voor de uitwerking van een idee tot een pitch en/of scenario",
      "Voert regelende, ondersteunende en administratieve werkzaamheden",
      "Draagt zorg voor de beschikbaarheid van documenten en/of (toestemmings)formulieren",
      "Kan onderzoek uitvoeren in het kader van authenticiteit en zorgt ervoor dat de schrijvers over de juiste (historische) informatie/feiten/details beschikken",
      "De werkzaamheden beperken zich tot één vakgebied",
      "Afstemmen en overtuigen is nodig om schrijvers te begeleiden en de werkzaamheden uit te voeren"
    ],
    "volgorde": 50
  },
  {
    "dep": "Scenario",
    "rol": "Co-scenarist",
    "niveaus": [
      "H"
    ],
    "aliases": [],
    "omschrijving": "Schrijft onderdelen van documenten, zoals scenarioversies, treatments, karakterbeschrijvingen en pitches, ten behoeve van de ontwikkeling en eventuele aanpassing (van een gedeelte) van een scenario. Het betreft een autonome positie, waarbij vrijwel altijd verificatie mogelijk is. Werkt dan ook binnen de kaders van een Scenarist en/of Hoofd Schrijver. Is op de hoogte van de richting van de productie en weet dat te vertalen naar een beperkt aantal documenten en producten. Doet voorstellen en geeft adviezen die uitstralen op de totale productie. Kent de verhaallijnen die door de Scenarist en/of Hoofd Schrijver binnen de kaders van het beoogde eindproduct zijn geschetst en vult deze verder aan. Heeft onder andere contact met de Scenarist en/of de Hoofd Schrijver. Deze contacten zijn veelal adviserend en/of soms beïnvloedend.",
    "bullets": [
      "Schrijft onderdelen van documenten zoals scenarioversies, treatments, karakterbeschrijvingen en pitches, t.b.v. de ontwikkeling en/of aanpassing van (delen van) een scenario",
      "Werkt vanuit een autonome positie, waarbij vrijwel altijd verificatie mogelijk is",
      "Werkt binnen de kaders die zijn gesteld door een Scenarist en/of Hoofd Schrijver en/of Showrunner",
      "Is op de hoogte van de richting van de productie en vertaalt dit naar een beperkt aantal documenten en producten",
      "Doet voorstellen en geeft adviezen die invloed kunnen hebben op de totale productie",
      "Kent de verhaallijnen zoals geschetst door de Scenarist en/of Hoofd Schrijver en/of Showrunner en vult deze verder aan",
      "Heeft contact met de Scenarist en/of Hoofd Schrijver en/of Showrunner en deze contacten zijn veelal adviserend en soms beïnvloedend"
    ],
    "volgorde": 60
  },
  {
    "dep": "Scenario",
    "rol": "Dialoog schrijver",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Richt zich specifiek op het schrijven van dialogen binnen een scenario en werkt daarvoor samen met één of meerdere Scenarioschrijvers aan hetzelfde scenario. Het betreft een autonome positie die in dienst staat van de stijl en sfeer van het complete scenario. Heeft diverse interne en externe contacten die sturend en beïnvloedend zijn op het resultaat van  de productie.",
    "bullets": [
      "Richt zich specifiek op het schrijven van dialogen binnen een scenario",
      "Werkt, in meer of minderen mate, samen met een of meedere Scenarioschrijver(s) aan hetzelfde scenario",
      "Verricht vanuit een autonome positie specialistische werkzaamheden die in dienst staan van de stijl en sfeer van het complete scenario",
      "Heeft diverse interne en externe contacten die sturend en beïnvloedend zijn op het resultaat van  de productie"
    ],
    "volgorde": 70
  },
  {
    "dep": "Scenario",
    "rol": "Script Coach",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Begeleidt en ondersteunt de Scenarioschrijver(s) in diverse fases van ontwikkeling door mee te lezen en mee te denken vanuit diens visie. Geeft feedback, doet concrete suggesties en stelt vragen, om creativiteit te stimuleren en het eindresultaat te verbeteren. Het betreft een autonome positie  met specialistische werkzaamheden en staat hoofdzakelijk in dienst van het schrijfproces.",
    "bullets": [
      "Begeleidt de Scenarioschrijver(s) door mee te lezen en mee te denken vanuit diens visie",
      "Is betrokken tijdens diverse fases van ontwikkeling",
      "Geeft feedback, doet concrete suggesties en stelt vragen, om creativiteit te stimuleren en het eindresultaat te verbeteren",
      "Verricht vanuit een autonome positie specialistische werkzaamheden"
    ],
    "volgorde": 80
  },
  {
    "dep": "Scenario",
    "rol": "Script-docter/Script editor",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Analyseert een bestaand scenario en geeft concrete adviezen om dit scenario te verbeteren of herschrijft, in overleg met de Scenarioschrijver, (een deel van) het scenario. Het betreft specialistische werkzaamheden die worden verricht vanuit een autonome positie. Werkt nauw samen met de Producent en Scenarioschrijver en heeft diverse interne en externe contacten die sturend en beïnvloedend zijn op het resultaat van  de productie.",
    "bullets": [
      "Analyseert een bestaand scenario en geeft concrete adviezen om dit scenario te verbeteren",
      "Kan in overleg met de Scenarioschrijver, (een deel van) het scenario herschrijven",
      "Verricht vanuit een autonome positie specialistische werkzaamheden",
      "Werkt nauw samen met de Producent en Scenarioschrijver",
      "Heeft diverse interne en externe contacten die sturend en beïnvloedend zijn op het resultaat van  de productie"
    ],
    "volgorde": 90
  },
  {
    "dep": "Scenario",
    "rol": "Hoofdschrijver",
    "niveaus": [
      "I"
    ],
    "aliases": [],
    "omschrijving": "Schrijft documenten en producten, zoals scenarioversies, treatments, karakterbeschrijvingen en pitches en ontwikkelt die door. Het betreft een autonome positie, waarbij vaak vrijwel geen verificatie mogelijk is. Is volledig op de hoogte van de gewenste richting van de productie en weet dat te vertalen naar documenten en producten die (mede) bepalend zijn voor (de kwaliteit van) het audiovisuele eindproduct. Doet voorstellen en geeft adviezen die uitstralen op de totale productie (afbreukrisico). Heeft onder andere contact met de Producent en Regisseur. Deze contacten zijn meestal adviserend en/of beïnvloedend. Stuurt leden van een schrijfteam aan.",
    "bullets": [
      "Schrijft documenten en producten zoals scenarioversies, treatments, karakterbeschrijvingen en pitches, en ontwikkelt deze verder",
      "Zorgt dat de creative visie haalbaar blijft binnen de planning en het budget",
      "Werkt vanuit een autonome positie, waarbij vaak weinig tot geen verificatie mogelijk is",
      "Is volledig op de hoogte van de gewenste richting van de productie en vertaalt dit naar documenten en producten die (mede) bepalend zijn voor de kwaliteit van het audiovisuele eindproduct",
      "Doet voorstellen en geeft adviezen die invloed hebben op de totale productie (afbreukrisico)",
      "Heeft contact met onder andere de Producent en Regisseur en deze contacten zijn meestal adviserend en/of beïnvloedend van aard",
      "Stuurt leden van een schrijfteam aan"
    ],
    "volgorde": 100
  },
  {
    "dep": "Scenario",
    "rol": "Scenarioschrijver",
    "niveaus": [
      "I"
    ],
    "aliases": [],
    "omschrijving": "Schrijft documenten en producten, zoals scenarioversies, treatments, karakterbeschrijvingen en pitches, en ontwikkelt die door. Het betreft een autonome positie, waarbij vaak vrijwel geen verificatie mogelijk is. Is volledig op de hoogte van de gewenste richting van de productie en weet dat te vertalen naar documenten en producten die (mede) bepalend zijn voor (de kwaliteit van) het audiovisuele eindproduct. Doet voorstellen en geeft adviezen die uitstralen op de totale productie (afbreukrisico). Heeft onder andere contact met de producent en regie. Deze contacten zijn meestal adviserend en/of beïnvloedend.",
    "bullets": [
      "Schrijft documenten en producten zoals scenarioversies, treatments, karakterbeschrijvingen en pitches, en ontwikkelt deze verder",
      "Werkt vanuit een autonome positie, waarbij vaak vrijwel geen verificatie mogelijk is",
      "Is volledig op de hoogte van de gewenste richting van de productie en vertaalt dit naar documenten en producten die (mede) bepalend zijn voor de kwaliteit van het audiovisuele eindproduct",
      "Doet voorstellen en geeft adviezen die invloed hebben op de totale productie (afbreukrisico)",
      "Heeft onder andere contact met de producent en de regie en deze contacten zijn meestal adviserend en/of beïnvloedend"
    ],
    "volgorde": 110
  },
  {
    "dep": "Scenario",
    "rol": "Showrunner",
    "niveaus": [
      "K"
    ],
    "aliases": [],
    "omschrijving": "Heeft creatieve verantwoordelijkheid voor het eindproduct van een complexe productie. Stuurt processen aan die bepalend zijn voor het creatieve resultaat. Schrijft documenten en producten, zoals scenarioversies, treatments, karakterbeschrijvingen en pitches voor een complexe productie en ontwikkelt die door. Stelt deze op ten behoeve van een eindproduct. Overziet de creatieve productie en regisseert mogelijkerwijs een of meer afleveringen. Er is kennis nodig van meerdere met elkaar verwant houdende departementen. Gemaakte beslissingen in het proces zijn bepalend voor het eindproduct (afbreukrisico). Stuurt andere schrijvers en regisseurs aan door werk te verdelen en/of uit te besteden, te coördineren en door creatieve en inhoudelijke aanwijzingen te geven.",
    "bullets": [
      "Heeft creatieve en zakelijke verantwoordelijkheid voor het eindproduct van een complexe productie",
      "Zorgt dat de creative visie haalbaar blijft binnen de planning en het budget",
      "Stuurt processen aan die bepalend zijn voor het creatieve resultaat",
      "Schrijft documenten en producten zoals scenarioversies, treatments, karakterbeschrijvingen en pitches voor een complexe productie (bijvoorbeeld een dramaserie), en ontwikkelt deze verder",
      "Stelt deze documenten op ten behoeve van het eindproduct",
      "Overziet de creatieve productie en regisseert mogelijk een of meer afleveringen",
      "Beschikt over kennis van meerdere onderling verbonden departementen",
      "Neemt beslissingen die bepalend zijn voor het eindproduct (met afbreukrisico)",
      "Stuurt andere schrijvers en regisseurs aan door werk te verdelen, uit te besteden, te coördineren en creatieve/in­houdelijke aanwijzingen te geven"
    ],
    "volgorde": 120
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Catering Assistent",
    "niveaus": [
      "A"
    ],
    "aliases": [],
    "omschrijving": "Voert uitvoerende taken uit binnen een afgebakend werkgebied, zoals het bereiden van maaltijden, klaarzetten en afruimen. De werkzaamheden zijn volgens instructies en zijn op basis van routine. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Voert uitvoerende taken uit binnen een afgebakend werkgebied, zoals het bereiden van maaltijden, het klaarzetten en afruimen, en het schoon en hygiënisch houden van tafels, buffetten en keukenunits",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 10
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Nachtwaker",
    "niveaus": [
      "A",
      "B",
      "C"
    ],
    "aliases": [],
    "omschrijving": "Bewaakt de set op momenten dat er niet wordt gedraaid. Werkt binnen heldere kaders en richtlijnen. Meldt incidenten eerst aan de productie, tenzij sprake is van een noodgeval of direct gevaar; in dat geval neemt de nachtwaker direct contact op met hulpdiensten (bijvoorbeeld bij brand, inbraak of een bedreigende situatie).",
    "bullets": [
      "Bewaakt de set op momenten dat er niet wordt gedraaid",
      "Werkt aan de hand duidelijke instructies en richtlijnen",
      "Meldt incidenten eerst aan de productie, tenzij sprake is van een noodgeval of direct gevaar; in dat geval neemt de nachtwaker direct contact op met hulpdiensten (bijvoorbeeld bij brand, inbraak of een bedreigende situatie)"
    ],
    "volgorde": 20
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Verkeersregelaar",
    "niveaus": [
      "A",
      "B",
      "C"
    ],
    "aliases": [],
    "omschrijving": "Begeleidt het veilig en ordelijk filmen op de openbare weg. Zorgt dat cast, crew en omstanders zich veilig kunnen bewegen. Werkt binnen heldere kaders en richtlijnen, en volgens de afspraken in de filmontheffing van de betreffende gemeente.",
    "bullets": [
      "Begeleidt het veilig en ordelijk filmen op de openbare weg",
      "Zorgt dat cast, crew en omstanders zich veilig kunnen bewegen",
      "Werkt aan de hand van duidelijke instructies en richtlijnen, en volgens de afspraken in de filmontheffing van de betreffende gemeente"
    ],
    "volgorde": 30
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Beveiliger",
    "niveaus": [
      "B"
    ],
    "aliases": [],
    "omschrijving": "Voert uitvoerende werkzaamheden uit, zoals het zorgdragen van de veiligheid door het controleren van in- en uitgaande personen. Er is sprake van duidelijk aangegeven instructies of voorschriften. Er dient naar eigen inzicht gehandeld te worden en het contact is met name gericht op het uitwisselen van informatie, zoals bij onregelmatigheden.",
    "bullets": [
      "Voert uitvoerende werkzaamheden uit zoals het zorgdragen van de veiligheid door het controleren van in- en uitgaande personen",
      "Er wordt gewerkt aan de hand van duidelijke instructies en/of voorschriften",
      "Er dient naar eigen inzicht gehandeld te worden binnen de geldende veiligheidsnormen en -afspraken",
      "Het contact is met name gericht op het uitwisselen van informatie, zoals bij onregelmatigheden"
    ],
    "volgorde": 40
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Productie runner",
    "niveaus": [
      "B"
    ],
    "aliases": [],
    "omschrijving": "Voert ondersteunende werkzaamheden uit op concreet verzoek en volgens de duidelijke aanwijzingen die daarbij verkregen worden. Het kan gaan om het vervoeren van cast, equipment en/of andere last minute benodigdheden. Er is geen tot zeer weinig ruimte voor eigen prioritering van werkzaamheden. Inzicht in de gang van zaken op de set is noodzakelijk om mee te denken en ad hoc oplossingsvoorstellen te kunnen doen.",
    "bullets": [
      "Vervoert cast, equipment en/of andere last minute benodigdheden",
      "Voert ondersteunende werkzaamheden uit op concreet verzoek en volgens duidelijke aanwijzingen",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen departement"
    ],
    "volgorde": 50
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Dierentrainer / Animal handler",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Traint en begeleidt dieren voor filmopnames. Draagt zorg voor veilige en ethisch verantwoorde omstandigheden, zodat het dier de gewenste prestatie levert op het juiste moment. Signaleert problemen tijdens zowel de voorbereiding als de uitvoering en brengt deze onder de aandacht van betrokkenen. Verzorgt de dieren en regelt hun vervoer en verblijf. Contacten zijn gericht op het uitwisselen van informatie binnen het eigen team.",
    "bullets": [
      "Traint en begeleidt dieren voor filmopnames",
      "Draagt zorg voor veilige en ethisch verantwoorde omstandigheden, zodat het dier de gewenste prestatie levert op het juiste moment",
      "Verzorgt de dieren en regelt hun vervoer en verblijf",
      "Werkt binnen het kader van het production design aan het beoogde eindresultaat",
      "Signaleert problemen tijdens de uitvoering en meldt deze bij anderen",
      "Onderhoudt contact om informatie op te halen en uit te wisselen binnen het eigen team"
    ],
    "volgorde": 60
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Housing coordinator",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Regelt (ad hoc) overnachtingen voor cast en crew. Onderhandelt met hotels of verhuurders over prijzen, beschikbaarheid en voorwaarden. Behoudt het overzicht van wie waar en hoe lang verblijft, en lost klachten en onvoorziene situaties op. Contacten zijn gericht op het ophalen en uitwisselen van informatie en binnen het eigen productie department.",
    "bullets": [
      "Regelt overnachtingen voor cast en crew",
      "Onderhandelt met hotels of verhuurders over prijzen, beschikbaarheid en voorwaarden",
      "Behoudt het overzicht van wie waar en hoe lang verblijft, en lost klachten en onvoorziene situaties op",
      "Inzicht in de gang van zaken is noodzakelijk om mee te denken en ad hoc oplossingsvoorstellen te kunnen doen",
      "Voert ondersteunende werkzaamheden uit",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie en binnen eigen departement"
    ],
    "volgorde": 70
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Productieassistent",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Voert ten behoeve van een specifieke productie ondersteunende werkzaamheden uit op het productiekantoor en op de set, zoals distributie van call sheets, scripts etc naar cast en crew. Inzicht in de gang van zaken op het kantoor op de set is noodzakelijk om mee te denken en ad hoc oplossingsvoorstellen te kunnen doen. Contacten zijn gericht op het ophalen en uitwisselen van informatie en binnen eigen productie departement.",
    "bullets": [
      "Verantwoordelijk voor kopiëren van call sheets, scripts etc en de distributie hiervan naar cast en crew",
      "Voert ondersteunende werkzaamheden uit op het productiekantoor en op de set",
      "Inzicht in de gang van zaken op het kantoor op de set is noodzakelijk om mee te denken en ad hoc oplossingsvoorstellen te kunnen doen",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie en binnen eigen departement"
    ],
    "volgorde": 80
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "(Post-) Productiecoördinator",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Werkt als Productiecoördinator binnen het productieteam en biedt operationele ondersteuning aan de Productieleider. Zorgt voor correspondentie tussen het productieteam en de crew/cast. Organiseert middelen en logistiek, inclusief transport en accommodatie. Of biedt als Postproductiecoördinator operationele ondersteuning aan Post Production Supervisor en leidt de workflow tijdens de postproductie in goede banen, coördineert afspraken met editors, geluidstudio's, color grading en/of postproductiehuizen.",
    "bullets": [
      "Biedt als Productiecoördinator operationele steun aan Productieleider",
      "Regelt contact tussen productieteam en crew/cast",
      "Zorgt voor correspondentie tussen het productieteam en de crew/cast",
      "Organiseert middelen en logistiek, inclusief transport en accommodatie OF",
      "Biedt als Postproductiecoördinator operationele ondersteuning aan Post Production Supervisor",
      "Leidt de workflow tijdens de postproductie in goede banen, coördineert afspraken met editors, geluidstudio's, color grading en/of postproductiehuizen"
    ],
    "volgorde": 90
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Assistent Locatiemanager",
    "niveaus": [
      "F"
    ],
    "aliases": [],
    "omschrijving": "Organiseert en regelt faciliteiten op de locaties. Speelt zelfstandig binnen gegeven kader in op (on)voorbereide veranderende omstandigheden en weet vanuit eigen vakkennis wat daarvoor nodig is. Informeert en escaleert naar het eigen Head of Department (HoD)  indien nodig. Ziet dat belangen stakeholders soms uiteenlopen en trekt situaties weer vlot.",
    "bullets": [
      "Organiseert en regelt faciliteiten op de locaties",
      "Speelt binnen gegeven kaders zelfstandig in op onvoorziene omstandigheden en weet vanuit vakkennis wat hiervoor nodig is",
      "Kan aanspreekpunt zijn in het buurtcontact en ondersteunend bij crowd control, draagt (mede) zorg voor de veiligheid op en rond de draailocaties, en zorgt dat deze netjes worden opgeleverd",
      "Informeert wanneer relevant Head of Department (HoD)",
      "Voorziet conflicterende belangen van stakeholders en lost deze waar nodig op"
    ],
    "volgorde": 100
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Carhandler",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Bedenkt, scout en organiseert voertuigen in beeld, maakt deze rijklaar en draagt zorg voor verplaatsing. Contacten zijn gericht op het ophalen en uitwisselen van informatie met Art, Productie en Regie. Werkt zelfstandig vanuit eigen vakkennis en speelt in op onvoorziene omstandigheden.",
    "bullets": [
      "Bedenkt, scout en organiseert voertuigen in beeld",
      "Maakt voertuigen rijklaar en draagt zorg voor verplaatsing",
      "Contacten zijn gericht op het ophalen en uitwisselen van informatie binnen eigen departement",
      "Speelt binnen gegeven kaders zelfstandig in op onvoorziene omstandigheden en weet vanuit vakkennis wat hiervoor nodig is"
    ],
    "volgorde": 110
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Catering Manager/Chef",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor de catering op set. Kiest het menu op basis van verschillende factoren, waaronder beschikbaarheid, kosten, wensen/allergieën van cast en crew en draagt zorg voor veilige bereiding en naleving van hygiënevoorschriften. Stuurt een team aan en is eerste aanspreekpunt voor productie.",
    "bullets": [
      "Draagt zorg voor veilige bereiding, naleving van hygiënevoorschriften en toegankelijke presentatie van het eten en drinken",
      "Stuurt team van assistenten en koks aan",
      "Is eerste aanspreekpunt voor productie"
    ],
    "volgorde": 120
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Eco/Sustainability Manager",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Ontwikkelt in samenwerking met productie een gedetailleerd, klimaatbewust productieplan dat gericht is op het verminderen van afval, het bevorderen van duurzaam materiaalgebruik en het verhogen van de energie- en kostenefficiëntie op de set. Houdt desgevraagd bij hoeveel CO2-uitstoot of afval een productie genereert en rapporteert dit aan productie en financiers en motiveert cast & crew om duurzame keuzes te maken. Werkt zelfstandig vanuit eigen vakkennis en speelt in op onvoorziene omstandigheden.",
    "bullets": [
      "Ontwikkelt i.s.m. productie een gedetailleerd klimaatbewust productieplan dat gericht is op het verminderen van afval, het bevorderen van duurzaam materiaalgebruik en het verhogen van de energie- en kostenefficiëntie op de set",
      "Houdt desgevraagd bij hoeveel CO2-uitstoot of afval een productie genereert en rapporteert dit aan productie en financiers",
      "Motiveert cast & crew om duurzame keuzes te maken",
      "Speelt binnen gegeven kaders zelfstandig in op onvoorziene omstandigheden en weet vanuit vakkennis wat hiervoor nodig is"
    ],
    "volgorde": 130
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Floor manager (studio)",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor de communicatie tussen regie, productie en de crew op de studiovloer en ziet toe op orde en veiligheid. Speelt zelfstandig binnen gegeven kader in op (on)voorbereide veranderende omstandigheden en weet vanuit eigen vakkennis wat daarvoor nodig is. Informeert en escaleert naar het eigen Head of Department (HoD) indien nodig. Ziet dat belangen stakeholders soms uiteenlopen en trekt situaties weer vlot.",
    "bullets": [
      "Is verantwoordelijk voor de communicatie tussen regie, productie en de crew op de studiovloer en ziet toe op orde en veiligheid",
      "Speelt binnen gegeven kaders zelfstandig in op onvoorziene omstandigheden en weet vanuit vakkennis wat hiervoor nodig is",
      "Informeert en escaleert naar het eigen Head of Department (HoD) indien nodig",
      "Voorziet conflicterende belangen van stakeholders en lost deze waar nodig op"
    ],
    "volgorde": 140
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Health & Safety Manager",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Minimaliseert risico's en bevordert een gezonde en veilige werkomgeving tijdens het productieproces. Werkt nauw samen met andere afdelingen om ervoor te zorgen dat alle veiligheidsprotocollen worden nageleefd. Werkt zelfstandig vanuit eigen vakkennis en speelt in op onvoorziene omstandigheden.",
    "bullets": [
      "Minimaliseert risico's en bevordert een gezonde en veilige werkomgeving tijdens het productieproces; ◦ Werkt nauw samen met andere afdelingen om ervoor te zorgen dat alle veiligheidsprotocollen worden nageleefd",
      "Speelt binnen gegeven kaders zelfstandig in op onvoorziene omstandigheden en weet vanuit vakkennis wat hiervoor nodig is"
    ],
    "volgorde": 150
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Locatiescout",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Onderzoekt en doet voorstellen voor potentiële locaties naar aanleiding van het script en een creatieve briefing vanuit de Regisseur en Production Designer. Houdt rekening met (praktische) vereisten, zoals sfeer, tijdperiode, kosten, toegankelijkheid en veiligheid. Legt het eerste contact met locatie-eigenaren en stuurt, indien aanwezig, assistenten aan door het werk te verdelen en inhoudelijke aanwijzingen en/of instructies te geven ten behoeve van het beoogde resultaat.",
    "bullets": [
      "Zoekt potentiële locaties op basis van het script en wensen van de Regisseur en Production Designer",
      "Houdt rekening met (praktische) vereisten, zoals sfeer, tijdperiode, kosten, toegankelijkheid en veiligheid",
      "Stelt passende locaties voor aan het team",
      "Stuurt assistenten aan (indien aanwezig) door werk te verdelen en instructies te geven ten behoeve van het beoogde eindresultaat"
    ],
    "volgorde": 160
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Productie Accountant",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Berekent financiën en de kosten van een productie, en controleert de cashflow of uitgaven. Houdt tijdens de productie toezicht op alle betalingen, beheert de salarisadministratie en levert de dagelijkse of wekelijkse kostenrapporten. Maakt ook kostenprognoses om de impact van eventuele productiewijzigingen te evalueren. Speelt zelfstandig binnen gegeven kader in op (on)voorbereide veranderende omstandigheden en weet vanuit eigen vakkennis wat daarvoor nodig is.",
    "bullets": [
      "Controleert de financiering en kosten van een productie",
      "Controleert en administreert de cashflow en uitgaven",
      "Houdt toezicht op alle betalingen",
      "Beheert salarisadministratie",
      "Stelt periodieke kostenoverzichten samen voor producenten, productiebedrijf en financiers",
      "Overlegt en maakt prognoses t.b.v. wijzigingen in de productie",
      "Zoekt zelfstandig en vanuit eigen expertise oplossingen voor onvoorziene veranderingen binnen de productie"
    ],
    "volgorde": 170
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Set Manager",
    "niveaus": [
      "F"
    ],
    "aliases": [],
    "omschrijving": "Voert een voorbereid plan uit op de set met als doel om de inrichting van de set in goede banen te leiden. Wijst aan waar partijen en goederen naar toe moeten op de set. Speelt zelfstandig binnen gegeven kader in op (on)voorbereide veranderende omstandigheden en weet vanuit eigen vakkennis wat daarvoor nodig is. Informeert en escaleert naar het eigen Head of Department (HoD) indien nodig. Ziet dat belangen stakeholders soms uiteenlopen en trekt situaties weer vlot.",
    "bullets": [
      "Voert een voorbereid plan uit op de set met als doel om de inrichting van de set in goede banen te leiden",
      "Wijst aan waar partijen en goederen naartoe moeten op de set en ziet toe op orde en veiligheid op de set",
      "Speelt zelfstandig binnen gegeven kader in op (on)voorbereide veranderende omstandigheden en weet vanuit eigen vakkennis wat daarvoor nodig is",
      "Informeert en escaleert naar het eigen Head of Department (HoD) indien nodig",
      "Ziet dat belangen van stakeholders soms uiteenlopen en trekt situaties weer vlot"
    ],
    "volgorde": 180
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Set Medic",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Levert uitgebreide medische en veiligheidsdiensten om een ​​veilige en goed beschermde omgeving te garanderen op de set. Is op de set aanwezig, o.a. bij stunts en gecompliceerde scènes. Werkt zelfstandig vanuit eigen vakkennis en speelt in op onvoorziene omstandigheden.",
    "bullets": [
      "Levert uitgebreide medische en veiligheidsdiensten om een ​​veilige en goed beschermde omgeving te garanderen op de set",
      "Is op de set aanwezig, o.a. bij stunts en gecompliceerde scènes",
      "Speelt binnen gegeven kaders zelfstandig in op onvoorziene omstandigheden en weet vanuit vakkennis wat hiervoor nodig is"
    ],
    "volgorde": 190
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Transportmanager",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Coördineert alle transporten en de informatie-uitwisseling daaromtrent om ervoor te zorgen dat cast, crew en faciliteiten op de plaats van bestemming kunnen komen wanneer ze daar moeten zijn. Bewaakt transportkosten en ziet toe op rij- en rusttijden, verzekeringen en verkeersveiligheid. Werkt zelfstandig vanuit eigen vakkennis en speelt in op onvoorziene omstandigheden.",
    "bullets": [
      "Coördineert alle transporten t.b.v. van de opnames van cast, crew en faciliteiten",
      "Communiceert alle daartoe relevante informatie met de betrokken departementen",
      "Bewaakt transportkosten en ziet toe op rij- en rusttijden, verzekeringen en verkeersveiligheid",
      "Zoekt zelfstandig en vanuit eigen expertise oplossingen voor onvoorziene veranderingen binnen het eigen werkterrein"
    ],
    "volgorde": 200
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Weapon Handler",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Regelt, bewaakt en beheert wapens voor op de set. Werkt vanuit aantoonbare vakkennis zelfstandig binnen de gegeven (veiligheids-)kaders en geldende (veiligheids-) protocollen, en het beoogde resultaat vanuit productie, regie en production design. Voert veiligheidscontroles uit vóór, tijdens en na afloop van elke opname en zorgt voor duidelijke instructies en veiligheidsbriefings aan cast en crew. Houdt documentatie van vergunningen, transport en gebruikslogboeken bij. Wisselt continu informatie uit binnen het eigen departement voor afstemming en speelt in op (onvoorbereide) veranderende omstandigheden.",
    "bullets": [
      "Regelt, bewaakt en beheert wapens op de set",
      "Werkt zelfstandig binnen de gestelde (veiligheids-)kaders, geldende (veiligheids-)protollen, en beoogde resultaat vanuit productie, regie en production design",
      "Voert veiligheidscontroles uit vóór, tijdens en na afloop van elke opname",
      "Zorgt voor duidelijke instructies en veiligheidsbriefings aan cast en crew",
      "Houdt documentatie van vergunningen, transport en gebruikslogboeken bij",
      "Speelt in op (on)voorbereide veranderende omstandigheden vanuit eigen vakkennis en beoordelinsvermogen",
      "Heeft contact binnen het eigen departement om informatie uit te wisselen"
    ],
    "volgorde": 210
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Assistent Productieleider",
    "niveaus": [
      "G"
    ],
    "aliases": [],
    "omschrijving": "Werkt binnen de (financiële en creatieve) kaders, wensen en richtlijnen van productie ten aanzien van het beoogde resultaat. Richt deelplanningen concreet in en regelt randvoorwaarden alsmede de benodigde faciliteiten. Stuurt op set assistenten aan om ad hoc problemen op te lossen. Overziet consequenties van problemen en oplossingen voor aanverwante departementen. Fungeert vanuit de Producent als eerste aanspreekpunt voor crew werkzaam binnen het eigen departement.",
    "bullets": [
      "Richt deelplanningen in",
      "Regelt randvoorwaarden en daartoe benodigde faciliteiten",
      "Maakt callsheet als er geen 2nd AD is",
      "Stuurt op de set assistenten aan om ad hoc problemen op te lossen",
      "Ontvangt kaders en richtlijnen en taken van de productieleider",
      "Voorziet problemen en overziet consequenties en oplossingen hiervoor",
      "Is eerste aanspreekpunt voor verschillende departementen en crew & cast"
    ],
    "volgorde": 220
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Budget controller",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor de controle op het productiebudget. Stelt een rekeningoverzicht op met alle inkomsten en uitgaven voor de producent of het productiebedrijf en de financiers. Overziet consequenties van problemen en oplossingen voor aanverwante departementen. Adviseert over het beheer en de optimalisatie van budgetten. Fungeert vanuit financiële controle als eerste aanspreekpunt voor de Line Producer en Producent. Rapporteert op gezette tijden aan de Line Producer en Producent en ziet erop toe dat wordt voldaan aan de door (publieke) financiers gestelde regels voor budgettering en de financieringsvoorwaarden van fondsen en subsidie­verstrekkers.",
    "bullets": [
      "Verantwoordelijk voor de controle op het productiebudget",
      "Voorziet en overziet budgetoverschrijdingen en consequenties",
      "Adviseert over beheer en optimalisatie van budgetten",
      "Is eerste aanspreekpunt over financiën voor Producent en Line Producer",
      "Rapporteert op gezette tijden aan de Line Producer en Producent en ziet erop toe dat wordt voldaan aan de door (publieke) financiers gestelde regels voor budgettering en de financieringsvoorwaarden van fondsen en subsidie­verstrekkers"
    ],
    "volgorde": 230
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Locatiemanager",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Onderzoekt en beoordeelt potentiële locaties op hun match met de creatieve briefing en praktische vereisten, zoals kosten, toegankelijkheid en veiligheid. Onderhandelt over contracten met locatie-eigenaren of hun agenten en verkrijgen alle officiële vergunningen of toestemmingen die vereist zijn. Organiseert de logistiek voor het gebruik van locaties, zodat alle afdelingen effectief en veilig kunnen werken. Is aanspreekpunt op de opnamelocatie. Zorgt dat de locatie na afloop netjes wordt achtergelaten en eventuele schade wordt afgehandeld.",
    "bullets": [
      "Onderzoekt en beoordeelt potentiële locaties op hun match met de praktische vereisten",
      "Onderhandelt over prijs en contracten met de locatiehouders",
      "Verkrijgt alle benodigde en/of vereiste vergunningen en toestemmingen",
      "Organiseert het logistieke gebruik van en op de locaties t.b.v. effectiviteit en veiligheid",
      "Is aanspreekpunt voor de opnamelocatie, toezichthouders, gemeenten en diensten",
      "Zorgt dat de locatie na afloop netjes wordt achtergelaten en eventuele schade wordt afgehandeld"
    ],
    "volgorde": 240
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Productieleider",
    "niveaus": [
      "H"
    ],
    "aliases": [],
    "omschrijving": "Richt planningen concreet in en regelt randvoorwaarden. Ontvangt hiertoe richtlijnen vanuit de Line Producer ten aanzien van het beoogde resultaat van de productie. Beheert onderdelen van budgetten en onderhandelt binnen kaders over kosten en uitgaven. Ziet toe op de naleving van gemaakte afspraken. Lost ad hoc problemen op en kijkt vooruit. Overziet consequenties van problemen en oplossingen voor aanverwante departementen. Adviseert over het beheer en de optimalisatie van planningen en budgetten. Fungeert vanuit de productie als eerste aanspreekpunt (op de set) voor de crew.",
    "bullets": [
      "Beheert deelbudgetten van de productie",
      "Onderhandelt binnen kaders over kosten en uitgaven",
      "Richt planningen in met betrokken heads",
      "Ziet toe op naleving van de gemaakt afspraken met cast en crew",
      "Draagt zorg voor het (laten) regelen van accommodatie, vervoer, catering, vergunningen en materialen",
      "Voorziet en lost ad hoc problemen tijdens voorbereiding en in opnameperiode op",
      "Adviseert over het beheer van en de optimalisatie van planningen en budget",
      "Is eerste aanspreekpunt voor crew en cast tijdens prep- en draaiperiode"
    ],
    "volgorde": 250
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "(Post)production Supervisor",
    "niveaus": [
      "I"
    ],
    "aliases": [],
    "omschrijving": "Fungeert vanuit de Producent als eerste aanspreekpunt voor de (post)productie. Beheert een deelbudget van een grote productie en maakt afspraken over de invulling daarvan met stakeholders binnen de postproductiefase. Overziet meerdere planningen en integreert wensen en consequenties voor departementen in de postproductie in het eigen aandachtsgebied. Signaleert knelpunten daarbinnen, doet voorstellen om die op te lossen en bespreekt die met de Producent. Heeft contact met onder andere de Producent en regie, deze contacten zijn veelal zakelijk en beïnvloedend van aard. De Post-production manager heeft voor en tijdens de draaiperiode contact met productie in verband met de workflow van de postproductie/VFX.",
    "bullets": [
      "Is vanuit producent eerste aanspreekpunt voor de post-productie",
      "Beheert deelbudget van een grote productie",
      "Maakt afspraken hierover met uitvoerenden in de post-productie",
      "Overziet en combineert planningen van alle betrokken partijen",
      "Integreert wensen en consequenties voor de departementen in de postproductie",
      "Ziet erop toe betrokken partijen zoals editors, coloristen, sound designers, componisten, VFX artiesten en ondertitelaars tijdig en in de juiste formaten materiaal opleveren",
      "Signaleert knelpunten en doet voorstellen deze op te lossen",
      "Heeft contact met vnl. (uitvoerend) Producent en regie",
      "Deze contacten zijn zakelijk en beïnvloedend",
      "Heeft contact met de productie over de draaiperiode i.v.m. workflow richting de post-productie"
    ],
    "volgorde": 260
  },
  {
    "dep": "Uitvoerende productie",
    "rol": "Line Producer (J )",
    "niveaus": [
      "J",
      "K"
    ],
    "aliases": [],
    "omschrijving": "Beheert het volledige budget van een productie en maakt afspraken over de invulling daarvan met verschillende Heads of Department (HoD). Overziet lange termijn planningen en integreert zelfstandig wensen en consequenties voor departementen in de pre- en postproductie. Beoordeelt daarbij de haalbaarheid van en communiceert intensief daarover met de verschillende HoD. Doet verbetervoorstellen en levert input op het beleid ten aanzien van het beoogde eindresultaat. Signaleert afwijkingen, informeert en draagt zorg voor afstemming met producent. Stuurt een team met assistenten en Productieleiders aan, dat draagt zorg voor verdere concrete invulling van deelbudgetten en -planningen. Fungeert vanuit de productie als eerste aanspreekpunt voor de HoD.",
    "bullets": [
      "Beheert volledige budget van een productie",
      "Maakt afspraken over de invulling daarvan met de heads of department",
      "Overziet lange termijn planning",
      "Integreert wensen en consequenties en dus haalbaarheid daarvan van de departementen voor hele project en regelt de gewenste verzekeringen",
      "Doet verbetervoorstellen",
      "Adviseert over het beleid van de Producent",
      "Stuurt productieteam aan dat de invulling en uitvoering van de geformuleerde richtlijnen en kaders verder uitvoert"
    ],
    "volgorde": 270
  },
  {
    "dep": "VFX en VP",
    "rol": "(Digital) Matte Painter",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Maakt met gebruik van foto-collages en digitale schildertechnieken 2D afbeeldingen die gebruikt worden om delen van een gedraaid shot te vervangen. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Maakt met gebruik van foto-collages en digitale schildertechnieken 2D afbeeldingen die gebruikt worden om delen van een gedraaid shot te vervangen",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 10
  },
  {
    "dep": "VFX en VP",
    "rol": "2D Animator",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Creëert stilstaande beelden die in een snelle volgorde worden afgespeeld om de illusie van beweging te creëeren. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Creëert stilstaande beelden die in een snelle volgorde worden afgespeeld om de illusie van beweging te creëren",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 20
  },
  {
    "dep": "VFX en VP",
    "rol": "3D Animator",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Laat een gerigged 3D model bewegen. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Laat een gerigged 3D model bewegen",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 30
  },
  {
    "dep": "VFX en VP",
    "rol": "3D Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Neemt verschillende CG-taken binnen een VFX shot op zich zoals 3D modeling, het maken van texturen en shading en animatie. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van de instructies ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Neemt verschillende CG-taken binnen een VFX shot op zich zoals 3D modeling, het maken van texturen en shading en animatie",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van de instructies ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 40
  },
  {
    "dep": "VFX en VP",
    "rol": "CFX Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Creëert dynamiek door het simuleren van effecten zoals stof, haar, bont, veren en spier- en huidvervorming van 'wezens'. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Creëert dynamiek door het simuleren van stof, haar, bont, veren en spier- en huidvervorming van 'wezens'",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 50
  },
  {
    "dep": "VFX en VP",
    "rol": "CG Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Neemt verschillende Computer Generated-taken binnen een VFX shot op zich zoals rigging, animatie, simulatie en rendering. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van de instructies ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Neemt verschillende CG-taken binnen een VFX shot op zich zoals rigging, animatie, simulatie en rendering",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van de instructies ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 60
  },
  {
    "dep": "VFX en VP",
    "rol": "Character Animator",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Is een 3D animator, met een specialisme in het animeren van karakters. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Is een 3D animator, met een specialisme in het animeren van karakters",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 70
  },
  {
    "dep": "VFX en VP",
    "rol": "Character Designer",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Visualiseert en creëert het uiterlijk van individuele karakters. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak.. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Visualiseert en creëert het uiterlijk van individuele karakters",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 80
  },
  {
    "dep": "VFX en VP",
    "rol": "Concept Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Bedenkt en maakt visuele voorstellen, zoals (experimentele) schetsen van shots, sets en decors van belangrijke momenten in het verhaal die inzicht bieden als mogelijke eindresultaten voor regie, production design, camera en VFX/Postproductie. Werkt vanuit concrete richtlijnen gegeven door de Head of Department en vertaalt deze naar creatieve keuzes die tevens dienen als visuele gids voor de creatieve teams (Art, Kostuum, VFX en Hair & Make-up). Stuurt, indien aanwezig, assistenten aan door het werk te verdelen en inhoudelijke aanwijzingen en/of instructies te geven ten behoeve van het beoogde resultaat.",
    "bullets": [
      "Maakt (gedetaileerde) kunstwerken, schetsen en/of referentiecollages ter inspiratie voor de visuele effecten (VFX) in een film- of tvproductie",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 90
  },
  {
    "dep": "VFX en VP",
    "rol": "Display & Video Expert",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het video-signaal tussen alle componenten van een VP productie. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Is verantwoordelijk voor het video-signaal tussen alle componenten van een VP productie",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 100
  },
  {
    "dep": "VFX en VP",
    "rol": "FX Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Voert meerdere taken uit bij het maken van een VFX shot. Levert gebundelde specialistische vaktechnische bijdrage. Werkt zelfstandig binnen de kaders van de opdracht ten behoeve van het beoogde eindresultaat, waarbij afstemming benodigd is die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft. Bij het oplossen van problemen worden er creatieve keuzes gemaakt binnen reeds bestaande oplossingsmogelijkheden. Er is vooral contact binnen het eigen departement.",
    "bullets": [
      "Creëert op fysica gebaseerde digitale effecten zoals explosies, rook en water",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 110
  },
  {
    "dep": "VFX en VP",
    "rol": "IT & Network Expert",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het aanleggen en onderhouden van het netwerk tussen alle systemen die tijdens een VP productie gebruikt worden. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Is verantwoordelijk voor het aanleggen en onderhouden van het netwerk tussen alle systemen die tijdens een VP productie gebruikt worden",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 120
  },
  {
    "dep": "VFX en VP",
    "rol": "LED Technician",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het opzetten, verplaatsen en onderhouden van het LED scherm. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van de instructies ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Is verantwoordelijk voor het opzetten, verplaatsen en onderhouden van het LED scherm",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van de instructies ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 130
  },
  {
    "dep": "VFX en VP",
    "rol": "Lighting Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Maakt het mogelijk om diepte en realisme toe te voegen aan een door de computer gegenereerde (CG) scène door middel van verlichting. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Maakt het mogelijk om diepte en realisme toe te voegen aan een door de computer gegenereerde (CG) scène door middel van verlichting",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van de instructies ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 140
  },
  {
    "dep": "VFX en VP",
    "rol": "Matchmove Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Matcht camerabewegingen die zijn gemaakt op de set als virtuele camera tijdens de post productie. Maakt hiervoor een simpele layout van de scène in 3D voor verificatie. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van de instructies ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Matcht camerabewegingen die zijn gemaakt op de set als virtuele camera tijdens de post productie",
      "Werkt zowel in 2D als in 3D",
      "Maakt een simpele layout van de scène in 3D voor verificatie",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van de instructies ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 150
  },
  {
    "dep": "VFX en VP",
    "rol": "Modeler / Modeling Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Creëert karakters, wapens, planeten en dieren in 3D. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Creëert bijvoorbeeld karakters, wapens, planeten en dieren in 3D:",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 160
  },
  {
    "dep": "VFX en VP",
    "rol": "Motion Graphic Designer / Animator / Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Maakt en ontwerpt geanimeerde beelden zoals vormen, objecten, teksten en illustraties die gebruikt worden in films, series en commercials. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Maakt en ontwerpt geanimeerde beelden zoals vormen, objecten, teksten en illustraties die gebruikt worden in films, series en commercials",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 170
  },
  {
    "dep": "VFX en VP",
    "rol": "Playback Operator",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het besturen, aanpassen en afspelen van 2D/3D content op het LED scherm tijdens een VP shoot. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Is verantwoordelijk voor het besturen, aanpassen en afspelen van 2D/3D content op het LED scherm tijdens een VP shoot",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 180
  },
  {
    "dep": "VFX en VP",
    "rol": "Previs Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Maakt snelle, eenvoudige digitale animaties ter visualisatie van een scène, voordat deze wordt gemaakt. Helpt om te plannen hoe een film eruit gaat zien; Previs is het proces waarbij een scène wordt gevisualiseerd voordat deze wordt gemaakt. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak.. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Maakt snelle, eenvoudige digitale animaties ter visualisatie van een scène, voordat deze wordt gemaakt",
      "Helpt om te plannen hoe een film eruit gaat zien; Previs is het proces waarbij een scène wordt gevisualiseerd voordat deze wordt gemaakt",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 190
  },
  {
    "dep": "VFX en VP",
    "rol": "Real Time Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Maakt en beheert visuele content, zoals 3D omgevingen of sets, in bijvoorbeeld Unreal Engine (3D software). De werkzaamheden ondersteunen het werkproces en worden uitgevoerd met ruimte voor eigen inzicht en volgens een gestructureerde aanpak, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Maakt en beheert visuele content, zoals 3D omgevingen of sets, in bijvoorbeeld Unreal Engine (3D software)",
      "Verricht uitvoerende werkzaamheden ten behoeve van een ondersteunend werkproces",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 200
  },
  {
    "dep": "VFX en VP",
    "rol": "Real-time Compositor",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Voert specialistische werkzaamheden uit ter verbetering van bewegende beelden en geeft advies hierover. Analyseert en brengt bestaande materialen samen met (technische) oplossingen tot het gewenste eindresultaat. Het kan gaan om het samenvoegen van beeldlagen en/of het toepassen van technieken als maskeren. Ontvangt kaders en verwachtingen ten aanzien van het beoogde eindresultaat vanuit het Head of Department (HoD). Stemt departement overstijgend af met andere specialisten en andere Heads of Department (HoD). Kan programmeren en/of scripten om analyses en berekeningen te standaardiseren. Heeft inhoudelijk kennis van aanverwante departementen, waaronder photography en licht.",
    "bullets": [
      "Matcht kleuren van content op een LED scherm live tijdens een VP shoot",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 210
  },
  {
    "dep": "VFX en VP",
    "rol": "Rendering Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Houdt zich, voornamelijk, met het opzetten van 3D scenes en maakt de vertaling van 3D naar 2D beelden, als input voor de compositor. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Houdt zich, voornamelijk, met het opzetten van 3D scenes en maakt de vertaling van 3D naar 2D beelden, als input voor de compositor",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 220
  },
  {
    "dep": "VFX en VP",
    "rol": "Rigging Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Maakt onderhoudende en uitbreidende Rigs voor een verscheidenheid aan rekwisieten, voertuigen, personages en andere CG-objecten die moeten worden geanimeerd. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van de instructies ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Maakt onderhoudende en uitbreidende Rigs voor een verscheidenheid aan rekwisieten, voertuigen, personages en andere CG-objecten die moeten worden geanimeerd",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van de instructies ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 230
  },
  {
    "dep": "VFX en VP",
    "rol": "Roto Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Maakt maskers met getraceerde contouren, zodat objecten 'los' worden gehaald en in live-actie kunnen worden geïntegreerd in lagen voor films, tv-shows en videogames. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van de instructies ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Maakt maskers met getraceerde contouren, zodat objecten 'los' worden gehaald en in live-actie kunnen worden geïntegreerd in lagen voor films, tv-shows en videogames",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van de instructies ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 240
  },
  {
    "dep": "VFX en VP",
    "rol": "Texturing Artist",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Creëert oppervlaktestructuren en materialen voor (CG) 3D-modellen om deze er realistisch of stijlvoll te laten zien, zoals hout, metaal of roest. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak.Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Creëert oppervlaktestructuren en materialen voor (CG) 3D-modellen om deze er realistisch of stijlvoll te laten zien, zoals hout, metaal of roest",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 250
  },
  {
    "dep": "VFX en VP",
    "rol": "Typographic Designer",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Bedenkt en ontwerpt uitingen met typografie in een productie. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Bedenkt en ontwerpt het ontwerp uitingen met typografie in een productie",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 260
  },
  {
    "dep": "VFX en VP",
    "rol": "Unreal Developer VP",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Ontwikkelt tools in Unreal Engine (3D software) ter ondersteuning van het werk van specialisten binnen het departement. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht en volgens een gestructureerde aanpak, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Ontwikkelt tools in Unreal Engine (3D software)",
      "Verricht uitvoerende werkzaamheden ten behoeve van een ondersteunend werkproces",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de kaders van de instructies ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 270
  },
  {
    "dep": "VFX en VP",
    "rol": "VP Engineer",
    "niveaus": [
      "D",
      "E"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor ontwikkeling van hardware en software die een VP productie mogelijk maken. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Is verantwoordelijk voor ontwikkeling van hardware en software die een VP productie mogelijk maken",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 280
  },
  {
    "dep": "VFX en VP",
    "rol": "Animation Supervisor",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het bewaken van de kwaliteit en consistentie van animaties in het animatie departement. Werkt vanuit specialistische vaktechnische zelfstandig binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat, waarbij afstemming benodigd is die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft. Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden. Er is vooral contact binnen het eigen departement.",
    "bullets": [
      "Is verantwoordelijk voor het bewaken van de kwaliteit en consistentie van animaties in het animatie departement",
      "Werkt vanuit specialistische vaktechnische zelfstandig binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat",
      "Bij werkzaamheden is afstemming benodigd die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft",
      "Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden",
      "Er is vooral contact binnen het eigen departement"
    ],
    "volgorde": 290
  },
  {
    "dep": "VFX en VP",
    "rol": "Pipeline TD",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Ontwerpt de complete 'pipeline' tussen verschillende afdelingen zodat een VFX project soepel verloopt en elke afdeling over de benodigde softwaretools beschikt. Bouwt tools en scripts, lost knelpunten in het productisproces op en draagt zorg voor de technische automatisering van taken. De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders ten aanzien van de opdracht en het beoogde eindresultaat en een gestructureerde aanpak. Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen.",
    "bullets": [
      "Ontwerpt/script de hele 'pipeline' van het VFX traject voor een VFX studio",
      "Zorgt dat een VFX project soepel verloopt en dat elke afdeling over de softwaretools beschikt die benodigd zijn",
      "De werkzaamheden worden uitgevoerd met ruimte voor eigen inzicht, binnen de (creatieve en zakelijke) kaders ten aanzien van de opdracht en het beoogde eindresultaat en een gestructureerde aanpak",
      "Heeft met name contacten binnen het eigen team om af te stemmen en informatie uit te wisselen"
    ],
    "volgorde": 300
  },
  {
    "dep": "VFX en VP",
    "rol": "Story Board Artist",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Creëert visuele vertalingen van het script ten behoeve van heldere communicatie in de voorbereidingen van de productie. Werkt met de Regisseur en Director of Photography (DOP) samen om scènes te visualiseren. Werkt zelfstandig binnen de kaders van de opdracht en het beoogde eindresultaat, waarbij afstemming benodigd is die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft. Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden.",
    "bullets": [
      "Creëert visuele vertalingen van het script t.b.v. heldere communicatie in de voorbereidingen van de productie",
      "Werkt met de regisseur en Director of Photography (DOP) samen om scènes te visualiseren",
      "Werkt zelfstandig binnen de kaders van de opdracht en het beoogde eindresultaat",
      "Bij werkzaamheden is afstemming benodigd die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft",
      "Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden"
    ],
    "volgorde": 310
  },
  {
    "dep": "VFX en VP",
    "rol": "VFX Art Director",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voorhet visueel interpreteren van de ideëen van de Regisseur en andere Heads of Department. Handhaaft de look & feel van de VFX-onderdelen van de productie. Werkt zelfstandig binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat, waarbij afstemming benodigd is die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft. Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden. Er is vooral contact binnen het eigen departement.",
    "bullets": [
      "Is verantwoordelijk voor het visueel interpreteren van de ideeën van de Regisseur en andere Heads of Department",
      "Handhaaft de look & feel van de VFX-onderdelen van de productie",
      "Werkt zelfstandig binnen de (creatieve en zakelijke) kaders van de opdracht ten aanzien van het beoogde eindresultaat, waarbij afstemming benodigd is die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft",
      "Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden",
      "Er is vooral contact binnen het eigen departement"
    ],
    "volgorde": 320
  },
  {
    "dep": "VFX en VP",
    "rol": "VFX Coördinator",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Overziet de dagelijkse gang van zaken in het team en zorgt dat iedereen de informatie beschikt die nodig is om effectief te werken. Is verantwoordelijk voor het distribueren van de benodigde middelen en referenties naar de relevante afdelingen. Coördineert de voortgang en stelt planningen bij. Is de schakel tussen de VFX Producer en de artists. Stemt departement overstijgend af met andere specialisten.",
    "bullets": [
      "Overziet de dagelijkse gang van zaken in het team en zorgt dat iedereen de informatie beschikt die nodig is om effectief te werken",
      "Is verantwoordelijk voor het distribueren van de benodigde middelen en referenties naar de relevante afdelingen",
      "Coördineert de voortgang en stelt planningen bij",
      "Is de schakel tussen de VFX Producer en de artists",
      "Stemt departementoverstijgend af met andere specialisten"
    ],
    "volgorde": 330
  },
  {
    "dep": "VFX en VP",
    "rol": "VFX Editor / VFX Data Manager",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het organiseren, overdragen en opslaan van de computerbestanden en data. Werkt vanuit specialistische vaktechnische kennis waarbij afstemming benodigd is die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft. Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden. Er is vooral contact binnen het eigen departement.",
    "bullets": [
      "Is verantwoordelijk voor het organiseren, overdragen en opslaan van de computerbestanden en data",
      "Werkt vanuit specialistische vaktechnische kennis",
      "Werkt zelfstandig binnen de kaders van de opdracht ten behoeve van het resultaat, waarbij afstemming benodigd is die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft",
      "Bij het oplossen van problemen moeten er creatieve keuzes gemaakt worden binnen reeds bestaande oplossingsmogelijkheden",
      "Er is vooral contact binnen het eigen departement"
    ],
    "volgorde": 340
  },
  {
    "dep": "VFX en VP",
    "rol": "VFX generalist / Artist",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Voert meerdere taken uit bij het maken van een VFX shot. Levert gebundelde specialistische vaktechnische bijdrage. Werkt zelfstandig binnen de kaders van de opdracht ten behoeve van het beoogde eindresultaat, waarbij afstemming benodigd is die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft. Bij het oplossen van problemen worden er creatieve keuzes gemaakt  binnen reeds bestaande oplossingsmogelijkheden. Er is vooral contact binnen het eigen departement.",
    "bullets": [
      "Voert meerdere taken uit bij het maken van een VFX shot",
      "Levert gebundelde specialistische vaktechnische bijdrage",
      "Werkt zelfstandig binnen de kaders van de opdracht ten behoeve van het beoogde eindresultaat",
      "Bij werkzaamheden is afstemming benodigd die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft",
      "Bij het oplossen van problemen worden er creatieve keuzes gemaakt binnen reeds bestaande oplossingsmogelijkheden",
      "Er is vooral contact binnen het eigen departement"
    ],
    "volgorde": 350
  },
  {
    "dep": "VFX en VP",
    "rol": "VFX On Set Supervisor / VFX DATA Wrangler",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor de VFX op set en werkt vanuit specialistische vakkennis. Verzamelt relevante data ter informatie voor de VFX Artists. Werkt zelfstandig binnen de kaders van de opdracht ten behoeve van het beoogde resultaat, waarbij afstemming benodigd is die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft. Bij het oplossen van problemen worden er eigen creatieve keuzes gemaakt  binnen reeds bestaande oplossingsmogelijkheden. Heeft contact met andere HoD over de beste manier van het draaien van de VFX-plates.",
    "bullets": [
      "Is verantwoordelijk voor de VFX op set en werkt vanuit specialistische vakkennis",
      "Verzamelt relevante data ter informatie voor de VFX Artists",
      "Werkt zelfstandig binnen de kaders van de opdracht ten behoeve van het beoogde resultaat",
      "Bij werkzaamheden is afstemming benodigd die tamelijk specialistisch van aard is en een informerend en licht beïnvloedend karakter heeft",
      "Bij het oplossen van problemen worden er eigen creatieve keuzes gemaakt binnen reeds bestaande oplossingsmogelijkheden",
      "Heeft contact met andere HoD over de beste manier van het draaien van de VFX-plates"
    ],
    "volgorde": 360
  },
  {
    "dep": "VFX en VP",
    "rol": "VP Coördinator",
    "niveaus": [
      "F",
      "G"
    ],
    "aliases": [],
    "omschrijving": "Overziet de dagelijkse gang van zaken in het team en zorgt dat iedereen over de benodigde informatie beschikt om effectief te werken. Is verantwoordelijk voor het distribueren van de benodigde middelen en werkzaamheden naar de relevante afdelingen. Is de schakel tussen supervisor/producer en de artists en zorgt voor afstemming met specialisten uit diverse departementen.",
    "bullets": [
      "Overziet de dagelijkse gang van zaken en zorgt dat iedereen over de benodigde de informatie beschikt die nodig is om effectief te werken",
      "Is verantwoordelijk voor het distribueren van de benodigde middelen en werkzaamheden naar de relevante afdelingen",
      "Is de schakel tussen supervisor/producer en de artists",
      "Stemt departement overstijgend af met andere specialisten"
    ],
    "volgorde": 370
  },
  {
    "dep": "VFX en VP",
    "rol": "Compositor",
    "niveaus": [
      "G"
    ],
    "aliases": [],
    "omschrijving": "Voert specialistische werkzaamheden uit ter verbetering van bewegende beelden en geeft advies hierover. Analyseert en brengt bestaande materialen samen met (technische) oplossingen tot het gewenste eindresultaat. Het kan gaan om het samenvoegen van beeldlagen en/of het toepassen van technieken als maskeren. Ontvangt kaders en verwachtingen ten aanzien van het beoogde eindresultaat vanuit het Head of Department (HoD). Stemt departement overstijgend af met andere specialisten en andere Heads of Department (HoD). Kan programmeren en/of scripten om analyses en berekeningen te standaardiseren. Heeft inhoudelijk kennis van aanverwante departementen, waaronder photography en licht.",
    "bullets": [
      "Voert specialistische werkzaamheden uit ter verbetering van bewegende beelden en geeft advies hierover",
      "Analyseert en brengt bestaande materialen samen met (technische) oplossingen tot het gewenste eindresultaat",
      "Combineert meerdere beeldlagen (CG, live-action) tot één samenhangend beeld; voert beeldcorrecties uit zoals kleurafstemming, masking, rotoscoping",
      "Ontvangt kaders en verwachtingen ten aanzien van het beoogde eindresultaat vanuit het Head of Department (HoD)",
      "Stemt departement overstijgend af met andere specialisten en andere Heads of Department (HoD)",
      "Kan programmeren en/of scripten om analyses en berekeningen te standaardiseren",
      "Heeft inhoudelijk kennis van aanverwante departementen, waaronder photography en licht"
    ],
    "volgorde": 380
  },
  {
    "dep": "VFX en VP",
    "rol": "CG Supervisor",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor de levering en kwaliteit van de 3D computer-gegenereerde elementen van een VFX-project. Anticipeert op te nemen besluiten in eerdere productiefasen door werkzaamheden (van het team) daarop af te stemmen en in te richten. Organiseert en begeleid reviewsessies met eigen team, haalt feedback op, brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor het eigen vakgebied. Is de schakel tussen de VFX Supervisor en CG (computer generated) team en rapporteert mede aan de VFX Producer.",
    "bullets": [
      "Is verantwoordelijk voor de levering en kwaliteit van de 3D computer-gegenereerde elementen van een VFX-project",
      "Anticipeert op te nemen besluiten in eerdere productiefasen door werkzaamheden (van het team) daarop af te stemmen en in te richten",
      "Organiseert en begeleid reviewsessies met eigen team, haalt feedback op, brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor het eigen vakgebied",
      "Is de schakel tussen de VFX Supervisor en CG (computer generated) team",
      "Rapporteert mede aan de VFX Producer"
    ],
    "volgorde": 390
  },
  {
    "dep": "VFX en VP",
    "rol": "Compositing Supervisor",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor de levering en kwaliteit van aanpassingen aan bewegende beelden. Anticipeert op te nemen besluiten in eerdere productiefasen door werkzaamheden (van het team) daarop af te stemmen en in te richten. Organiseert en begeleidt reviewsessies met eigen team, haalt feedback op, brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor het eigen vakgebied. Is de schakel tussen de VFX Supervisor en het compositing team en rapporteert mede aan de VFX Producer.",
    "bullets": [
      "Is verantwoordelijk voor de levering en kwaliteit van aanpassingen aan bewegende beelden",
      "Anticipeert op te nemen besluiten in eerdere productiefasen door werkzaamheden (van het team) daarop af te stemmen en in te richten",
      "Organiseert en begeleidt reviewsessies met eigen team, haalt feedback op, brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor het eigen vakgebied",
      "Is de schakel tussen de VFX Supervisor en compositing team",
      "Rapporteert mede aan de VFX Producer"
    ],
    "volgorde": 400
  },
  {
    "dep": "VFX en VP",
    "rol": "Lead CG Artist",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Maakt 3D-objecten en omgevingen en bewaakt de creatieve richting op basis van kwaliteit, stijl en de planning van de audiovisuele productie. Stuurt het CG-team aan, organiseert en begeleid reviewsessies met eigen team, haalt feedback op, brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor de eigen werkzaamheden. Begeleidt en ondersteunt andere CG Artists.",
    "bullets": [
      "Maakt digitale 3D-objecten en omgevingen",
      "Bewaakt de creatieve richting op basis van kwaliteit, stijl en de planning van de audiovisuele productie",
      "Organiseert en begeleid reviewsessies met eigen team, haalt feedback op, brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor de eigen werkzaamheden",
      "Begeleidt en ondersteunt andere CG Artists"
    ],
    "volgorde": 410
  },
  {
    "dep": "VFX en VP",
    "rol": "Technical Director",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Is een expert op het gebied van de technische workflow van het visual effects traject, zoals het opzetten en onderhouden van de pipeline en het ontwikkelen van in-house tools. Anticipeert op te nemen besluiten in eerdere productiefasen door werkzaamheden (van het team) daarop af te stemmen en in te richten. Brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor het eigen vakgebied.",
    "bullets": [
      "Is een expert op het gebied van de technische workflow van het visual effects traject, zoals het opzetten en onderhouden van de pipeline en het ontwikkelen van in-house tools",
      "Anticipeert op te nemen besluiten in eerdere productiefasen door werkzaamheden (van het team) daarop af te stemmen en in te richten",
      "Brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor het eigen vakgebied"
    ],
    "volgorde": 420
  },
  {
    "dep": "VFX en VP",
    "rol": "VFX Producer",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Fungeert vanuit de VFX als eerste aanspreekpunt richting Postproductie Manager, Line Producer, regie en HOD's. Coördineert met regie, DoP, production design, VFX Supervisor en VFX Editor tijdens preproductie, set en post, en organiseert reviews, turnovers en deliveries. Beheert een deelbudget van een grote productie en maakt afspraken over de invulling daarvan met stakeholders. Overziet meerdere planningen en integreert wensen en consequenties voor departementen in de postproductie in het eigen aandachtsgebied. Stuurt het interne VFX-productieteam aan, signaleert knelpunten en doet voorstellen om die op te lossen. Rapporteert periodiek aan Postproductie Manager en Line Producer over voortgang, kosten en risico's. Is verantwoordelijk voor de zakelijke planning en techniek en werkt nauw samen met de VFX Supervisor voor afstemming en uitwisseling.",
    "bullets": [
      "Fungeert vanuit de VFX als eerste aanspreekpunt richting Postproductie Manager, Line Producer, regie en HOD’s",
      "Coördineert met regie, DoP, production design, VFX Supervisor en VFX Editor tijdens preproductie, set en post",
      "Organiseert reviews, turnovers en deliveries",
      "Beheert een deelbudget van een grote productie en maakt afspraken over de invulling daarvan met stakeholders",
      "Overziet meerdere planningen en integreert wensen en consequenties voor departementen in de postproductie in het eigen aandachtsgebied",
      "Houdt rekening met subsidie- en incentive-voorwaarden en zorgt voor eindafrekening en formele deliverables",
      "Signaleert knelpunten daarbinnen, doet voorstellen om die op te lossen en bespreekt die met de Postproductie Manager",
      "Stuurt het interne VFX-productieteam aan en rapporteert periodiek aan Postproductie Manager en Line Producer over voortgang, kosten en risico’s",
      "Is verantwoordelijk voor de zakelijke planning en techniek en werkt nauw samen met de VFX Supervisor voor afstemming en uitwisseling"
    ],
    "volgorde": 430
  },
  {
    "dep": "VFX en VP",
    "rol": "VFX Production Manager",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Maakt de gedetailleerde planning voor het project en bewaakt het budget binnen de kaders en richtlijnen vanuit de VFX-producent ten behoeve van het beoogde resultaat. Werkt zelfstandig vanuit eigen vakkennis en speelt in op onvoorziene omstandigheden.",
    "bullets": [
      "Plant en coördineert het volledige VFX-traject binnen de postproductie",
      "Bewaakt het budget binnen de kaders en richtlijnen vanuit de VFX-producent ten behoeve van het beoogde resultaat",
      "Maakt  gedetailleerde VFX planningen, bewaakt deadlines en houdt overzicht op VFX-leveringen Werkt zelfstandig vanuit eigen vakkennis en speelt in op onvoorziene omstandigheden."
    ],
    "volgorde": 440
  },
  {
    "dep": "VFX en VP",
    "rol": "VFX Supervisor",
    "niveaus": [
      "H"
    ],
    "aliases": [],
    "omschrijving": "Stelt het (VFX) team samen dat specialistische werkzaamheden binnen alle aspecten van de VFX productie uitvoert en geeft daar sturing aan en/of adviseert de Regisseur en Producent in alle productiefasen op het eigen én enkele aanverwante departementen, waaronder photography en licht. Anticipeert op te nemen besluiten in eerdere productiefasen door werkzaamheden (van het team) daarop af te stemmen en in te richten. Organiseert en begeleidt reviewsessies met productie en regie, haalt feedback op, brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor het eigen vakgebied.",
    "bullets": [
      "Stelt het (VFX) team samen en geeft sturing aan de specialistische werkzaamheden binnen alle aspecten van de VFX productie ten behoeve van het resultaat",
      "Adviseert Regisseur en Producent in alle productiefasen op het eigen én enkele aanverwante departementen, waaronder photography en licht",
      "Anticipeert op te nemen besluiten in eerdere productiefasen door werkzaamheden (van het team) daarop af te stemmen en in te richten",
      "Organiseert en begeleidt reviewsessies met productie en regie, haalt feedback op, brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor het eigen vakgebied",
      "Is verantwoordelijk voor de creatieve invulling en werkt nauw samen met de VFX Supervisor voor afstemming en uitwisseling"
    ],
    "volgorde": 450
  },
  {
    "dep": "VFX en VP",
    "rol": "Virtual Camera Supervisor",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het camera en motion tracking systeem voor een VP shoot. Anticipeert op te nemen besluiten in eerdere productiefasen door werkzaamheden (van het team) daarop af te stemmen en in te richten. Organiseert en begeleid reviewsessies met eigen team, haalt feedback op, brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor het eigen vakgebied. Overlegt met DoP en VP Supervisor.",
    "bullets": [
      "Is verantwoordelijk voor het camera en motion tracking systeem voor een VP shoot",
      "Anticipeert op te nemen besluiten in eerdere productiefasen door werkzaamheden (van het team) daarop af te stemmen en in te richten",
      "Organiseert en begeleid reviewsessies met eigen team, haalt feedback op, brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor het eigen vakgebied",
      "Overlegt met DoP en VP Supervisor"
    ],
    "volgorde": 460
  },
  {
    "dep": "VFX en VP",
    "rol": "VP Producer",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Fungeert vanuit de VP als eerste aanspreekpunt richting Postproductie Manager, Line Producer, regie en HOD’s. Coördineert met regie, DoP, production design, VFX Supervisor en VFX Editor tijdens preproductie, set en post; organiseert reviews, turnovers en deliveries. Beheert een deelbudget van een grote productie en maakt afspraken over de invulling daarvan met stakeholders. Overziet meerdere planningen en integreert wensen en consequenties voor departementen in de postproductie in het eigen aandachtsgebied. Stuurt het interne VFX-productieteam aan, signaleert knelpunten en doet voorstellen om die op te lossen. Rapporteert periodiek aan Postproductie Manager en Line Producer over voortgang, kosten en risico’s. Is verantwoordelijk voor de zakelijke planning en techniek en werkt nauw samen met de VP Supervisor voor afstemming en uitwisseling.",
    "bullets": [
      "Fungeert vanuit de VFX als eerste aanspreekpunt richting Postproductie Manager, Line Producer, regie en HOD’s",
      "Coördineert met regie, DoP, production design, VFX Supervisor en VFX Editor tijdens preproductie, set en post; organiseert reviews, turnovers en deliveries",
      "Beheert een deelbudget van een grote productie en maakt afspraken over de invulling daarvan met stakeholders",
      "Overziet meerdere planningen en integreert wensen en consequenties voor departementen in de postproductie in het eigen aandachtsgebied",
      "Houdt rekening met subsidie- en incentive-voorwaarden en zorgt voor eindafrekening en formele deliverables",
      "Signaleert knelpunten daarbinnen, doet voorstellen om die op te lossen en bespreekt die met de Postproductie Manager",
      "Stuurt het interne VFX-productieteam aan en rapporteert periodiek aan Postproductie Manager en Line Producer over voortgang, kosten en risico’s",
      "Is verantwoordelijk voor de zakelijke planning en techniek en werkt nauw samen met de VFX Supervisor voor afstemming en uitwisseling"
    ],
    "volgorde": 470
  },
  {
    "dep": "VFX en VP",
    "rol": "VP Supervisor",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Is verantwoordelijk voor het coördineren en het technisch/creatief aansturen van alle VP onderdelen binnen een procutie. Adviseert de Regisseur en Producent in alle productiefasen op het eigen én enkele aanverwante departementen, waaronder photography en licht. Is tijdens de shoot aanwezig op de set en stuurt een specialistisch team van Real Time Artist aan ten behoeve van het beoogde eindresultaat . Anticipeert op besluiten die in eerdere productiefasen moeten worden genomen door werkzaamheden (van het team) daarop af te stemmen en in te richten. Organiseert en begeleid reviewsessies met productie en regie, haalt feedback op, brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor het eigen vakgebied. Werkt nauw samen met de VFX Supervisor voor uitwisseling van informatie.",
    "bullets": [
      "Is verantwoordelijk voor het coördineren en het technisch/creatief aansturen van alle VP onderdelen, binnen een productie",
      "Adviseert de Regisseur en Producent in alle productiefasen op het eigen én enkele aanverwante departementen, waaronder photography en licht",
      "Stelt een specialistisch team samen van Real Time Artists en stuurt deze aan ten behoeve van het beoogde eindresultaat",
      "Anticipeert op te nemen besluiten in eerdere productiefasen door werkzaamheden (van het team) daarop af te stemmen en in te richten",
      "Is tijdens de shoot aanwezig op de set in de buurt van regie, DoP en Opnameleider om te horen wat er gebeurt en daar op in te springen",
      "Organiseert en begeleid reviewsessies met productie en regie, haalt feedback op, brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor het eigen vakgebied",
      "Werkt nauw samen met de VFX Supervisor voor uitwisseling van informatie"
    ],
    "volgorde": 480
  },
  {
    "dep": "VFX en VP",
    "rol": "VP Technical Director",
    "niveaus": [
      "H",
      "I"
    ],
    "aliases": [],
    "omschrijving": "Is een expert op het gebied van de technische workflow van het VP traject. Zet de technische workflow van het VP traject op en draagt zorg voor het onderhoudt ervan. Anticipeert op te nemen besluiten in eerdere productiefasen door werkzaamheden (van het team) daarop af te stemmen en in te richten. Brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor het eigen vakgebied.",
    "bullets": [
      "Is een expert op het gebied van de technische workflow van het VP traject",
      "Zet de technische workflow van het VP traject op en draagt zorg voor het onderhoudt ervan",
      "Anticipeert op te nemen besluiten in eerdere productiefasen door werkzaamheden (van het team) daarop af te stemmen en in te richten",
      "Brengt informatie samen en verwerkt dat door te vertalen naar resultaten en doelen voor het eigen vakgebied"
    ],
    "volgorde": 490
  }
];

export const rollenFestival = [
  {
    "dep": "Bedrijfsvoering",
    "rol": "Officemedewerker",
    "niveaus": [
      "3"
    ],
    "aliases": [
      "Medewerker Financiële Administratie (KAF)",
      "Financieel Medewerker (MtM)",
      "Front Office support (IFFR)"
    ],
    "omschrijving": "Het verzorgen van administratieve ondersteuning van de organisatie.",
    "bullets": [],
    "volgorde": 1010
  },
  {
    "dep": "Bedrijfsvoering",
    "rol": "Officemanager",
    "niveaus": [
      "5"
    ],
    "aliases": [
      "Office Manager + (schaal 6) (Cinekid)",
      "Medewerker Financiële Administratie & Organisatie (NFF)"
    ],
    "omschrijving": "Levert ondersteuning op administratief, secretarieel en facilitair gebied ten behoeve van de primaire en ondersteunende processen binnen de organisatie. Realiseert de met de leidinggevende afgesproken doelstellingen.",
    "bullets": [],
    "volgorde": 1020
  },
  {
    "dep": "Bedrijfsvoering",
    "rol": "HR Manager",
    "niveaus": [
      "8"
    ],
    "aliases": [],
    "omschrijving": "De HR manager draagt zorg voor het personeelsbeleid en is als zodanig medeverantwoordelijk voor de continuïteit van de organisatie als geheel.",
    "bullets": [],
    "volgorde": 1030
  },
  {
    "dep": "Bedrijfsvoering",
    "rol": "Controller",
    "niveaus": [
      "9"
    ],
    "aliases": [],
    "omschrijving": "Draagt zorg voor het (doen) opstellen en de uitvoering van de planning en controlecyclus. Zorgt voor de controle op het strategisch financieel beleid, in samenspraak met de directie.",
    "bullets": [],
    "volgorde": 1040
  },
  {
    "dep": "Development",
    "rol": "Medewerker Development A",
    "niveaus": [
      "5"
    ],
    "aliases": [
      "Medewerker Fondsenwerving (NFF)",
      "Senior Partnerships Manager (IDFA)",
      "Coordinator Development & Sales (Cinekid)",
      "Fundraiser (MtM)"
    ],
    "omschrijving": "Het ondersteunen van de fondsen en sponsorwervers en uitvoering geven aan development werkzaamheden binnen de afdeling. Het realiseren van de met de leidinggevende afgesproken doelstellingen.",
    "bullets": [],
    "volgorde": 2010
  },
  {
    "dep": "Development",
    "rol": "Medewerker Development B",
    "niveaus": [
      "6"
    ],
    "aliases": [
      "Development Coordinator (IDFA)",
      "Coordinator Donations, Mecenaat & Events (IFFR)"
    ],
    "omschrijving": "Het ondersteunen van de fondsen en sponsorwervers en uitvoering geven aan development werkzaamheden binnen de afdeling. Het realiseren van de met de leidinggevende afgesproken doelstellingen.",
    "bullets": [],
    "volgorde": 2020
  },
  {
    "dep": "Development",
    "rol": "Fondsenwerver / Coördinator Development",
    "niveaus": [
      "7"
    ],
    "aliases": [
      "Coordinator Funding and Private Partners (IFFR)",
      "Partnerships Manager (IDFA)",
      "Projectmanager Partner Events (IDFA)",
      "Private Donations Manager (IDFA)"
    ],
    "omschrijving": "Het operationeel zorgdragen voor de uitvoering van het development beleid/jaarplan van de organisatie en verantwoordelijkheid voor de operationele werkzaamheden met betrekking tot de fondsen, partners en stakeholders. Realiseert de met de leidinggevende afgesproken doelstellingen en werkt nauw samen met het development team om nieuwe zakelijke kansen te identificeren en te benutten.",
    "bullets": [],
    "volgorde": 2030
  },
  {
    "dep": "Development",
    "rol": "Hoofd Development A",
    "niveaus": [
      "7"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het sponsor- en fondsenbeleid. Levert een bijdrage aan het strategisch beleid en is verantwoordelijk voor het aansturen en stroomlijnen van afdelingsprocessen en de dagelijkse aansturing van het team. Is medeverantwoordelijk voor de continuïteit van de organisatie als geheel.",
    "bullets": [],
    "volgorde": 2040
  },
  {
    "dep": "Development",
    "rol": "Hoofd Development B",
    "niveaus": [
      "8"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het sponsor- en fondsenbeleid. Levert een bijdrage aan het strategisch beleid en is verantwoordelijk voor het aansturen en stroomlijnen van afdelingsprocessen en de dagelijkse aansturing van het team. Is medeverantwoordelijk voor de continuïteit van de organisatie als geheel.",
    "bullets": [],
    "volgorde": 2050
  },
  {
    "dep": "Development",
    "rol": "Hoofd Development C",
    "niveaus": [
      "9"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het sponsor- en fondsenbeleid. Levert een bijdrage aan het strategisch beleid en is verantwoordelijk voor het aansturen en stroomlijnen van afdelingsprocessen en de dagelijkse aansturing van het team. Is medeverantwoordelijk voor de continuïteit van de organisatie als geheel.",
    "bullets": [],
    "volgorde": 2060
  },
  {
    "dep": "Marketing & Communicatie",
    "rol": "Medewerker Marketing & Communicatie A",
    "niveaus": [
      "5"
    ],
    "aliases": [
      "Content Marketeer (NFF)",
      "International Press Officer (IDFA)",
      "Dutch Press Officer (IDFA)",
      "Online Marketeer (IDFA)",
      "Designer (IDFA)",
      "Communication Producer (IDFA)",
      "Communication Coordinator (IDFA)",
      "Image Editor (IDFA)",
      "Online Editor (IDFA)",
      "Social Media/Webeditor (IDFA)",
      "Copy Editor (IDFA)",
      "Online Redacteur (IDFA)",
      "Medewerker Marketing & Communicatie (Cinekid)",
      "Copywriter (KAF)",
      "Editor (KAF)",
      "Graphic Designer (KAF)",
      "Online Communication & Web-Editing (KAF)",
      "Online Marketeer / Marketeer Publiek & Festival (MtM)",
      "Audiences & Communities Assistant (IFFR)",
      "Image Coordinator (IFFR)",
      "Editorial Coordinator - Dutch (IFFR)"
    ],
    "omschrijving": "Het zorgdragen voor de uitvoering van (digitale) marketingprojecten en -processen op de afdeling marketing en communicatie en deels als uitvoerende betrokken bij deze projecten en processen. Realiseren van de met de leidinggevende afgesproken doelstellingen.",
    "bullets": [],
    "volgorde": 3010
  },
  {
    "dep": "Marketing & Communicatie",
    "rol": "Medewerker Marketing & Communicatie B",
    "niveaus": [
      "6"
    ],
    "aliases": [
      "Coordinator Communication (IDFA)",
      "Senior Editor (IDFA)",
      "Coordinator Audiences & Communities (IFFR)",
      "Traffic Coordinator (IFFR)",
      "Coordinator Marketing (IFFR)",
      "Editorial Coordinator (IFFR)",
      "Press & PR Coordinator (IFFR)",
      "Coordinator Socials & Communities & Merchandise (IFFR)"
    ],
    "omschrijving": "Het zorgdragen voor de uitvoering van (digitale) marketingprojecten en -processen op de afdeling marketing en communicatie en deels als uitvoerende betrokken bij deze projecten en processen. Realiseren van de met de leidinggevende afgesproken doelstellingen.",
    "bullets": [],
    "volgorde": 3020
  },
  {
    "dep": "Marketing & Communicatie",
    "rol": "Coördinator Marketing & Communicatie",
    "niveaus": [
      "7"
    ],
    "aliases": [
      "Coordinator Marketing & Communicatie (Cinekid)",
      "Coordinator Marketing & Communications Pro (IFFR)",
      "Data Marketeer (IFFR)"
    ],
    "omschrijving": "Het in operationele zin zorg dragen voor de uitvoering van het marketing & communicatie beleid/jaarplan van de organisatie en coördineren van de projecten en processen van de afdeling. Realiseren van de met de leidinggevende afgesproken doelstellingen.",
    "bullets": [],
    "volgorde": 3030
  },
  {
    "dep": "Marketing & Communicatie",
    "rol": "Hoofd Marketing & Communicatie A",
    "niveaus": [
      "7"
    ],
    "aliases": [
      "Head of Marketing, Communication & Press (IDFA)"
    ],
    "omschrijving": "Het ontwikkelen en uitvoeren van het marketing- en communicatiebeleid en PR beleid, zowel naar publiek als naar (inter)nationale professionals. Levert een bijdrage aan het strategisch beleid en is verantwoordelijk voor het aansturen en stroomlijnen van afdelingsprocessen en de dagelijkse aansturing van het team. Is medeverantwoordelijk voor de continuïteit van de organisatie als geheel.",
    "bullets": [],
    "volgorde": 3040
  },
  {
    "dep": "Marketing & Communicatie",
    "rol": "Hoofd Marketing & Communicatie B",
    "niveaus": [
      "8"
    ],
    "aliases": [
      "Head of Communications (IFFR)"
    ],
    "omschrijving": "Het ontwikkelen en uitvoeren van het marketing- en communicatiebeleid en PR beleid, zowel naar publiek als naar (inter)nationale professionals. Levert een bijdrage aan het strategisch beleid en is verantwoordelijk voor het aansturen en stroomlijnen van afdelingsprocessen en de dagelijkse aansturing van het team. Is medeverantwoordelijk voor de continuïteit van de organisatie als geheel.",
    "bullets": [],
    "volgorde": 3050
  },
  {
    "dep": "Marketing & Communicatie",
    "rol": "Hoofd Marketing & Communicatie C",
    "niveaus": [
      "9"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het marketing- en communicatiebeleid en PR beleid, zowel naar publiek als naar (inter)nationale professionals. Levert een bijdrage aan het strategisch beleid en is verantwoordelijk voor het aansturen en stroomlijnen van afdelingsprocessen en de dagelijkse aansturing van het team. Is medeverantwoordelijk voor de continuïteit van de organisatie als geheel.",
    "bullets": [],
    "volgorde": 3060
  },
  {
    "dep": "Productie",
    "rol": "Medewerker Productie A",
    "niveaus": [
      "5"
    ],
    "aliases": [
      "Events Producer (IFFR)",
      "Productie Assistent (IFFR)",
      "Customer Service Coordinator (IFFR)",
      "Productieloket (IFFR)",
      "Location Manager (IFFR)",
      "Stagemanager (IFFR)",
      "Specialistisch Bouwer (IFFR)",
      "Hospitality Coordinator (IFFR)",
      "Guest Officer (IFFR)",
      "Carservice Producer (IFFR)",
      "Volunteer Coordinator (IDFA)",
      "Location Producent (IDFA)",
      "Building Facilitator (IDFA)",
      "Logistics & Decoration Producer (IDFA)",
      "Operateur (IDFA)",
      "Q&A Producer (IDFA)",
      "Hospitality Producer (IDFA)",
      "Technical Producer (IDFA)",
      "Floor Coordinator (IDFA)",
      "Executive Producer (KAF)",
      "Program Producer (KAF)",
      "Festival Producent (KAF)",
      "Ticketing & Helpdesk Coordinator (KAF)",
      "Ticketing Manager (KAF)",
      "Film Control (KAF)",
      "Projectionist (KAF)",
      "Sound Engineer (KAF)",
      "Technician (KAF)",
      "Technical location Manager (KAF)",
      "Guest Manager (KAF)",
      "Locatiemanager (KAF)",
      "Roommanager (KAF)",
      "IT Manager (KAF)",
      "Vrijwilligerscoördinator (KAF)",
      "Industry Coordinator (MtM)",
      "Kassa Coördinator (MtM)",
      "Education Producer (MtM)",
      "Vrijwilligers Coördinator (MtM)",
      "Kassa Subcoördinator (MtM)",
      "Gastenservice (MtM)",
      "Ass. Vrijwilligers Coördinator (MtM)",
      "Ass. Productie (MtM)",
      "Locatiemanager (MtM)"
    ],
    "omschrijving": "Productionele ondersteuning en uitvoering festival- plus daarbij behorende projecten en activiteiten.",
    "bullets": [],
    "volgorde": 4010
  },
  {
    "dep": "Productie",
    "rol": "Medewerker Productie B",
    "niveaus": [
      "6"
    ],
    "aliases": [
      "Senior Technical Producer (IDFA)",
      "Coordinator Cinema Techniek (IDFA)",
      "Event Coordinator (IDFA)",
      "HR Coordinator & Executive Assistant (IDFA)",
      "Festival Producer (IDFA)",
      "Bouwploeg Coordinator (IFFR)",
      "Ticketing specialist (IFFR)",
      "Events Producer (IFFR)"
    ],
    "omschrijving": "Productionele ondersteuning en uitvoering festival- plus daarbij behorende projecten en activiteiten.",
    "bullets": [],
    "volgorde": 4020
  },
  {
    "dep": "Productie",
    "rol": "Coördinator Productie / Producer",
    "niveaus": [
      "7"
    ],
    "aliases": [
      "Coordinator Applications (IFFR)",
      "Coordinator Ticketing & Data (IFFR)",
      "Volunteers Coordinator (IFFR)",
      "Facilities Producer (IFFR)",
      "Locations & Events Coordinator (IFFR)",
      "Client Relations and Hospitality Producer (IFFR)",
      "Festival Producer (MtM)",
      "Coördinator ICT & Applicatiebeheer (MtM)"
    ],
    "omschrijving": "Het zelfstandig één of meerdere projecten en/of activiteiten zoals voorstellingen/evenementen/bijeenkomsten van het filmfestival productioneel voorbereiden en uitvoeren.",
    "bullets": [],
    "volgorde": 4030
  },
  {
    "dep": "Productie",
    "rol": "Hoofd Productie A",
    "niveaus": [
      "7"
    ],
    "aliases": [
      "Hoofd Productie & ICT (NFF)",
      "Hoofd Productie & Digital (IDFA)",
      "Hoofd Technische Productie (KAF)"
    ],
    "omschrijving": "Het ontwikkelen en uitvoeren van het productiebeleid: de logistieke, facilitaire en technische realisatie van het filmfestival. Levert een bijdrage aan het strategisch beleid van de organisatie. Is verantwoordelijk voor het aansturen en stroomlijnen van afdelingsprocessen en de dagelijkse aansturing van het productieteam. Draagt mede zorg voor de continuïteit van de organisatie als geheel.",
    "bullets": [],
    "volgorde": 4040
  },
  {
    "dep": "Productie",
    "rol": "Hoofd Productie B",
    "niveaus": [
      "8"
    ],
    "aliases": [
      "Head of Production (IFFR)"
    ],
    "omschrijving": "Het ontwikkelen en uitvoeren van het productiebeleid: de logistieke, facilitaire en technische realisatie van het filmfestival. Levert een bijdrage aan het strategisch beleid van de organisatie. Is verantwoordelijk voor het aansturen en stroomlijnen van afdelingsprocessen en de dagelijkse aansturing van het productieteam. Draagt mede zorg voor de continuïteit van de organisatie als geheel.",
    "bullets": [],
    "volgorde": 4050
  },
  {
    "dep": "Productie",
    "rol": "Hoofd Productie C",
    "niveaus": [
      "9"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het productiebeleid: de logistieke, facilitaire en technische realisatie van het filmfestival. Levert een bijdrage aan het strategisch beleid van de organisatie. Is verantwoordelijk voor het aansturen en stroomlijnen van afdelingsprocessen en de dagelijkse aansturing van het productieteam. Draagt mede zorg voor de continuïteit van de organisatie als geheel.",
    "bullets": [],
    "volgorde": 4060
  },
  {
    "dep": "Programmering",
    "rol": "Medewerker Programma A",
    "niveaus": [
      "5"
    ],
    "aliases": [
      "Coordinator Education (IFFR)",
      "Coordinator Program Operations (IFFR)",
      "Officer Education (IFFR)",
      "Officer Program Operations (IFFR)",
      "Q&A Co-coordinator (IFFR)",
      "Hubert Bals Fund Officer (IFFR)",
      "Zakelijk Medewerker Programma (NFF)",
      "Programma Producer Professionals & Talent (NFF)",
      "Talks Producer (IDFA)",
      "Educatie Producent (IDFA)",
      "Producer Education (IDFA)",
      "Producer Filmmaker Support (IDFA)",
      "Producer Guest Service (IDFA)",
      "Producer Industry (IDFA)",
      "Producer New Media (IDFA)",
      "Program Producer (IDFA)",
      "IDFA IBF Producer (IDFA)",
      "Senior Talks Producer (IDFA)",
      "Forum Producer (IDFA)",
      "Markets Producer (IDFA)",
      "Producent Educatie (Cinekid)",
      "Producent Films & Series (Cinekid)",
      "Coordinator Cinekid for Professionals (Cinekid)",
      "Projectleider Participatie & Verbinding (Cinekid)",
      "Medewerker Educatie Buitenschools (Cinekid)",
      "Film Reviewer (KAF)",
      "Moderator (KAF)",
      "Industry Coordinator (KAF)",
      "Medewerker Kaboom Distribution (KAF)",
      "Medewerker Kaboom Education (KAF)",
      "Producent Industry (KAF)",
      "Medewerker Educatie (MtM)",
      "Jury Coördinator (MtM)"
    ],
    "omschrijving": "Operationaliseert vanuit de artistieke visie van de organisatie verschillende (competitie, reguliere en speciale) programma's en randactiviteiten (of educatie- en/of talent- en/of industry- en/of nieuwe mediaprogramma's en activiteiten). Geeft zelfstandig op dagelijkse basis uitvoering aan uitvoerende werkzaamheden en realiseert hierbij de met de leidinggevende afgesproken doelstellingen.",
    "bullets": [],
    "volgorde": 5010
  },
  {
    "dep": "Programmering",
    "rol": "Medewerker Programma B",
    "niveaus": [
      "6"
    ],
    "aliases": [
      "Coordinator Filmmaker Support (IDFA)",
      "Coordinator Ticketing and Customer Service (IFFR)",
      "Program Coordinator (IDFA)",
      "Manager IDFA Bertha Fund (IDFA)",
      "Producent Film & Series (Cinekid)",
      "Coordinator Education (IFFR)",
      "Coordinator Hubert Bals Fund (IFFR)",
      "Coordinator Pro (IFFR)",
      "Coordinator Program Operations (IFFR)"
    ],
    "omschrijving": "Operationaliseert vanuit de artistieke visie van de organisatie verschillende (competitie, reguliere en speciale) programma's en randactiviteiten (of educatie- en/of talent- en/of industry- en/of nieuwe mediaprogramma's en activiteiten). Geeft zelfstandig op dagelijkse basis uitvoering aan uitvoerende werkzaamheden en realiseert hierbij de met de leidinggevende afgesproken doelstellingen.",
    "bullets": [],
    "volgorde": 5020
  },
  {
    "dep": "Programmering",
    "rol": "Programmeur A",
    "niveaus": [
      "7"
    ],
    "aliases": [
      "Selection Committee Member (IFFR)",
      "Curator Digitale Cultuur (NFF)",
      "Programmer (IDFA)",
      "Programma Manager (IDFA)",
      "Curator (KAF)",
      "Programmeur (KAF)",
      "Junior Programmeur (KAF)",
      "Senior Programmer (MtM)"
    ],
    "omschrijving": "Het ontwikkelen en organiseren van een enkelvoudig inhoudelijk programma-onderdeel van het festival in het geval van een programmeur A of meervoudige inhoudelijke programma-onderdelen in het geval van een programmeur B binnen de daarvoor beschikbare budgetten.",
    "bullets": [],
    "volgorde": 5030
  },
  {
    "dep": "Programmering",
    "rol": "Coördinator Programma A",
    "niveaus": [
      "7"
    ],
    "aliases": [
      "Senior Producer Markets (IDFA)",
      "Coordinator Digital (IDFA)",
      "IT Specialist (IDFA)",
      "Finance Manager (IDFA)",
      "Operations Manager (IDFA)",
      "Coordinator RTM (IFFR)",
      "Coordinator Programme Operations (IFFR)",
      "Coordinator Education (IFFR)",
      "Coordinator Pro (IFFR)",
      "Coordinator HBF (IFFR)",
      "Projectleider Educatie (Cinekid)",
      "Coordinator Cinekid for Professionals (Cinekid)",
      "Verdiepingscoördinator (MtM)"
    ],
    "omschrijving": "Houdt toezicht op de dagelijkse uitvoering van de operationele taken binnen het programmadomein. Draagt bij aan het opstellen van het afdelingsbeleid.",
    "bullets": [],
    "volgorde": 5040
  },
  {
    "dep": "Programmering",
    "rol": "Hoofd Programma A",
    "niveaus": [
      "7"
    ],
    "aliases": [
      "Chief of Content (IFFR)",
      "Hoofd Programma & Educatie (NFF)",
      "Hoofd Professionals & Talent (NFF)",
      "Head of Education (IDFA)",
      "Head of Talent IDFAcademy (IDFA)",
      "Head of Industry (IDFA)",
      "Hoofd Medialab (Cinekid)",
      "Head of Industry (KAF)",
      "Hoofd Programma Afdeling (KAF)",
      "Head of Education (MtM)"
    ],
    "omschrijving": "Het ontwikkelen en uitvoeren van het programmabeleid. Levert een bijdrage aan het strategisch beleid van de organisatie. Is verantwoordelijk voor het aansturen en stroomlijnen van afdelingsprocessen en de dagelijkse aansturing van het team. Is medeverantwoordelijk voor de continuïteit van de organisatie als geheel.",
    "bullets": [],
    "volgorde": 5050
  },
  {
    "dep": "Programmering",
    "rol": "Programmeur B",
    "niveaus": [
      "8"
    ],
    "aliases": [
      "Senior Programmer (IDFA)"
    ],
    "omschrijving": "Het ontwikkelen en organiseren van een enkelvoudig inhoudelijk programma-onderdeel van het festival in het geval van een programmeur A of meervoudige inhoudelijke programma-onderdelen in het geval van een programmeur B binnen de daarvoor beschikbare budgetten.",
    "bullets": [],
    "volgorde": 5060
  },
  {
    "dep": "Programmering",
    "rol": "Coördinator Programma B",
    "niveaus": [
      "8"
    ],
    "aliases": [
      "Head of Programme Operations (IFFR)"
    ],
    "omschrijving": "Houdt toezicht op de dagelijkse uitvoering van de operationele taken binnen het programmadomein. Draagt bij aan het opstellen van het afdelingsbeleid.",
    "bullets": [],
    "volgorde": 5070
  },
  {
    "dep": "Programmering",
    "rol": "Hoofd Programma B",
    "niveaus": [
      "8"
    ],
    "aliases": [
      "Head of Operations New Media (IDFA)",
      "Hoofd Film & Series (Cinekid)",
      "Hoofd Cinekid for Professionals (Cinekid)",
      "Hoofd Marketing & Communicatie (Cinekid)",
      "Hoofd Educatie (Cinekid)",
      "Hoofd Nieuwe Media (Cinekid)"
    ],
    "omschrijving": "Het ontwikkelen en uitvoeren van het programmabeleid. Levert een bijdrage aan het strategisch beleid van de organisatie. Is verantwoordelijk voor het aansturen en stroomlijnen van afdelingsprocessen en de dagelijkse aansturing van het team. Is medeverantwoordelijk voor de continuïteit van de organisatie als geheel.",
    "bullets": [],
    "volgorde": 5080
  },
  {
    "dep": "Programmering",
    "rol": "Hoofd Programma C",
    "niveaus": [
      "9"
    ],
    "aliases": [
      "Head of Pro (IFFR)",
      "Head of Education (IFFR)",
      "Head of HBF (IFFR)"
    ],
    "omschrijving": "Het ontwikkelen en uitvoeren van het programmabeleid. Levert een bijdrage aan het strategisch beleid van de organisatie. Is verantwoordelijk voor het aansturen en stroomlijnen van afdelingsprocessen en de dagelijkse aansturing van het team. Is medeverantwoordelijk voor de continuïteit van de organisatie als geheel.",
    "bullets": [],
    "volgorde": 5090
  },
  {
    "dep": "Directie",
    "rol": "Algemeen Directeur A",
    "niveaus": [
      "8"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6010
  },
  {
    "dep": "Directie",
    "rol": "Zakelijk Directeur A",
    "niveaus": [
      "8"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6020
  },
  {
    "dep": "Directie",
    "rol": "Artistiek Directeur A",
    "niveaus": [
      "8"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6030
  },
  {
    "dep": "Directie",
    "rol": "Algemeen Directeur B",
    "niveaus": [
      "9"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6040
  },
  {
    "dep": "Directie",
    "rol": "Zakelijk Directeur B",
    "niveaus": [
      "9"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6050
  },
  {
    "dep": "Directie",
    "rol": "Artistiek Directeur B",
    "niveaus": [
      "9"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6060
  },
  {
    "dep": "Directie",
    "rol": "Algemeen Directeur C",
    "niveaus": [
      "10"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6070
  },
  {
    "dep": "Directie",
    "rol": "Zakelijk Directeur C",
    "niveaus": [
      "10"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6080
  },
  {
    "dep": "Directie",
    "rol": "Artistiek Directeur C",
    "niveaus": [
      "10"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6090
  },
  {
    "dep": "Directie",
    "rol": "Algemeen Directeur D",
    "niveaus": [
      "11"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6100
  },
  {
    "dep": "Directie",
    "rol": "Zakelijk Directeur D",
    "niveaus": [
      "11"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6110
  },
  {
    "dep": "Directie",
    "rol": "Artistiek Directeur D",
    "niveaus": [
      "11"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6120
  },
  {
    "dep": "Directie",
    "rol": "Algemeen Directeur E",
    "niveaus": [
      "12"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6130
  },
  {
    "dep": "Directie",
    "rol": "Zakelijk Directeur E",
    "niveaus": [
      "12"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6140
  },
  {
    "dep": "Directie",
    "rol": "Artistiek Directeur E",
    "niveaus": [
      "12"
    ],
    "aliases": [],
    "omschrijving": "Het ontwikkelen en uitvoeren van het strategisch beleid, vaststellen van de programmatische-, financiële-, communicatierichtlijnen en eindverantwoordelijk voor de dagelijkse leiding. Het zowel extern als intern sturing geven aan de activiteiten van de organisatie van het filmfestival, zodat de ambities en de randvoorwaarden zijn gerealiseerd.",
    "bullets": [],
    "volgorde": 6150
  }
];

// Helpers: lookup-shortcuts per type/dep/rol, null als niet gevonden.
const lijstVoor = (type) => type === 'festival' ? rollenFestival : rollenFilmAv;

export const rolVoor = (type, dep, rol) =>
  lijstVoor(type).find(r => r.dep === dep && r.rol === rol) ?? null;

export const omschrijvingVoorRol = (type, dep, rol) =>
  rolVoor(type, dep, rol)?.omschrijving || null;

// Bullets bestaan alleen voor Film/AV (doc 6); festival levert altijd null.
export const bulletsVoorRol = (dep, rol) => {
  const r = rolVoor('film_av', dep, rol);
  return r?.bullets?.length ? r.bullets : null;
};
